var nsModuleExport = function(root,name,prototype)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			module.exports[name] = prototype;
		}
		else if (typeof define === "function" && define.amd)
		{
			define(name,[], function () {return prototype;});
		}
		else if(typeof exports === 'object')
		{
			exports[name] = prototype;
		}
		else
		{
			root[name] = prototype;
		}
	};var nsIsWeb = function(root)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			return false;
		}
		else if (typeof define === "function" && define.amd)
		{
			return false;
		}
		else if(typeof exports === 'object')
		{
			return false;
		}
		else
		{
			return true;
		}
	};if(!nsIsWeb())
		{
var nsutilRef = require('./nsUtil.min.js');
var NSUtil = nsutilRef.NSUtil;
var nscontainerbaseRef = require('./nsContainerBase.min.js');
var nsExtendPrototype = nscontainerbaseRef.nsExtendPrototype;
var NSContainerBase = nscontainerbaseRef.NSContainerBase;

		}
var NSEditor = (function()
{
	function NSEditor(component,setting) 
	{
		this.__orignalTextArea = component;
		this.__setting = setting;
		
		this.__context = window;
		
		this.editorUtil = null;
		this.__config = null;
		this.__selection = null;
		this.__toolBar = null;
		this.__execCommand = null;
		this.__stack = null;
		
		this.__divOuterContainer = null;
		this.__divTabContainer = null;
		this.__divBodyContainer = null;
		this.__divFooterContainer = null;
		this.__divFooterLeftContainer = null;
		this.__divFooterRightContainer = null;
		this.__divLineNumberContainer = null;
		this.__divTextAreaContainer = null;
		this.__compTextArea = null;
		this.__divLineNumberWrapper = null;
		this.__frameContentWindow = null;
		this.__frameContentDoc = null;
		this.__frameBody = null;
		this.__txtSourceCode = null;
		this.__iframePrint = null;
		
		this.__textAreaScrollRef = null;
		this.__textAreaResizeRef = null;
		this.__textAreaKeyUpRef = null;
		this.__textAreaKeyDownRef = null;
		
		this.__textAreaObserver = null; 
		this.__orignalTextAreaObserver = null; 
		this.__timeOutInterval = null;
		this.__lastTextAreaHeight = 0; 
		this.__lastTextAreaWidth = 0;
		this.__paddingHorizontal = 0;
		this.__browserDetail = null;
		this.__dom = null;
		this.__accessibleKeys = null;
		this.__toolBarButton = null;
		this.__objShortKey = {};
		this.__isDisabled = false;
		this.__isFrameDesignModeEnabled = false;
		this.__isSourceMode = false;
		this.__isInternalHTMLChange = false;
		this.__hasRendered = false;
		this.__renderedInterval = null;
		this.__resizeInterval = null;
		//this.__defaultContent = "<p class='nsEditorLineElement'><br></p>";
		this.__defaultContent = null;
		 //queue up the functions not called as Creation Complete called later
		this.__queueFunc = [];
		
		this.__pluginsInstances = {};
		this.__utilInstance = {};
		
		this.__init();
		
		this.base.__setBaseComponent.call(this,this.__divOuterContainer);
	};
	nsExtendPrototype(NSContainerBase,NSEditor);
	NSEditor.prototype.constructor = NSEditor;
	
	NSEditor.prototype.initializeComponent = function() 
	{
		this.base.initializeComponent.call(this);
		this.__browserDetail = this.util.getBrowser();
		this.__dom = this.util.getDomVariables();
		this.__accessibleKeys = {ctrl:{str:"ctrl",isPressed:function(event,keyCode){
			return (event.ctrlKey || event.metaKey || keyCode === 91 || keyCode === 92 || keyCode === 224);
		}},
		shift:{str:"shift",isPressed:function(event,keyCode){
			return event.shiftKey;
		}},
		alt:{str:"alt",isPressed:function(event,keyCode){
			return event.altKey;
		}},
		}
		
		this.__toolBarButton = {"bold":{html:"<i class='ns-icon ns-editor-bold' aria-hidden='true'></i>",tooltip:"Bold",tags: ["b", "strong"],css: {fontWeight: "bold"},shortKey:["ctrl+b"],command:"bold",showAsMenu: true},
				   "italic":{html:"<i class='ns-icon ns-editor-italics' aria-hidden='true'></i>",tooltip:"Italic",tags: ["i", "em"],css: {fontStyle: "italic"},shortKey: ["ctrl+i"],command:"italic",showAsMenu: true},
				   "underline":{html:"<i class='ns-icon ns-editor-underline' aria-hidden='true'></i>",tooltip:"Underline",tags: ["u"],css: {textDecoration: "underline"},shortKey: ["ctrl+u"],command:"underline",showAsMenu: true},
				   "strikeThrough":{html:"<i class='ns-icon ns-editor-strikethrough' aria-hidden='true'></i>",tooltip:"Strikethrough",tags: ["s", "strike"],css: {textDecoration: "line-through"},shortKey: ["ctrl+shift+s"],command:"strikeThrough",showAsMenu: true},
				   "justifyCenter":{html:"<i class='ns-icon ns-editor-align-center' aria-hidden='true'></i>",tooltip:"Justify Center",css: {textAlign: "center"},command:"justifyCenter"},
				   "justifyLeft":{html:"<i class='ns-icon ns-editor-align-left' aria-hidden='true'></i>",tooltip:"Justify Left",css: {textAlign: "left"},command:"justifyLeft"},
				   "justifyRight":{html:"<i class='ns-icon ns-editor-align-right' aria-hidden='true'></i>",tooltip:"Justify Right",css: {textAlign: "right"},command:"justifyRight"},
				   "justifyFull":{html:"<i class='ns-icon ns-editor-align-justify' aria-hidden='true'></i>",tooltip:"Justify Full",tags: ["s", "strike"],css: {textAlign: "justify"},command:"justifyFull"},
				   "subscript":{html:"<i class='ns-icon ns-editor-subscript' aria-hidden='true'></i>",tooltip:"Subscript",tags: ["sub"],command:"subscript",showAsMenu: true},
				   "superscript":{html:"<i class='ns-icon ns-editor-superscript' aria-hidden='true'></i>",tooltip:"Superscript",tags: ["sup"],command:"superscript",showAsMenu: true},
				  
				   "paragraph":{html:"<p>Normal</p>",tooltip:"Paragraph",command: "FormatBlock",
						   		    "arguments": (this.__browserDetail.isMSIE || this.__browserDetail.isSafari) ? "<p>" : "p",tags:["p"]},
				   "header1":{html:"<h1>Heading 1</h1>",tooltip:"Header 1",
					   				 command: "FormatBlock",
							   		 "arguments": "<h1>",tags: ["h1"]},
			   	   "header2":{html:"<h2>Heading 2</h2>",tooltip:"Header 2",
			   		   		  command: "FormatBlock",
		   				 	  "arguments": "<h2>",tags: ["h2"]},
				   "header3":{html:"<h3>Heading 3</h3>",tooltip:"Header 3",
					   		  command: "FormatBlock",
							  "arguments": "<h3>",tags: ["h3"]},
				   "header4":{html:"<h4>Heading 4</h4>",tooltip:"Header 4",
					   		  command: "FormatBlock",
			   		  		 "arguments": "<h4>",tags: ["h4"]},
				   "orderedList":{html:"<i class='ns-icon ns-editor-ordered-list' aria-hidden='true'></i>",tooltip:"Ordered List",command:"insertorderedlist",afterCommand:this.__orderedListHandler.bind(this),showAsMenu: true},
				   "unorderedList":{html:"<i class='ns-icon ns-editor-unordered-list' aria-hidden='true'></i>",tooltip:"Unordered List",command:"insertunorderedlist",afterCommand:this.__orderedListHandler.bind(this),showAsMenu: true},
				   "undo":{html:"<i class='ns-icon ns-editor-undo' aria-hidden='true'></i>",tooltip:"Undo",shortKey:["ctrl+z"],command:"undo",showAsMenu: true},
				   "redo":{html:"<i class='ns-icon ns-editor-redo' aria-hidden='true'></i>",tooltip:"Redo",shortKey:["ctrl+y"],command:"redo",showAsMenu: true},
				   "outdent":{html:"<i class='ns-icon ns-editor-decrease-indent' aria-hidden='true'></i>",tooltip:"Decrease Indent",command:"outdent",showAsMenu: true},
				   "indent":{html:"<i class='ns-icon ns-editor-increase-indent' aria-hidden='true'></i>",tooltip:"Increase Indent",command:"indent",showAsMenu: true},
				   "viewSourceCode":{html:"<i class='ns-icon ns-editor-source' aria-hidden='true'></i>",tooltip:"View Source Code",click: this.__viewSourceCodeHandler.bind(this),showAsMenu: true},
				   "clear":{html:"<i class='ns-icon ns-editor-new-doc' aria-hidden='true'></i>",tooltip:"Empty Document",click: this.__emptyDocHandler.bind(this),showAsMenu: true},
				   "print":{html:"<i class='ns-icon ns-editor-print' aria-hidden='true'></i>",tooltip:"Print",click: this.__printHandler.bind(this),showAsMenu: true},
				   "preview":{html:"<i class='ns-icon ns-editor-preview' aria-hidden='true'></i>",tooltip:"Preview",click: this.__previewHandler.bind(this),showAsMenu: true},
				   "pageBreakForPrinting":{html:"<i class='ns-icon ns-editor-bookmark' aria-hidden='true'></i>",tooltip:"Insert Page Break for Printing",click: this.__pageBreakForPrintingHandler.bind(this),showAsMenu: true},
				   "horizontalRule":{html:"<i class='ns-icon ns-editor-minus' aria-hidden='true'></i>",tooltip:"Insert Horizontal Line",command:"insertHorizontalRule",tags:["hr"],showAsMenu: true},
				   "fontFamily":{html:"<i class='ns-icon ns-editor-font' aria-hidden='true'></i>",tooltip:"Font Family",showAsMenu: true,
			   			isDropdown:true,
			   			dataSource:[{value:"Arial",html:"<span style=\"font-family: Arial\">Arial</span>",tooltip:"Arial",command:"fontName","arguments":"Arial"},
			   			            {value:"Arial Black",html:"<span style=\"font-family: Arial Black\">Arial Black</span>",tooltip:"Arial Black",command:"fontName","arguments":"Arial Black"},
			   			            {value:"Courier",html:"<span style=\"font-family: Courier\">Courier</span>",tooltip:"Courier",command:"fontName","arguments":"Courier"},
			   			            {value:"Courier New",html:"<span style=\"font-family: Courier New\">Courier New</span>",tooltip:"Courier New",command:"fontName","arguments":"Courier New"},
			   			            {value:"Comic Sans MS",html:"<span style=\"font-family: Comic Sans MS\">Comic Sans MS</span>",tooltip:"Comic Sans MS",command:"fontName","arguments":"Comic Sans MS"},
			   			            {value:"Courier",html:"<span style=\"font-family: Courier\">Courier</span>",tooltip:"Courier",command:"fontName","arguments":"Courier"},
			   			            {value:"Georgia",html:"<span style=\"font-family: Georgia\">Georgia</span>",tooltip:"Georgia",command:"fontName","arguments":"Georgia"},
			   			            {value:"Impact",html:"<span style=\"font-family: Impact\">Impact</span>",tooltip:"Impact",command:"fontName","arguments":"Impact"},
			   			            {value:"Lucida Grande",html:"<span style=\"font-family: Lucida Grande\">Lucida Grande</span>",tooltip:"Lucida Grande",command:"fontName","arguments":"Lucida Grande"},
			   			            {value:"Lucida Sans",html:"<span style=\"font-family: Lucida Sans\">Lucida Sans</span>",tooltip:"Lucida Sans",command:"fontName","arguments":"Lucida Sans"},
			   			            {value:"Serif",html:"<span style=\"font-family: Serif\">Serif</span>",tooltip:"Serif",command:"fontName","arguments":"Serif"},
			   			            {value:"Sans",html:"<span style=\"font-family: Sans\">Sans</span>",tooltip:"Sans",command:"fontName","arguments":"Sans"},
			   			            {value:"Tahoma",html:"<span style=\"font-family: Tahoma\">Tahoma</span>",tooltip:"Tahoma",command:"fontName","arguments":"Tahoma"},
			   			            {value:"Times",html:"<span style=\"font-family: Times\">Times</span>",tooltip:"Times",command:"fontName","arguments":"Times"},
			   			            {value:"Times New Roman",html:"<span style=\"font-family: Times New Roman\">Times New Roman</span>",tooltip:"Times New Roman",command:"fontName","arguments":"Times New Roman"},
			   			            {value:"Verdana",html:"<span style=\"font-family: Verdana\">Verdana</span>",tooltip:"Verdana",command:"fontName","arguments":"Verdana"}]},
				   "fontSize":{html:"<i class='ns-icon ns-editor-font-size' aria-hidden='true'></i>",tooltip:"Font Size",showAsMenu: true,
					   		    isDropdown:true,dataSource:[]},
				   "paragraphFormat":{html:"<i class='ns-icon ns-editor-paragraph' aria-hidden='true'></i>",tooltip:"Paragraph Format",showAsMenu: true,
					   			isDropdown:true,
					   			dataSource:[{value:"paragraph",htmlKey:"paragraph"},
					   			            {value:"header1",htmlKey:"header1"},
					   			            {value:"header2",htmlKey:"header2"},
					   			            {value:"header3",htmlKey:"header3"},
					   			            {value:"header4",htmlKey:"header4"}]},
 			       "align":{html:"<i class='ns-icon ns-editor-align-left' aria-hidden='true'></i>",tooltip:"Align",showAsMenu: true,
	 			    	  		isDropdown:true,
	 			    	  		dataSource:[{value:"justifyCenter",htmlKey:"justifyCenter"},
	 			    	  		            {value:"justifyLeft",htmlKey:"justifyLeft"},
	 			    	  		            {value:"justifyRight",htmlKey:"justifyRight"},
	 			    	  		            {value:"justifyFull",htmlKey:"justifyFull"}]},
	 		       "color":{html:"<i class='ns-icon ns-editor-font-color' aria-hidden='true'></i>",tooltip:"Font Color",showAsMenu: true,
	 						   isDropdown:true,dataSource:[]},
	 			   "backgroundColor":{html:"<i class='ns-icon ns-editor-background-color' aria-hidden='true'></i>",tooltip:"Background Color",showAsMenu: true,
		 					   isDropdown:true,dataSource:[]},
				 };
		//the browser doesnot allow font size > 7
		var arrFontSize = [{label:"xx-large",style:"xx-large",value:7},
		                   {label:"x-large",style:"x-large",value:6},
		                   {label:"large",style:"large",value:5},
		                   {label:"medium",style:"medium",value:4},
		                   {label:"small",style:"small",value:3},
		                   {label:"x-small",style:"x-small",value:2},
		                   {label:"xx-small",style:"xx-small",value:1}];
		var fontDataSource = [];
		for(var count = 0;count < arrFontSize.length;count++)
		{
			var item = arrFontSize[count];
			fontDataSource.push({value:item.label,html:"<span style=\"font-size: " + item.style + "\">" + item.label + "</span>",command:"fontsize","arguments":item.value});
		}
		this.__toolBarButton["fontSize"].dataSource = fontDataSource;
		var arrForeColor = [{label:"#000000",style:"#000000",value:"#000000"},
		                    {label:"#0000FF",style:"#0000FF",value:"#0000FF"},
							{label:"#30AD23",style:"#30AD23",value:"#30AD23"},
							{label:"#FF7F00",style:"#FF7F00",value:"#FF7F00"},
							{label:"#FF0000",style:"#FF0000",value:"#FF0000"},
							{label:"#FFFF00",style:"#FFFF00",value:"#FFFF00"},
							{label:"#FFFFFF",style:"#FFFFFF",value:"#FFFFFF"}];
		var foreColorDataSource = [];
		for(var count = 0;count < arrForeColor.length;count++)
		{
			var item = arrForeColor[count];
			foreColorDataSource.push({value:item.label,html:"<span style=\"color: " + item.style + "\">" + item.label + "</span>",command:"forecolor","arguments":item.value});
		}
		this.__toolBarButton["color"].dataSource = foreColorDataSource;
		var arrBackColor = [{label:"#000000",style:"#000000",value:"#000000"},
		                    {label:"#0000FF",style:"#0000FF",value:"#0000FF"},
							{label:"#30AD23",style:"#30AD23",value:"#30AD23"},
							{label:"#FF7F00",style:"#FF7F00",value:"#FF7F00"},
							{label:"#FF0000",style:"#FF0000",value:"#FF0000"},
							{label:"#FFFF00",style:"#FFFF00",value:"#FFFF00"},
							{label:"#FFFFFF",style:"#FFFFFF",value:"#FFFFFF"}];
		var backColorDataSource = [];
		for(var count = 0;count < arrBackColor.length;count++)
		{
			var item = arrBackColor[count];
			backColorDataSource.push({value:item.label,html:"<span style=\"color: " + item.style + "\">" + item.label + "</span>",command:"backcolor","arguments":item.value});
		}
		this.__toolBarButton["backgroundColor"].dataSource = backColorDataSource;
		this.__initializeModules();
		this.__initializePlugins();
		this.__setSetting();
		this.__initDefault();
		this.__initializeTools();
		this.__callInitializeInPluggin();
		this.__createComponent();
		this.attachResizeListener();
	};
	
	NSEditor.prototype.setComponentProperties = function() 
	{
		this.base.setComponentProperties.call(this);
	};
	
	NSEditor.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty)
	{
		var attributeName = attrName.toLowerCase();
		this.base.propertyChange.call(this,attrName, oldVal, newVal, setProperty);
	};
	
	NSEditor.prototype.removeComponent = function() 
	{
		this.base.removeComponent.call(this);
		this.util.removeStyleClass(this.__dom.doc.body,"nsEditorPresent");
		this.__callDestroyInPluggin();
		clearTimeout(this.__resizeInterval);
		var listenerComponent = this.__getListenerComponent();
		if(this.__textAreaScrollRef)
		{
			var element = this.__getScrollableComponent();
			this.util.removeEvent(element,"scroll",this.__textAreaScrollRef);
			this.__textAreaScrollRef = null;
		}
		if(this.__textAreaResizeRef)
		{
			this.util.removeEvent(listenerComponent,"resize",this.__textAreaResizeRef);
			this.__textAreaResizeRef = null;
		}
		if(this.__textAreaKeyUpRef)
		{
			this.util.removeEvent(listenerComponent,"keyup",this.__textAreaKeyUpRef);
			this.__textAreaKeyUpRef = null;
		}
		if(this.__textAreaKeyDownRef)
		{
			this.util.removeEvent(listenerComponent,"keydown",this.__textAreaKeyDownRef);
			this.__textAreaKeyDownRef = null;
		}
		this.__toolBar.destroy();
		if(this.__orignalTextAreaObserver)
		{
			this.__orignalTextAreaObserver.disconnect();
			this.__orignalTextAreaObserver = null;
		}
		if(this.__textAreaObserver)
		{
			this.__textAreaObserver.disconnect();
			this.__textAreaObserver = null;
		}
		if(this.__divOuterContainer)
		{
			if(this.__divOuterContainer.parentNode)
			{
				this.__divOuterContainer.parentNode.removeChild(this.__divOuterContainer);
			}
			this.__divOuterContainer = null;
		}
		if(this.__orignalTextArea)
		{
			this.util.removeStyleClass(this.__orignalTextArea,"nsEditorTextAreaHidden");
		}
		if(this.__iframePrint)
		{
			if(this.__iframePrint.parentNode)
			{
				this.__iframePrint.parentNode.removeChild(this.__iframePrint);
			}
			this.__iframePrint = null;
		}
	};
	
	NSEditor.prototype.componentResized = function(event) 
	{
		var baseMeasurement = this.__baseComponent.getBoundingClientRect();
		if(!this.__lastBaseMeasurement || this.__lastBaseMeasurement.height !== baseMeasurement.height || this.__lastBaseMeasurement.width !== baseMeasurement.width)
		{
			event = this.util.getEvent(event);
			clearTimeout(this.__resizeInterval);
			var self = this;
			this.__resizeInterval = setTimeout(function(){
				self.__dispatchInternalEvent("resize",{orignalEvent:event},{orignalEvent:event});
				self.__callResizedInPluggin([event]);
				self.base.componentResized.call(self,event);
			}, 250);
		}
	};
	
	NSEditor.prototype.registerPlugin = function(name,pluggin) 
	{
		if(name && pluggin)
		{
			if(!NSEditor.__plugins)
			{
				NSEditor.__plugins = {};
			}
			if(!NSEditor.__plugins[name])
			{
				NSEditor.__plugins[name] = pluggin;
			}
		}
	};
	
	NSEditor.prototype.registerUtil = function(name,util) 
	{
		if(name && util)
		{
			if(!NSEditor.__util)
			{
				NSEditor.__util = {};
			}
			if(!NSEditor.__util[name])
			{
				NSEditor.__util[name] = util;
			}
		}
	};
	
	//if setting["enableLineNumber"] is true then the components for line Number is created and then 
	// with toggleLineNumber function the Line Number visibility can be toggled
	NSEditor.prototype.toggleLineNumber = function() 
	{
		this.__config["enableLineNumber"] = !this.__config["enableLineNumber"];
		this.__setLineNumberVisibility(this.__config["enableLineNumber"]);
	};
	
	NSEditor.prototype.setDisabled = function(isDisabled) 
	{
		this.__isDisabled = isDisabled;
	};
	
	NSEditor.prototype.getDisabled = function() 
	{
		return this.__isDisabled;
	};
	
	NSEditor.prototype.getText = function() 
	{
		var text = this.__getTextFromTextArea();
		return (text ? text.replace(/(\r\n|\n|\r)/gm, "") : "");
	};
	
	NSEditor.prototype.setText = function(text) 
	{
		this.__setTextIntoTextArea(text);
	};
	
	NSEditor.prototype.getHtml = function() 
	{
		return this.__getHtmlFromTextArea();
	};
	
	NSEditor.prototype.setHtml = function(html) 
	{
		this.__setHtmlIntoTextArea(html);
	};
	
	NSEditor.prototype.__initDefault = function()
	{
		//item in autoSuggestTriggers will be {keyCode: 32, ctrlKey: true,shiftKey: false, preventDefault: true}
		if(!this.__config["autoSuggestTriggers"])
		{
			this.__config["autoSuggestTriggers"] = [];
		}
		if(!this.__config["mode"])
		{
			this.__config["mode"] = NSEditor.MODE_TEXTAREA;
		}
		this.__setDefaultContent();
	};
	
	NSEditor.prototype.__setDefaultContent = function()
	{
		this.__defaultContent = this.__getDefaultContent();
	};
	
	NSEditor.prototype.__getDefaultContent = function(asHtml)
	{
		asHtml = this.util.isUndefinedOrNull(asHtml) ? true : Boolean.parse(asHtml);
		var defaultElement = this.util.createElement(this.__config["enterElement"],null,"nsEditorLineElement");
		if(defaultElement)
		{
			defaultElement.innerHTML = "<br>"; 
		}
		else 
		{
			this.util.throwNSError("NSEditor","Enter a valid enterElement property");
		}
		return asHtml ? (defaultElement ? defaultElement.outerHTML : null) : defaultElement;
	};
	
	NSEditor.prototype.__setSetting = function()
	{
		if(!this.__setting)
		{
			this.__setting = {};
		}
		if(!this.__config)
		{
			this.__config = {};
		}
		var setting = this.__setting;
		if(setting)
		{
			if(setting.hasOwnProperty("context"))
			{
				this.__context = setting["context"];
			}
			this.__config = {
					enableToolBar: this.util.isUndefinedOrNull(this.__setting["enableToolBar"]) ? true : Boolean.parse(this.__setting["enableToolBar"]),
					toolBarButton: this.__setting["toolBarButton"],
					enableReadOnly: Boolean.parse(this.__setting["enableReadOnly"]),
					width: this.__setting["width"] || "auto",
				    height: this.__setting["height"] || "auto",
				    minWidth: this.__setting["minWidth"] || 200,
					minHeight: this.__setting["minHeight"] || 200,
					maxWidth: this.__setting["maxWidth"] || "100%",
					maxHeight: this.__setting["maxHeight"] || "100%",
				    theme: this.__setting["theme"] || "White",
				    //if this property is true then if bold is selected then in dom we use <b> or <strong> tag etc
				    //else we use style to do the same
				    enableTagsForProps: Boolean.parse(this.__setting["enableTagsForProps"]),
					enableSpellCheck: this.util.isUndefinedOrNull(this.__setting["enableSpellCheck"]) ? true : Boolean.parse(this.__setting["enableSpellCheck"]),
					enableTabBar: Boolean.parse(this.__setting["enableTabBar"]),
					enableLineNumber: Boolean.parse(this.__setting["enableLineNumber"]),
					enableToolBarActive: Boolean.parse(this.__setting["enableToolBarActive"]),
					enableAutoSuggest: Boolean.parse(this.__setting["enableAutoSuggest"]),
					autoSuggestTriggers: this.__setting["autoSuggestTriggers"],
					mode: this.__setting["mode"],
					placeholder: this.__setting["placeholder"],
					enterElement: this.__setting["enterElement"] || "p",// should ideally be <p> or <div> as others can create problems
					maxCharCount: this.util.isUndefinedOrNull(this.__setting["maxCharCount"]) ? null : parseInt(this.__setting["maxCharCount"]),
					charCounterType: this.__setting["charCounterType"] || "char", //char, byte, byte-html
					enableStickyToolbar: this.util.isUndefinedOrNull(this.__setting["enableStickyToolbar"]) ? true : Boolean.parse(this.__setting["enableStickyToolbar"]),
					enableStickyToolbarForMobile: this.util.isUndefinedOrNull(this.__setting["enableStickyToolbarForMobile"]) ? true : Boolean.parse(this.__setting["enableStickyToolbarForMobile"]),
					promptBoxCallback: this.__setting["promptBoxCallback"] ? this.util.getFunction(this.__setting["promptBoxCallback"]) : null,
			};
		}
		this.__callSetSettingsInPluggin();
		if(this.__config.enableToolBar && (!this.__config.toolBarButton || this.__config.toolBarButton.length == 0))
		{
			this.__config.toolBarButton = [];
			for(var key in this.__toolBarButton)
			{
				if(this.__toolBarButton[key].showAsMenu)
				{
					this.__config.toolBarButton.push(key);
				}
			}
		}
	};
	
	NSEditor.prototype.__init = function()
	{
		this.__divOuterContainer = document.createElement("div");
		this.__divOuterContainer.setAttribute("class","nsEditor nsEditorOuterContainer");
		if(this.__orignalTextArea && this.__orignalTextArea.parentNode)
		{
			if(this.__orignalTextArea.nextSibling)
			{
				this.__orignalTextArea.parentNode.insertBefore(this.__divOuterContainer, this.__orignalTextArea.nextSibling);
			}
			else
			{
				this.__orignalTextArea.parentNode.appendChild(this.__divOuterContainer);
			}
		}
		else
		{
			document.body.appendChild(this.__divOuterContainer);
		}
	};
	
	NSEditor.prototype.__initializeTools = function()
	{
	};
	
	NSEditor.prototype.__createComponent = function()
	{
		this.util.addStyleClass(this.__dom.doc.body,"nsEditorPresent");
		this.__createFixedComp();
		this.__toolBar.createToolBar();
		this.__createTabBar();
		this.__createBody();
		this.__createFooter();
		this.__createPlaceHolder();
		if(this.__isModeTextArea())
		{
			this.__initTextArea();
		}
		/*if(this.__isModeTextArea())
		{
			this.__callTextAreaFunc();
		}*/
	};
	
	NSEditor.prototype.__renderComplete = function()
	{
		var self = this;
		var callback = function()
		{
			if(self.__hasRendered)
			{
				if(self.__renderedInterval)
				{
					clearInterval(self.__renderedInterval);
					self.__renderedInterval = null;
				}
				if(self.__queueFunc && self.__queueFunc.length > 0)
				{
					for(var count = self.__queueFunc.length - 1;count > -1;count--)
					{
						self.__queueFunc[count]();
						self.__queueFunc.splice(count, 1);
					}
				}
			}
		};
		this.__renderedInterval = setInterval(callback, 300);
	};
	
	NSEditor.prototype.__callTextAreaFunc = function()
	{
		this.__callComponentsInitializedInPluggin();
		this.__setStyles();
		this.__renderComplete();
	};
	
	NSEditor.prototype.__resizeCallback = function(forciblyCalc,delayPeriod)
	{
		var self = this;
		var callback = function()
		{
			self.__setBodyStyle(forciblyCalc);
			self.__resizeIframe();
			self.__drawLineNumbers(1);
		};
		if(!delayPeriod)
		{
			delayPeriod = 0;
		}
		setTimeout(callback,delayPeriod);
	};
	
	NSEditor.prototype.__setStyles = function(delayPeriod)
	{
		var self = this;
		var callback = function()
		{
			var css = {};
			css.minWidth = self.__config.minWidth;
			css.minHeight = self.__config.minHeight;
			var maxWidth = self.__config.maxWidth;
			css.maxWidth = maxWidth;
			self.util.css(self.__divOuterContainer,css);
			self.__width(self.__config.width);
			self.__height(self.__config.height);
			
			//delay while rendering as the toolBox is taking time to get its height
			self.__setBodyStyle(false,false);
		};
		if(!delayPeriod)
		{
			delayPeriod = 0;
		}
		setTimeout(callback,delayPeriod);
	};
	
	NSEditor.prototype.__setBodyStyle = function(forciblyCalc,isDelay)
	{
		var self = this;
		var callback = function()
		{
			var setHeight = function(value)
			{
				var arrCon = [self.__divLineNumberContainer,self.__divTextAreaContainer,self.__compTextArea];//self.__getIFrameBody()
				for(var count = 0;count < arrCon.length;count++)
				{
					var con = arrCon[count];
					if(con)
					{
						self.util.css(con,"height",value);
					}
				}
			};
			forciblyCalc = Boolean.parse(forciblyCalc);
			var height = "auto";
			if(self.__config.height == "auto" && !forciblyCalc)
			{
				setHeight("auto");
			}
			else
			{
				var totalHeight = self.__divOuterContainer.offsetHeight;
				var nonEditorHeight = self.__getNonEditorHeight();
				height = totalHeight - nonEditorHeight;
				if(forciblyCalc)
				{
					setHeight("");
				}
			}
			self.__heightBody(height);
			self.__setBodyMinHeight();
		};
		if(isDelay)
		{
			setTimeout(callback,100);
		}
		else
		{
			callback();
		}
	};
	
	NSEditor.prototype.__setBodyMinHeight = function()
	{
		var nonEditorHeight = this.__getNonEditorHeight();
		var minHeight = this.__config.minHeight - nonEditorHeight;
		this.util.css(this.__divBodyContainer,"minHeight",minHeight);
		var arrCon = [this.__divLineNumberContainer,this.__divTextAreaContainer,this.__compTextArea,this.__getIFrameBody()];//
		for(var count = 0;count < arrCon.length;count++)
		{
			var con = arrCon[count];
			if(con)
			{
				this.util.css(con,"minHeight",minHeight - 2);
			}
		}
		this.__hasRendered = true;
	};
	
	NSEditor.prototype.__getNonEditorHeight = function()
	{
		var totalHeight = 0;
		if(this.__toolBar.__divToolBarContainer)
		{
			totalHeight += this.__toolBar.__divToolBarContainer.offsetHeight;
		}
		if(this.__divTabContainer)
		{
			totalHeight += this.__divTabContainer.offsetHeight;
		}
		if(this.__divFooterContainer)
		{
			totalHeight += this.__divFooterContainer.offsetHeight;
		}
		return totalHeight;
	};
	
	
	
	NSEditor.prototype.__createTabBar = function()
	{
		this.__divTabContainer = this.util.createDiv(this.getID() + "tabcontainer","nsEditorTabContainer");
		this.__divOuterContainer.appendChild(this.__divTabContainer);
		if(this.__config["enableTabBar"])
		{
			//this.__createToolBarComponents();
		}
		else
		{
			this.__handleVisibilityOfComponent(this.__divTabContainer,"enableTabBar");
		}
	};
	
	NSEditor.prototype.__createBody = function()
	{
		this.__divBodyContainer = this.util.createDiv(this.getID() + "bodycontainer","nsEditorBodyContainer");
		this.__divLineNumberContainer = this.util.createDiv(this.getID() + "linenumbercontainer","nsEditorLineNumberContainer");
		this.__divTextAreaContainer = this.util.createDiv(this.getID() + "textareacontainer","nsEditorTextAreaContainer");
		this.__divBodyContainer.appendChild(this.__divLineNumberContainer);
		this.__divBodyContainer.appendChild(this.__divTextAreaContainer);
		this.__divOuterContainer.appendChild(this.__divBodyContainer);
		this.__compTextArea = this.__createTextArea();
		this.__divTextAreaContainer.appendChild(this.__compTextArea);
	};
	
	NSEditor.prototype.__createTextArea = function()
	{
		var divTextArea = null;
		var content = "";
		if(this.__isModeTextArea())
		{
			//do not add class here as it will get overriden from if orignalTextArea has class
			divTextArea = this.util.createDiv(this.getID() + "textArea",null);
			if(!this.__config.enableReadOnly)
			{
				divTextArea.setAttribute("contenteditable",true);
				divTextArea.setAttribute("spellcheck",this.__config.enableSpellCheck);
			}
			if(this.__orignalTextArea)
			{
				if(this.__orignalTextArea.value.length > 0)
				{
					content = this.__orignalTextArea.value;
				}
				var arrAttributes = ["tabIndex"];
				var arrNewAttributes = ["tabIndex"];
				for(var count = 0;count < arrAttributes.length;count++)
				{
					if(this.__orignalTextArea.getAttribute(arrAttributes[count]))
					{
						divTextArea.setAttribute(arrNewAttributes[count],this.__orignalTextArea.getAttribute(arrAttributes[count]));
					}
				}
			}
			else if(this.__config.defaultValue && this.__config.defaultValue.length > 0)
			{
				divTextArea.appendChild(this.__dom.doc.createTextNode(this.__config.defaultValue));
			}
			this.util.addStyleClass(divTextArea,"nsEditorTextArea");
		}
		else
		{
			divTextArea = this.util.createElement("iframe",this.getID() + "textArea","nsEditorTextAreaIFrame");
			if(this.__context.location.protocol === "https:")
			{
				divTextArea.setAttribute("src","about:blank");
			}
			divTextArea.setAttribute("frameborder","0");
			divTextArea.setAttribute("allowtransparency","true");
			divTextArea.setAttribute("tabindex","-1");
			if(this.__orignalTextArea)
			{
				/*if(this.__orignalTextArea.getAttribute("tabindex"))
				{
					divTextArea.setAttribute("tabindex",this.__orignalTextArea.getAttribute("tabindex"));
				}*/
				if(this.__orignalTextArea.value.length > 0)
				{
					content = this.__orignalTextArea.value;
				}
			}
			var styleHtml = "html\r\n" + 
					"		{\r\n" + 
					"			margin:0px;\r\n" + 
					"			height:auto;\r\n" + 
					"		}\r\n" + 
					"		.nsEditorBody\r\n" + 
					"		{\r\n" + 
					"			height:auto;\r\n" + 
					"			background:transparent;\r\n" + 
					"			color:#000000;\r\n" + 
					"			position:relative;\r\n" + 
					"			z-index: 2;\r\n" +
					"			-webkit-user-select:auto;\r\n" + 
					"			margin:0px;\r\n" + 
					"			min-height:50px;\r\n" + 
					"			padding: 5px;\r\n" +
					"			overflow: auto;\r\n" +
					"		}\r\n" + 
					"		.nsEditorBody:after\r\n" + 
					"		{\r\n" + 
					"			content:\'\';\r\n" + 
					"			display:block;\r\n" + 
					"			clear:both;\r\n" + 
					"		}\r\n" + 
					"		.nsEditorBody::-moz-selection\r\n" + 
					"		{\r\n" + 
					"			background:#b5d6fd;\r\n" + 
					"			color:#000;\r\n" + 
					"		}\r\n" + 
					"		.nsEditorBody::selection\r\n" + 
					"		{\r\n" + 
					"			background:#b5d6fd;\r\n" + 
					"			color:#000;\r\n" + 
					"		}\r\n" + 
					"		.nsEditorBody.nsEditorBodyWithLineNumber\r\n" + 
					"		{\r\n" + 
					"			padding: 0px;\r\n" +
					"			padding-top: 5px;\r\n" + 
					"			padding-right: 5px;\r\n" + 			
					"		}\r\n" + 
					"		.nsEditorBody.nsEditorBodyWithLineNumber .nsEditorLineElement\r\n" + 
					"		{\r\n" + 
					"			margin:0;\r\n" + 
					"			font-size: 12px;\r\n" +
					"			line-height: 15px !important;\r\n" +
					"		}\r\n" + 
					"		.nsEditorPageBreak\r\n" + 
					"		{\r\n" + 
					"			clear: both !important;\r\n" + 
					"    		width: 100% !important;\r\n" + 
					"    		border-top: #999 1px dotted !important;\r\n" + 
					"    		border-bottom: #999 1px dotted !important;\r\n" + 
					"    		padding: 0 !important;\r\n" + 
					"    		height: 7px !important;\r\n" + 
					"    		cursor: default !important;\r\n" + 
					"		}";
			var arrStyle = this.__callAddStyleIFrameInPluggin(style);
			if(arrStyle && arrStyle.length > 0)
			{
				for(var count = 0;count < arrStyle.length;count++)
				{
					styleHtml += arrStyle[count].value;
				}
			}
			var arrStyle = this.__dom.doc.querySelectorAll("style");
			if(arrStyle && arrStyle.length > 0)
			{
				for(var count= 0;count < arrStyle.length; count++)
				{
					var style = arrStyle[count].cloneNode(true);
					styleHtml += "\n" + style.outerHTML;
				}
			}
			var arrLink = this.__dom.doc.querySelectorAll("link");
			if(arrLink && arrLink.length > 0)
			{
				for(var count= 0;count < arrLink.length; count++)
				{
					var link = this.__dom.doc.createElement("link");
					link.rel = arrLink[count].rel;
					link.href = arrLink[count].href;
					link.type = "text/css";
					link.media = "all";
					styleHtml += "\n" + link.outerHTML;
				}
			}
			var html = "<html><head><style>" + styleHtml + "</style></head><body class=\"nsEditorBody" + (this.__config["enableLineNumber"] ? " nsEditorBodyWithLineNumber" : "") + "\" contenteditable=\" " + !this.__config.enableReadOnly + "\" aria-disabled=\"false\" spellcheck=\"" + this.__config.enableSpellCheck +"\" dir=\"auto\">" + content + "</body></html>";
			this.__enableIFrameDesignMode(divTextArea,html);
		}
		if(!content && this.__config.defaultValue && this.__config.defaultValue.length > 0)
		{
			content = this.__config.defaultValue;
		}
		//for Mozilla showing cursor
		if(content)
		{
			content = this.__getWrappedContent(content);
		}
		else
		{
			content = this.__defaultContent;
		}
		this.__config.defaultValue = content;
		if(this.__orignalTextArea)
		{
			this.util.addStyleClass(this.__orignalTextArea,"nsEditorTextAreaHidden");
			if(!this.__config["placeholder"] && this.__orignalTextArea.getAttribute("placeholder"))
			{
				this.__config["placeholder"] = this.__orignalTextArea.getAttribute("placeholder");
			}
		}
		this.util.addStyleClass(divTextArea,"nsEditorTextAreaGeneric");
		
		return divTextArea;
	};
	
	NSEditor.prototype.__initTextArea = function()
	{
		var listenerComponent = this.__getListenerComponent();
		var clickListener = this.__isModeTextArea() ? this.__compTextArea : this.__frameContentDoc;
		var body = this.__isModeTextArea() ? this.__compTextArea : this.__getIFrameBody();
		var self = this;
		
		var genericListerener = function(event)
		{
			event = self.util.getEvent(event);
			if(event.type == "blur")
			{
				if(!self.getDisabled())
				{
					self.__selection.saveSelection();
				}
			}
			var element = event.target;
			var parentElement = element.parentNode;
			var item = {orignalEvent:event,element: element,parentElement: parentElement};
			self.__dispatchInternalEvent(event.type,item,item);
		};
		
		var eventListener = function(event){
			event = self.util.getEvent(event);
			//var target = self.util.getTarget(event);
			self.__selection.saveSelection();
			//self.__updateToolbar(target);
		};
		var pasteListener = function(event)
		{
			event = self.util.getEvent(event);
			switch(event.type)
			{
				case "beforepaste":
					self.__dispatchInternalEvent("beforepaste",{orignalEvent:event},{orignalEvent:event});
					break;
				case "paste":
					var content = self.__getPastedHTML(event);
					if(!content)
					{
						content = {};
					}
					content.orignalEvent = event;
					self.__dispatchInternalEvent("paste",content,content);
					break;
			}
		};
		
		if(this.__config.defaultValue)
		{
			body.innerHTML = this.__config.defaultValue;
		}
		var nonClickEvents = "keydown keyup keypress mousedown mouseup mousemove copy cut dragstart drop dragover touchstart touchend touchmove focus blur";
		var clickEvents = "selectionchange selectionstart dblclick click paste";
		this.util.addEvent(listenerComponent,nonClickEvents,genericListerener);
		this.util.addEvent(clickListener,clickEvents,genericListerener);
		//this.util.addEvent(listenerComponent,"keydown",this.__textAreaKeyDownHandler.bind(this));
		//this.util.addEvent(listenerComponent,"keyup mouseup mouseout focusout",eventListener);
		this.util.addEvent(clickListener,"beforepaste paste",pasteListener);
		this.util.addEvent(clickListener,"click",this.__textAreaClickHandler.bind(this));
		/*if(!this.__isModeTextArea())
		{
			this.__callTextAreaFunc();
		}*/
		this.__createLineNumberComponents();
		this.__callTextAreaFunc();
		this.__dispatchInternalEvent("textAreaInitialized");
		this.__textAreaObserver = new MutationObserver(this.__textAreaChangeHandler.bind(this));
		var observerConfig = {attributes:false,childList:true,characterData:true,subtree:true};
		this.__textAreaObserver.observe(body, observerConfig);
	};
	
	NSEditor.prototype.__enableIFrameDesignMode = function(iframe,html)
	{
		if(iframe && !this.__isFrameDesignModeEnabled)
		{
			this.__frameContentWindow = this.__getIFrameContentWindow(iframe);
			try 
			{
				this.__frameContentDoc = this.__frameContentWindow.document;
				this.__frameContentDoc.open();
				this.__frameContentDoc.write(html);
				this.__frameContentDoc.close();
            } 
			catch (error) 
			{
                //console.debug(error);
            }
            if (this.__dom.doc.contentEditable) 
			{
            	this.__frameContentDoc.designMode = "On";
            	this.__isFrameDesignModeEnabled = true;
            } 
			else if (this.__dom.doc.designMode !== null) 
			{
                try 
				{
                	this.__frameContentDoc.designMode = "on";
                	this.__isFrameDesignModeEnabled = true;
                } 
				catch (error) 
				{
                    //console.debug(error);
                }
            }
            if(this.__isFrameDesignModeEnabled)
            {
            	this.__setIframeStyle();
            	this.__initTextArea();
            	this.__dispatchInternalEvent("iframeInitialized");
            }
            var self = this;
            this.__timeOutInterval = setTimeout(function () 
		    {
            	self.__timeOutInterval = null;
            	self.__enableIFrameDesignMode.call(self,iframe,html);
		    }, 500);
		}
		else
		{
			clearTimeout(this.__timeOutInterval);
			this.__timeOutInterval = null;
		}
	};
	
	NSEditor.prototype.__setIframeStyle = function()
	{
		if(this.__config.height == "auto")
		{
			var doc = this.__getDocument();
			if(doc.documentElement)
			{
				doc.documentElement.style.overflowY = "hidden";
			}
			//this.util.addEvent(doc,"readystatechange DOMContentLoaded",this.__resizeIframe.bind(this));
			this.__listenInternalEvent("change", this.__resizeIframe.bind(this));
		}
	};
	
	NSEditor.prototype.__resizeIframe = function()
	{
		if(!this.__isModeTextArea() && this.__config.height == "auto")
		{
			var iframe = this.__compTextArea;
			var body = this.__getIFrameBody();
			if(iframe && body)
			{
				this.util.css(iframe,"height",body.offsetHeight);
			}
		}
	};
	
	NSEditor.prototype.__createLineNumberComponents = function()
	{
		var listenerComponent = this.__getListenerComponent();
		if(this.__config["enableLineNumber"])
		{
			this.util.addStyleClass(this.__divOuterContainer,"nsEditorWithLineNumber");
			//var textWidth = this.__width();
			//var baseMeasurement = this.__compTextArea.getBoundingClientRect();
			this.__divLineNumberWrapper = this.util.createDiv(this.getID() + "linenumberwrapper","nsEditorLineNumberWrapper");
			this.__divLineNumberContainer.appendChild(this.__divLineNumberWrapper);
			this.__queueFunc.splice(0, 0, this.__drawLineNumbers.bind(this,1));
			this.__paddingHorizontal = parseInt(this.util.getStyleValue(this.__divOuterContainer,"border-left-width",false)) +
									parseInt(this.util.getStyleValue(this.__divOuterContainer,"border-right-width",false)) + 
									parseInt(this.util.getStyleValue(this.__divOuterContainer,"padding-left",false)) + 
									parseInt(this.util.getStyleValue(this.__divOuterContainer,"padding-right",false));
			//this.__setWidth(textWidth - this.__paddingHorizontal);
			//this.__lastTextAreaHeight = this.__compTextArea.offsetHeight; 
			//this.__lastTextAreaWidth = this.__compTextArea.offsetWidth;
			if(!this.__textAreaScrollRef)
			{
				this.__textAreaScrollRef = this.__textAreaScrollHandler.bind(this);
				var element = this.__getScrollableComponent();
				this.util.addEvent(element,"scroll",this.__textAreaScrollRef);
			}
			if(!this.__textAreaResizeRef)
			{
				this.__textAreaResizeRef = this.__textAreaResizeHandler.bind(this);
				this.util.addEvent(listenerComponent,"resize",this.__textAreaResizeRef);
			}
		}
		else
		{
			if(this.__divLineNumberContainer && this.__divLineNumberContainer.parentElement)
			{
				this.__divLineNumberContainer.parentElement.removeChild(this.__divLineNumberContainer);
				this.__divLineNumberContainer = null;
			}
			this.util.removeStyleClass(this.__divOuterContainer,"nsEditorWithLineNumber");
		}
		if(this.__config["enableAutoSuggest"])
		{
			if(!this.__textAreaKeyUpRef)
			{
				this.__textAreaKeyUpRef = this.__textAreaKeyUpHandler.bind(this);
				this.util.addEvent(listenerComponent,"keyup",this.__textAreaKeyUpRef);
			}
			if(!this.__textAreaKeyDownRef)
			{
				this.__textAreaKeyDownRef = this.__textAreaKeyDownHandler.bind(this);
				this.util.addEvent(listenerComponent,"keydown",this.__textAreaKeyDownRef);
			}
		}
		//observer to watch if orignalTextArea has some style changed
		if(!this.__orignalTextAreaObserver && this.__orignalTextArea)
		{
			this.__orignalTextAreaObserver = new MutationObserver(this.__orignalTextAreaStyleChangeHandler.bind(this));
			this.__orignalTextAreaObserver.observe(this.__orignalTextArea, {attributes:true,attributeFilter:["style"]});
		}
		this.__setLineNumberVisibility(this.__config["enableLineNumber"]);
	};
	
	NSEditor.prototype.__createFooter = function()
	{
		this.__divFooterContainer = this.util.createDiv(this.getID() + "footercontainer","nsEditorFooterContainer");
		this.__divFooterLeftContainer = this.util.createDiv(this.getID() + "footerleftcontainer","nsEditorFooterLeftContainer");
		this.__divFooterContainer.appendChild(this.__divFooterLeftContainer);
		this.__divFooterRightContainer = this.util.createDiv(this.getID() + "footerrightcontainer","nsEditorFooterRightContainer");
		this.__divFooterContainer.appendChild(this.__divFooterRightContainer);
		this.__divOuterContainer.appendChild(this.__divFooterContainer);
	};
	
	NSEditor.prototype.__textAreaKeyDownHandler = function(event)
	{
		event = this.util.getEvent(event);
		if(!this.getDisabled())
		{
			if (event.keyCode === this.util.KEYCODE.BACKSPACE) 
			{ 
				if (this.__isTextAreaBlank()) 
				{ 
					event.stopPropagation(); // prevent remove single empty tag
					event.preventDefault();
				}
			}
			else
			{
				var keyCode = event.keyCode;
				var arrAccessKey = [];
				var strKey = "";
				for(var key in this.__accessibleKeys) 
				{
					if(this.__accessibleKeys[key].isPressed(event,keyCode))
					{
						arrAccessKey.push(this.__accessibleKeys[key]);
						strKey += "+" + this.__accessibleKeys[key].str;
					}
				}
				if(arrAccessKey.length)
				{
					if(strKey && strKey.length > 1)
					{
						strKey = strKey.substring(1);
					}
					strKey += "+" + String.fromCharCode(keyCode);
					var keyItem = this.__objShortKey[strKey.toLowerCase()];
					if(keyItem)
					{
						this.__toolBar.__toolBarButtonClickHandler(keyItem.item,keyItem.key,event);
						this.editorUtil.stopEvent(event);
					}
				}
			}
		}
	};
	
	NSEditor.prototype.__textAreaKeyUpHandler = function(event)
	{
		 /*if (decls.isVisible())
         {
             decls.setFilter(getFilterText());
         }*/
	};
	
	NSEditor.prototype.__textAreaClickHandler = function(event)
	{
		var target = this.util.getTarget(event);
		this.__toolBar.updateToolbar(target);
	};
	
	NSEditor.prototype.__textAreaScrollHandler = function(event)
	{
		if(!this.__timeOutInterval)
		{
			var lineNumberHeight = 15;
			var self = this;
			this.__timeOutInterval = setTimeout( function() 
			{
				var listenerComponent = self.__getScrollComponent();
				var scrollTop = listenerComponent.scrollTop;
				var firstLine = Math.floor((scrollTop / lineNumberHeight) + 1);
				var remainingScroll = (scrollTop / lineNumberHeight) % 1;

				self.__drawLineNumbers(firstLine);
				self.__divLineNumberWrapper.style.marginTop = (-1 * (remainingScroll * lineNumberHeight)) + "px";
				self.__timeOutInterval = null;
			}, 150);
		}
	};
	
	NSEditor.prototype.__textAreaResizeHandler = function(event)
	{
		
	};
	
	NSEditor.prototype.__orignalTextAreaStyleChangeHandler = function(arrMutation)
	{
		for(var count = 0;count < arrMutation.length;count++)
		{
			var mutation = arrMutation[count];
			if (mutation.type == "attributes") 
	        {
	        	
	        }
			
		}
	};
	
	NSEditor.prototype.__textAreaChangeHandler= function(arrMutation)
	{
		if(!this.__isInternalHTMLChange)
		{
			//this.__setDefaultTag();
			this.__dispatchInternalEvent("change");
			//this.__resizeIframe();
		}
		for(var count = 0;count < arrMutation.length;count++)
		{
			var mutation = arrMutation[count];
			//if child is added
			if (mutation.type === 'childList') 
			{
				//if height is auto
				if(this.__config.height == "auto" && this.__divLineNumberContainer)
				{
					this.__drawLineNumbers(1);
				}
	        }
		}
	};
	
	NSEditor.prototype.__drawLineNumbers = function(fromLine)
	{
		if(this.__divLineNumberWrapper)
		{
			this.util.removeAllChildren(this.__divLineNumberWrapper);
			this.arrLinesElement = [];
			var comp = this.__getScrollComponent();
			var measurement = comp.getBoundingClientRect();
			var containerHeight = measurement.height;
			while((this.__divLineNumberWrapper.offsetHeight - containerHeight) <= 0)
			{
				var divLineNumber = this.util.createDiv(this.getID() + "linenumber","nsEditorLineNumber");
				divLineNumber.appendChild(this.__dom.doc.createTextNode(fromLine));
				this.__divLineNumberWrapper.appendChild(divLineNumber);
				this.arrLinesElement.push(divLineNumber);
				fromLine++;
			}
		}
		return fromLine;
	};
	
	NSEditor.prototype.__setLineNumberVisibility = function(isVisible) 
	{
		if(this.__setting["enableLineNumber"])
		{
			this.__config["enableLineNumber"] = isVisible;
			this.__handleVisibilityOfComponent(this.__divLineNumberContainer,"enableLineNumber");
			this.__dispatchInternalEvent("lineNumberVisibilityChanged",{isVisible: isVisible},{isVisible: isVisible});
		}
	};
	
	NSEditor.prototype.__handleVisibilityOfComponent = function(component,property) 
	{
		this.__setting[property] ? this.util.removeStyleClass(component,"nsEditorComponentHidden") : this.util.addStyleClass(component,"nsEditorComponentHidden");
	};
	
	NSEditor.prototype.__handleKeySpecialKeys = function(event) 
	{
		// escape, left, right
        if (event.keyCode === 27 || event.keyCode === 37 || event.keyCode === 39)
        {
            setVisible(false);
        }
        // up
        else if (event.keyCode === 38)
        {
            moveSelected(-1);
            event.preventDefault();
            event.stopPropagation();
        }
        // down
        else if (event.keyCode === 40)
        {
            moveSelected(1);
            event.preventDefault();
            event.stopPropagation();
        }
        // page up 
        else if (event.keyCode === 33)
        {
            moveSelected(-5);
            event.preventDefault();
        }
        // page down
        else if (event.keyCode === 34)
        {
            moveSelected(5);
            event.preventDefault();
        }
	};
	
	NSEditor.prototype.__getTextFromTextArea = function() 
	{
		var text = null;
		if(this.__isModeTextArea())
		{
			text  = this.__compTextArea.textContent || this.__compTextArea.innerText;
		}
		else
		{
			text = this.__getIFrameText();
		}
		return text;
	};
	
	NSEditor.prototype.__getHtmlFromTextArea = function() 
	{
		var text = null;
		if(this.__isModeTextArea())
		{
			text  = this.__compTextArea.innerHTML;
		}
		else
		{
			text = this.__getIFrameContent();
		}
		if(text)
		{
			text = text.replace(/^(<p[^>]*>(&nbsp;|&#160;|\s|\u00a0|<br \/>|)<\/p>[\r\n]*|<br \/>[\r\n]*)$/, "");
		}
		return text;
	};
	
	NSEditor.prototype.__setTextIntoTextArea = function(text) 
	{
		if(this.__isModeTextArea())
		{
			this.__compTextArea.innerText = text;
		}
		else
		{
			this.__setIFrameText(text);
		}
		//this.__dispatchInternalEvent("change");
	};
	
	NSEditor.prototype.__setHtmlIntoTextArea = function(html) 
	{
		if(this.__isModeTextArea())
		{
			this.__compTextArea.innerHTML = html;
		}
		else
		{
			this.__setIFrameContent(html);
		}
		//this.__dispatchInternalEvent("change");
	};
	
	//functions related to IFrame
	NSEditor.prototype.__getIFrameText = function() 
	{
		var iframeBody = this.__getIFrameBody();
	    return (iframeBody ? (iframeBody.textContent || iframeBody.innerText) : null);
	};
	
	NSEditor.prototype.__getIFrameContent = function() 
	{
		var iframeBody = this.__getIFrameBody();
	    return (iframeBody ? iframeBody.innerHTML : null);
	};
	
	NSEditor.prototype.__setIFrameText = function(text) 
	{
		var iframeBody = this.__getIFrameBody();
	    iframeBody ? iframeBody.innerText = text : null;
	};
	
	NSEditor.prototype.__setIFrameContent = function(html) 
	{
		var iframeBody = this.__getIFrameBody();
	    iframeBody ? iframeBody.innerHTML = html : null;
	};
	
	NSEditor.prototype.__getIFrameContentWindow = function(iframe) 
	{
		if(this.__isModeTextArea())
		{
			return null;
		}
		var contentWindow = null;
		if (iframe.contentWindow)
		{
			contentWindow = iframe.contentWindow;
		}
		else if(iframe.contentDocument)
		{
			if(iframe.contentDocument.defaultView)
			{
				contentWindow = iframe.contentDocument.defaultView;
			}
			else if (iframe.contentDocument.document)
	        {
	        	contentWindow = iframe.contentDocument.document;
	        }
	        else
	        {
	        	contentWindow = iframe.contentDocument;
	        }
		}
		return contentWindow;
	};
	
	NSEditor.prototype.__getIFrameBody = function() 
	{
		if(this.__isModeTextArea())
		{
			return null;
		}
		//if(!this.__frameBody)
		//{
			this.__frameBody = this.__getIFrameDocument().getElementsByTagName("body")[0];
		//}
	    return this.__frameBody;
	};
	
	NSEditor.prototype.__getIFrameDocument = function()  
	{
	    return this.__isModeTextArea() ? null : (this.__compTextArea.contentDocument || this.__compTextArea.contentWindow.document);
	};
	
	NSEditor.prototype.__disableStyleWithCSS = function() 
	{
		if (this.__browserDetail.isFirefox) 
		{
			//disable style while inserting in firefox design Mode
			try 
			{
				this.__frameContentDoc.execCommand("styleWithCSS", false, false);
			} 
			catch (error) 
			{
				try 
				{
					this.__frameContentDoc.execCommand("useCSS", false, true);
				} 
				catch (error2) 
				{
				}
			}
		}
	};
	//end of functions related to IFrame
	NSEditor.prototype.__executeCommand = function(commandName,config,key) 
	{
		if(!config)
		{
			config = {};
		}
		var command = config.command || commandName;
		var arguments = config["arguments"];
		if(config.execCommand)
		{
			config.execCommand.apply(this);
		}
		else 
		{
			var doc = this.__dom.doc;
			if(!this.__isModeTextArea())
			{
				doc = this.__frameContentDoc;
				this.__disableStyleWithCSS();
			}
			// in Firefox untrusted JavaScript is not allowed to access the clipboard
			try 
			{
				this.__dispatchInternalEvent("beforeExecCommand",config,config);
				if(config.beforeCommand)
				{
					config.beforeCommand(config,key);
				}
				this.__selection.restoreSelection();
				this.__selection.setFocus();
				this.__execCommand.execute(command, false, arguments);
				//doc.execCommand(command, false, arguments);
				this.__selection.saveSelection();
				if(config.afterCommand)
				{
					config.afterCommand(config,key);
				}
				this.__dispatchInternalEvent("afterExecCommand",config,config);
			} 
			catch (error) 
			{
				console.error(error);
			}
		}
		//this.__dispatchInternalEvent("change");
	};
	
	NSEditor.prototype.__orderedListHandler = function(item,key,event)
	{
		/*var element = this.__selection.getElementUnderCursor();
		var textArea = this.__getTextArea();
		var parent = this.util.findParentByCallback(element, function(node) 
		{ 
			return node && /^UL|OL$/i.test(node.nodeName);
		}, textArea);
        if (parent && this.util.isElementOfType(parent.parentNode,"p")) 
        {
            var selection = this.__selection.saveSelection();
            this.util.insertElementParentsParent(parent.parentNode);
            for(var count = 0;count < parent.childNodes.length;count++)
            {
            	var li = parent.childNodes[count];
            	if (this.util.isElementOfType(li.lastChild,"br")) 
            	{
            		this.editorUtil.removeNode(li.lastChild);
                }
            }
            this.__selection.restoreSelection(selection);
        }*/
        //editor.setEditorValue();
	};
	
	NSEditor.prototype.__viewSourceCodeHandler = function(item,key,event)
	{
		if(!this.__txtSourceCode)
		{
			this.__txtSourceCode = this.util.createElement("textarea",this.getID() + "sourcetextArea","nsEditorSourceTextArea");
			//this.__txtSourceCode.setAttribute("disabled",true);
			this.__divTextAreaContainer.appendChild(this.__txtSourceCode);
		}
		//view source is shown then show editor
		if (this.__isSourceMode)
		{
			this.util.addStyleClass(this.__txtSourceCode,"nsEditorTextAreaHidden");
			this.util.removeStyleClass(this.__compTextArea,"nsEditorTextAreaHidden");
			this.setHtml(this.__txtSourceCode.value);
			//processItems(false);
		}
		//view source is not shown then show viewsource text area
		else
		{
			var html = this.__getHtmlFromTextArea();
			this.util.removeStyleClass(this.__txtSourceCode,"nsEditorTextAreaHidden");
			this.util.addStyleClass(this.__compTextArea,"nsEditorTextAreaHidden");
			this.__txtSourceCode.value = html;
			//processItems(true);
		}
		this.__isSourceMode = !this.__isSourceMode;
		this.__placeHolderToggleRef();
		this.__dispatchInternalEvent("viewSourceChanged",{isSourceMode: this.__isSourceMode,item: item,key: key}, {isSourceMode: this.__isSourceMode,item: item,key: key});
	};
	
	NSEditor.prototype.__emptyDocHandler = function(item,key,event)
	{
		var body = this.__getTextArea();
		body.innerHTML = this.__config.defaultValue;
	};
	
	NSEditor.prototype.__printHandler = function(item,key,event)
	{
		if(this.__isModeTextArea())
		{
			if(!this.__iframePrint)
			{
				this.__iframePrint = this.util.createElement("iframe",this.getID() + "EditorPrintFrame","nsEditorPrint");
				this.__iframePrint.name = this.getID() + "EditorPrintFrame";
				this.__dom.doc.body.appendChild(this.__iframePrint);
			}
			var content =  this.__getHtmlFromTextArea();
			var html = "<!DOCTYPE html><html><head><title>" + this.__dom.doc.title + "</title>";
			var arrStyle = this.__dom.doc.querySelectorAll("style");
			if(arrStyle && arrStyle.length > 0)
			{
				for(var count= 0;count < arrStyle.length; count++)
				{
					var style = arrStyle[count].cloneNode(true);
					html += "\n" + style.outerHTML;
				}
			}
			var arrLink = this.__dom.doc.querySelectorAll("link");
			if(arrLink && arrLink.length > 0)
			{
				for(var count= 0;count < arrLink.length; count++)
				{
					var link = this.__dom.doc.createElement("link");
					link.rel = arrLink[count].rel;
					link.href = arrLink[count].href;
					link.type = "text/css";
					link.media = "all";
					html += "\n" + link.outerHTML;
				}
			}
			html +="</head><body class=\"nsEditorBody\" dir=\"auto\"><div>" + content + "</div></body></html>";
			var self = this;
			this.__iframePrint.onload = function() 
			{
                setTimeout(function() 
                {
                	var frame = self.__context.frames[self.getID() + "EditorPrintFrame"];
                	frame.focus();
                	frame.print();
                	self.__context.focus();
                }, 0);
            };
            var contentWindow = this.__iframePrint.contentWindow;
            contentWindow.document.open();
            contentWindow.document.write(html);
            contentWindow.document.close();
		}
		else
		{
			this.__executeCommand("print",item,"print");
		}
	};
	
	NSEditor.prototype.__previewHandler = function(item,key,event)
	{
		var content =  this.__getHtmlFromTextArea();
		content = "<div class='" + this.__getTextArea().getAttribute("class") + "'>" + content + "</div>";
		var objWindow = this.__context.open("","_blank");
		if(!objWindow)
		{
			throw this.util.throwNSError("NSEditor","Preview window was not opened.Please deactivate PopUp Blocker for this application");
		}
		objWindow.mimeType = "text/html";
		var width = this.__getTextArea().offsetWidth + "px !important";
		var bodyCssClass =  this.__divOuterContainer.getAttribute("class") + " nsEditorBody";
		if(this.__isModeTextArea())
		{
			var html = "";
            var arrStyle = this.__dom.doc.querySelectorAll("style");
            if(arrStyle && arrStyle.length > 0)
			{
				for(var count= 0;count < arrStyle.length; count++)
				{
					var style = arrStyle[count].cloneNode(true);
					html += "\n" + style.outerHTML;
				}
			}
			var arrLink = this.__dom.doc.querySelectorAll("link");
			if(arrLink && arrLink.length > 0)
			{
				for(var count= 0;count < arrLink.length; count++)
				{
					var link = this.__dom.doc.createElement("link");
					link.rel = arrLink[count].rel;
					link.href = arrLink[count].href;
					link.type = "text/css";
					link.media = "all";
					html += "\n" + link.outerHTML;
				}
			}
            objWindow.document.write('' +
                '<!DOCTYPE html><html>' +
                '<head>' +
                '<meta charset="utf-8" />' +
                '<meta name="viewport" content="width=device-width, initial-scale=1">' +
                '<title>' + "Preview" + '</title>' +
                html +
                '</head>' +
                '<body class="' + bodyCssClass + '" style="width:' + width + '; border:1px solid #ccc; margin:10px auto !important; height:auto !important;">' + content + '</body>' +
                '</html>'
            );
            
		}
		else
		{
			objWindow.document.write('' +
                '<!DOCTYPE html><html>' +
                '<head>' +
                this.__getDocument().head.innerHTML +
                '<style>body {overflow:auto !important; width:' + width + '; border:1px solid #ccc; margin: 10px auto !important; height:auto !important;}</style>' +
                '</head>' +
                '<body ' + bodyCssClass + '>' + content + '</body>' +
                '</html>'
            );
		}
	};
	
	NSEditor.prototype.__pageBreakForPrintingHandler = function(item,key,event)
	{
		var divPageBreak = "<div class=\"nsEditorPageBreak\" style=\"page-break-after: always\" title=\"Page Break\"></div>";
		this.__selection.insertHTML(divPageBreak);
	};
	
	NSEditor.prototype.__getScrollComponent = function() 
	{
		var component = this.__isModeTextArea() ? this.__divTextAreaContainer : this.__getIFrameBody();
		return component;
	};
	
	NSEditor.prototype.__getScrollableComponent = function() 
	{
		var element = this.__isModeTextArea() ? this.__divTextAreaContainer : this.__frameContentWindow;
		return element;
	};
	
	NSEditor.prototype.__getTextArea = function() 
	{
		var component = this.__isModeTextArea() ? this.__compTextArea : this.__getIFrameBody();
		return component;
	};
	
	NSEditor.prototype.__getDocument = function() 
	{
		var component = this.__isModeTextArea() ? this.__dom.doc : this.__getIFrameDocument();
		return component;
	};
	
	NSEditor.prototype.__getWindow = function() 
	{
		var component = this.__isModeTextArea() ? this.__context : this.__frameContentWindow;
		return component;
	};
	
	NSEditor.prototype.__getListenerComponent = function() 
	{
		var listenerComponent = this.__isModeTextArea() ? this.__compTextArea : this.__frameContentWindow;
		return listenerComponent;
	};

	NSEditor.prototype.__isModeTextArea = function() 
	{
		return (this.__config["mode"] !== NSEditor.MODE_IFRAME);
	};
	
	NSEditor.prototype.__resizeContainer = function(width,height) 
	{
		this.__setHeight(height);
		this.__setWidth(width);
		this.__handleLineNumberOnResize();
	};
	
	NSEditor.prototype.__dispatchEvent = function(eventType,data,param,bubbles,cancelable)
	{
		this.util.dispatchEvent(this.__baseComponent,eventType,data,param,bubbles,cancelable);
	};
	
	NSEditor.prototype.__dispatchInternalEvent = function(eventType,data,param,bubbles,cancelable)
	{
		this.util.dispatchEvent(this.__baseComponent,this.__getInternalEvent(eventType),data,param,bubbles,cancelable);
	};
	
	NSEditor.prototype.__listenInternalEvent = function(eventType,callback)
	{
		this.util.addEvent(this.__baseComponent,this.__getInternalEvent(eventType),callback);
	};
	
	NSEditor.prototype.__removeInternalEvent = function(eventType,callback)
	{
		this.util.removeEvent(this.__baseComponent,this.__getInternalEvent(eventType),callback);
	};
	
	NSEditor.prototype.__addEvent = function(eventType,listener)
	{
		this.util.addEvent(this.__baseComponent,eventType,listener);
	};
	
	NSEditor.prototype.__getInternalEvent = function(eventType)
	{
		var retType = "";
		var joinBy = " ";
		var arrEventType = eventType.split(" ");
		for(var count = 0;count < arrEventType.length;count++)
		{
			retType += joinBy + "__" + arrEventType[count];
		}
		if(retType)
		{
			retType = retType.substring(joinBy.length);
		}
		return retType;
	};
	
	NSEditor.prototype.__height = function(height)
	{
		if(!this.util.isUndefinedOrNull(height))
		{
			this.util.css(this.__divOuterContainer,"height",height);
		}
		var baseMeasurement = this.__divOuterContainer.getBoundingClientRect();
		return baseMeasurement.height;
	};
	
	NSEditor.prototype.__width = function(width)
	{
		if(!this.util.isUndefinedOrNull(width))
		{
			this.util.css(this.__divOuterContainer,"width",width);
		}
		var baseMeasurement = this.__divOuterContainer.getBoundingClientRect();
		return baseMeasurement.width;
	};
	
	NSEditor.prototype.__heightBody = function(height)
	{
		if(!this.util.isUndefinedOrNull(height))
		{
			this.util.css(this.__divBodyContainer,"height",height);
		}
		var baseMeasurement = this.__divBodyContainer.getBoundingClientRect();
		return baseMeasurement.height;
	};
	
	NSEditor.prototype.__handleLineNumberOnResize = function()
	{
		if(this.__divLineNumberWrapper)
		{
			var lineNumberHeight = 15;
			var listenerComponent = this.__getScrollComponent();
			
			var scrollTop = listenerComponent.scrollTop;
			var firstLine = Math.floor((scrollTop / lineNumberHeight) + 1);
			var remainingScroll = (scrollTop / lineNumberHeight) % 1;

			this.__drawLineNumbers(firstLine);
			this.__divLineNumberWrapper.style.marginTop = (-1 * (remainingScroll * lineNumberHeight)) + "px";
			this.__paddingHorizontal = parseInt(this.util.getStyleValue(this.__divOuterContainer,"border-left-width",false)) +
									parseInt(this.util.getStyleValue(this.__divOuterContainer,"border-right-width",false)) + 
									parseInt(this.util.getStyleValue(this.__divOuterContainer,"padding-left",false)) + 
									parseInt(this.util.getStyleValue(this.__divOuterContainer,"padding-right",false));
		}
	};
	
	NSEditor.prototype.__getWrappedContent = function(content) 
	{
		if(content)
		{
			var isPFound = content.match(/<\/?p>/gi);
			if (!isPFound) 
			{
				return "<p>" + content + "</p>";
			}
		}
		return content;
	};
	
	NSEditor.prototype.__setDefaultTag = function()
	{
		var text = this.__getTextFromTextArea();
		var htmlText = this.__getHtmlFromTextArea();
		if(text && text.trim().length === 0 && htmlText != this.__defaultContent)
		{
			this.__isInternalHTMLChange = true;
			var body = this.__getTextArea();
			body.innerHTML = this.__defaultContent;
			this.__isInternalHTMLChange = false;
		}
	};
	
	NSEditor.prototype.__getPastedHTML = function(event)
	{
		var objReturn = {text:"",html:"",rtf:""};
		if (this.__context.clipboardData && this.__context.clipboardData.getData) 
        { 
			
        }
		else if (event.clipboardData && event.clipboardData.getData) 
        {
			objReturn.text = event.clipboardData.getData("text/plain");
			objReturn.html = event.clipboardData.getData("text/html");
			objReturn.rtf = event.clipboardData.getData("text/rtf");
        }
		return objReturn;
	};
	
	//Placeholder functions
	this.__compPlaceHolder = null;
	this.__placeHolderToggleRef = null;
	NSEditor.prototype.__createPlaceHolder = function() 
	{
		if(this.__config["placeholder"])
		{
			if(!this.__compPlaceHolder)
			{
				this.__compPlaceHolder = this.util.createElement("span",this.getID() + "Placeholder","nsEditorPlaceholder");
				this.__compPlaceHolder.appendChild(this.__dom.doc.createTextNode(this.__config["placeholder"]));
			}
			if(!this.editorUtil.isEditable())
			{
				this.__removePlaceHolder();
			}
			if(!this.__placeHolderToggleRef)
			{
				this.__placeHolderToggleRef = this.util.debounce(this.__togglePlaceHolder.bind(this),10);
				this.__placeHolderToggleRef();
				this.__addListenerToPlaceHolder();
			}
		}
	};
	
	NSEditor.prototype.__addListenerToPlaceHolder = function() 
	{
		this.__listenInternalEvent("textAreaInitialized change focus keyup mouseup keydown mousedown changePlace",this.__placeHolderToggleRef);
	};
	
	NSEditor.prototype.__setPlaceHolderPosition = function() 
	{
		if(this.__isPlaceHolderVisible())
		{
			var doc = this.__getDocument();
			var win = this.__getWindow();
			if(doc && win)
			{
				var getPropValue = function(value)
				{
					if(value == "")
					{
						return 0;
					}
					return parseInt(value, 10);
				};
				var textArea = this.__getTextArea();
				var marginTop = 0;
				var marginLeft = 0;
				var paddingTop = 0;
				var paddingLeft = 0;
				var firstChild = textArea.firstChild;
				var textAreaStyle = win.getComputedStyle(textArea);
				var css = {};
				if(firstChild && this.util.isElement(firstChild))
				{
					 var childStyle = win.getComputedStyle(firstChild);
			         marginTop = getPropValue(childStyle.getPropertyValue("margin-top"));
			         marginLeft = getPropValue(childStyle.getPropertyValue("margin-left"));
			         paddingTop = getPropValue(childStyle.getPropertyValue("padding-top"));
			         paddingLeft = getPropValue(childStyle.getPropertyValue("padding-left"));
			         css = {fontSize: getPropValue(childStyle.getPropertyValue("font-size")),lineHeight: getPropValue(childStyle.getPropertyValue("line-height"))};
				}
				else
				{
					 css = {fontSize: getPropValue(textAreaStyle.getPropertyValue("font-size")),lineHeight: getPropValue(textAreaStyle.getPropertyValue("line-height"))};
				}
				css.display = "block";
				css.marginTop = Math.max(getPropValue(textAreaStyle.getPropertyValue("margin-top")), marginTop);
				css.marginLeft = Math.max(getPropValue(textAreaStyle.getPropertyValue("margin-left")), marginLeft);
				css.paddingTop = Math.max(getPropValue(textAreaStyle.getPropertyValue("padding-top")), paddingTop);
				css.paddingLeft = Math.max(getPropValue(textAreaStyle.getPropertyValue("padding-left")), paddingLeft);
				this.util.css(this.__compPlaceHolder,css);
			}
		}
	};
	
	NSEditor.prototype.__togglePlaceHolder = function() 
	{
		if(this.__compPlaceHolder)
		{
			var visible = true;
			if(this.__txtSourceCode)
			{
				visible = false;
			}
			else
			{
				visible = this.__isTextAreaBlank();
			}
			visible ? this.__addPlaceHolder() : this.__removePlaceHolder();
		}
	};
	
	NSEditor.prototype.__addPlaceHolder = function() 
	{
		if(!this.__isPlaceHolderVisible())
		{
			this.__divTextAreaContainer.appendChild(this.__compPlaceHolder);
		}
		this.__setPlaceHolderPosition();
	};
	
	NSEditor.prototype.__removePlaceHolder = function() 
	{
		if(this.__isPlaceHolderVisible())
		{
			this.__compPlaceHolder.parentNode.removeChild(this.__compPlaceHolder);
		}
	};
	
	NSEditor.prototype.__isPlaceHolderVisible = function() 
	{
		return (this.__compPlaceHolder && this.__compPlaceHolder.parentNode);
	};
	
	//end of Placeholder functions
	//FixedDiv functions (for Modal,ContextMenu etc)
	this.__compFixed = null;
	NSEditor.prototype.__createFixedComp = function() 
	{
		if(!this.__compFixed)
		{
			this.__compFixed = this.util.createDiv(this.getID() + "_FixedComp","nsEditorFixedComp");
			this.__dom.doc.body.appendChild(this.__compFixed);
		}
	};
	
	NSEditor.prototype.__getFixedComp = function() 
	{
		if(!this.__compFixed)
		{
			this.__createFixedComp();
		}
		return this.__compFixed;
	};
	
	NSEditor.prototype.__isTextAreaBlank = function() 
	{
		/*var textArea = this.__getTextArea();
		if(textArea.children.length === 0)
		{
			return true;
		}
		var getText = function(paramText)
		{
			var regex = /[\uFEFF]/g;
			paramText = paramText.replace(regex,"");
			paramText = paramText.replace(/(\r\n|\n|\r)/gm,"");
			return paramText;
		};
		if(textArea.children.length === 1)
		{
			var firstChild = textArea.firstChild;
			if(this.editorUtil.REGEX_EMPTY_TAGS.test(firstChild.nodeName))
			{
				return false;
			}
			var text = this.__getTextFromTextArea();
			if(getText(text).length == 0)
			{
				return true;
			}
		}
		var self = this;
		var isEmpty = function(paramNode)
		{
			if(!paramNode) 
			{
	            return true;
	        }
			if(self.util.isTextNode(paramNode))
			{
				return paramNode.nodeValue === null || paramNode.nodeValue.trim().length === 0;
			}
			var regexNonEmptyTags = /^(img|svg|canvas|input|textarea|form)$/;
			if(regexNonEmptyTags.test(paramNode.nodeName.toLowerCase()))
			{
				return false;
			}
			if(self.util.isElement(paramNode))
			{
				var text = paramNode.textContent || paramNode.innerText;
				if(getText(text).length == 0)
				{
					return true;
				}
			}
			if(!self.util.isElement(paramNode))
			{
				return true;
			}
			return false;
		};
		var arrElements = textArea.querySelectorAll("*");
		for(var count = 0;count < arrElements.length;count++)
		{
			var ele = arrElements[count];
			if(!isEmpty(ele) && !(ele.tagName.toLowerCase() == "br"))
			{
				return false;
			}
		}
		return true;*/
		var textArea = this.__getTextArea();
		if (textArea.firstChild) 
		{
			var self = this;
			var firstChild = textArea.firstChild;
		    if(this.editorUtil.REGEX_EMPTY_TAGS.test(firstChild.nodeName))
		    {
		    	return false;
		    }
		    var nextNode = this.util.findNextNode(firstChild,function(node) 
		    { 
		    	return node && !self.editorUtil.isEmptyTextNode(node); 
		    }, textArea);
		    if (this.util.isTextNode(firstChild) && !nextNode) 
		    {
		    	return self.editorUtil.isEmptyTextNode(firstChild);
		    }
		    if (!nextNode) 
		    {
		    	var value = this.util.loopAllChildren(firstChild,function(paramElement) 
		    	{ 
		    		return self.editorUtil.isEmptyNode(paramElement) || self.util.isElementOfType(paramElement,"br"); 
		    	});
		    	if(value)
		    	{
		    		return true;
		    	}
		    }
		    return false;
	    }
	    return true;   
	};
	
	NSEditor.prototype.__getStyleValue = function(styleValue) 
	{
        return parseInt(styleValue, 10) || 0;
    };
    
    NSEditor.prototype.__initializeModules = function() 
	{
    	this.editorUtil = new NSEditorUtil(this);
		this.__selection = new NSSelection(this);
		this.__toolBar = new NSToolBar(this);
		this.__execCommand = new NSExecCommand(this);
		this.__stack = new NSStack(this);
	};
    
    //section of functions for util
    NSEditor.prototype.__getUtilClass = function(utilClassName) 
	{
		if(NSEditor.__util)
		{
			for(var utilName in NSEditor.__util)
			{
				if(utilName == utilClassName)
				{
					return NSEditor.__util[utilName];
				}
			}
		}
		this.util.throwNSError("NSEditor",utilClassName + " util has not been loaded.");
	};
	
	NSEditor.prototype.__getUtilInstance = function(utilClassName,utilInstanceID,plugginName,objPluggin,utilSetting) 
	{
		var utilClass = this.__getUtilClass(utilClassName);
		if(utilClass)
		{
			!this.__utilInstance[utilClassName] && (this.__utilInstance[utilClassName] = {});
			!this.__utilInstance[utilClassName][utilInstanceID] && (this.__utilInstance[utilClassName][utilInstanceID] = {});
			var objUtilPluggin = this.__utilInstance[utilClassName][utilInstanceID][plugginName];
			if(objUtilPluggin && objUtilPluggin.instance)
			{
				return objUtilPluggin.instance;
			}
			var objUtil = new utilClass(this,objPluggin,utilSetting);
			objUtil.id = utilInstanceID;
			objUtil.selection = this.__selection;
			objUtil.util = this.util;
			objUtil.editorUtil = this.editorUtil;
			var item = {instance: objUtil,instanceID: utilInstanceID,plugginInstance: objPluggin,utilSetting: utilSetting};
			this.__utilInstance[utilClassName][utilInstanceID][plugginName] = item;
			return objUtil;
		}
	};
	//end of section of functions for util
    
	//section of functions for pluggin
	NSEditor.prototype.__initializePlugins = function() 
	{
		this.__pluginsInstances = {};
		if(NSEditor.__plugins)
		{
			for(var plugginName in NSEditor.__plugins)
			{
				var objPlugin = new NSEditor.__plugins[plugginName](this);
				objPlugin.nsEditor = this;
				objPlugin.selection = this.__selection;
				objPlugin.util = this.util;
				objPlugin.editorUtil = this.editorUtil;
				this.__pluginsInstances[plugginName] = {prototype: NSEditor.__plugins[plugginName],instance: objPlugin};
			}
		}
	};
	
	NSEditor.prototype.__callSetSettingsInPluggin = function() 
	{
		this.__callFunctionInPlugins("setSettings");
		this.__dispatchInternalEvent("setSettings");
	};
	
	NSEditor.prototype.__callInitializeInPluggin = function() 
	{
		this.__callFunctionInPlugins("initialize");
		this.__dispatchInternalEvent("initialize");
	};
	
	NSEditor.prototype.__callComponentsInitializedInPluggin = function() 
	{
		this.__callFunctionInPlugins("componentsInitialized");
		this.__dispatchInternalEvent("componentsInitialized");
	};
	
	NSEditor.prototype.__callDestroyInPluggin = function() 
	{
		this.__callFunctionInPlugins("destroy");
		this.__dispatchInternalEvent("destroy");
	};
	
	NSEditor.prototype.__callResizedInPluggin = function() 
	{
		this.__callFunctionInPlugins("resized");
		this.__dispatchInternalEvent("resized");
	};
	
	NSEditor.prototype.__callAddStyleIFrameInPluggin = function() 
	{
		return this.__callFunctionInPlugins("addStyleInIFrame");
		this.__dispatchInternalEvent("addStyleInIFrame");
	};
	
	NSEditor.prototype.__callFunctionInPlugins = function(functionName,arrParams) 
	{
		var arrRetValue = [];
		if(this.__pluginsInstances)
		{
			for(var plugginName in this.__pluginsInstances)
			{
				var objPlugin = this.__pluginsInstances[plugginName].instance;
				if(objPlugin && objPlugin[functionName])
				{
					var retValue = objPlugin[functionName].apply(objPlugin,arrParams);
					if(!this.util.isUndefined(retValue))
					{
						arrRetValue.push({name: plugginName,value: retValue});
					}
				}
			}
		}
		return arrRetValue;
	};
	
	NSEditor.prototype.__callPromptBox = function(titleHtml,message,okText,cancelText,okHandler,cancelHandler) 
	{
		if(this.__config["promptBoxCallback"])
		{
			this.__config["promptBoxCallback"](titleHtml,message,okText,cancelText,okHandler,cancelHandler);
		}
		else
		{
			var closeConfirmBox = function(event)
			{
				this.__dom.doc.body.removeChild(divContainer);
			};
			var divContainer = this.util.createDiv("nsEditorConfirmContainer","nsEditorPromptOvelay");
			var content = "<div class='nsEditorPrompt'>" +
	    						"<header>" +
	    							"<h3> " + titleHtml + " </h3> " +
	    							"<i id='nsEditorIconClose' class='fa fa-close'></i>" +
	    						"</header>" +
	        					"<div class='nsEditorPromptBody'>" +
	        						" <p> " + message + " </p> " +
	        					"</div>" +
	        					"<footer>" +
							         "<div class='controls'>" +
							             " <button id='btnEditorConfirmOk' class='nsEditorPromptButton nsEditorPromptButtonDanger'>" + okText + "</button> " +
							             " <button id='btnEditorConfirmCancel' class='nsEditorPromptButton nsEditorPromptButtonDefault'>" + cancelText + "</button> " +
							         "</div>" +
							    "</footer>" +
						   "</div>";
			divContainer.innerHTML = content;
			this.__dom.doc.body.insertBefore(divContainer,this.__dom.doc.body.firstChild);
			this.util.addEvent(this.__dom.doc.getElementById("nsEditorIconClose"),"click",closeConfirmBox);
			this.util.addEvent(this.__dom.doc.getElementById("btnEditorConfirmOk"),"click",function(event){
				if(okHandler)
				{
					okHandler(event);
				}
				closeConfirmBox();
			});
			this.util.addEvent(this.__dom.doc.getElementById("btnEditorConfirmCancel"),"click",function(event){
				if(cancelHandler)
				{
					cancelHandler(event);
				}
				closeConfirmBox();
			});
		}
	};
	//end of section of functions for pluggin

	NSEditor.prototype.__addElement = function (node,config) 
	{
		this.__selection.restoreSelection();
		if(node)
		{
			config = config || {};
			var doc = this.__getDocument();
			var win = this.__getWindow();
			var textArea = this.__getTextArea();
			var html = this.getHtml();
			if(html == this.__defaultContent)
			{
				this.util.removeAllChildren(textArea);
			}
			var element = this.__selection.getElementUnderCursor();
	        var isCollapsed = this.__selection.isCollapsed();
	        if (element && isCollapsed) 
	        {
	        	var self = this;
	        	var blockElement = this.editorUtil.getClosestElement(element,function(node) 
	        	{ 
	        		return self.editorUtil.isBlock(node,win); 
	        	},textArea);
	            if (config.insertAfterSelectedNode && blockElement && blockElement !== textArea) 
	            {
	            	if(!config.insertAfterNodeCallback || config.insertAfterNodeCallback(blockElement))
	            	{
	            		this.__selection.setCursorAfter(blockElement);
	            	}
	            }
	        }
	        this.__selection.insertNode(doc.createTextNode("\n"));
	        this.__selection.insertNode(node,Boolean.parse(config.insertCursorAfter));
	        config.afterInsertCallback && config.afterInsertCallback();
	        if(config.dispatchEvents && config.dispatchEvents.length)
	        {
	        	for(var count = 0;count < config.dispatchEvents.length;count++)
	        	{
	        		var itemEvent = config.dispatchEvents[count];
	        		this.__dispatchInternalEvent(itemEvent.name,itemEvent.args,itemEvent.args);
	        	}
	        }
		}
	};
	
	
    
    NSEditor.prototype.__checkCharCount = function(element,charCounterType) 
    {
    	var maxCount = this.__config.maxCharCount
        if (maxCount) 
        {
            var countType = charCounterType || this.__config.charCounterType;
            var length = this.editorUtil.getCharLength((typeof element === "string" ? element : this.__isCharTypeHTML() ? element.outerHTML : element.textContent), countType);
            if (length > 0 && length + this.__getCharCount(countType) > maxCount) 
            {
            	//TODO:indicate here that character has increased maxCharCount
                return false;
            }
        }
        return true;
    };
    
    NSEditor.prototype.__getCharCount = function(charCounterType) 
    {
        charCounterType = (typeof charCounterType === "string") ? charCounterType : this.__config.charCounterType;
        var count = this.editorUtil.getCharLength((this.__isCharTypeHTML() ? this.getHtml() : this.getText()), charCounterType);
        return count;
    };

	//function related to Media sources like img,audio,video
	NSEditor.prototype.__createCustomMediaContainerContainer = function(mediaContainer,cssClass,contenteditable) 
	{
		contenteditable = Boolean.parse(contenteditable);
        var container = this.util.createDiv(null,"nsEditorMediaContainerContainer");
        if(cssClass)
        {
        	this.util.addStyleClass(cssClass);
        }
        container.setAttribute("contenteditable",contenteditable);
        if(mediaContainer)
        {
        	container.appendChild(mediaContainer);
        }
        return container;
    };

    NSEditor.prototype.__createCustomMediaContainer = function(element,parent) 
    {
        var container = this.util.createDiv(null,"nsEditorMediaContainer");
        if(element)
        {
        	container.appendChild(element);
        }
        if(parent)
        {
        	parent.appendChild(container);
        }
        return container;
    };

    NSEditor.prototype.__createCustomMediaCaption = function(caption,parent) 
    {
        var divCaption = this.util.createDiv(null,"nsEditorMediaCaption");
        divCaption.setAttribute("contenteditable", true);
        var divContent = this.util.createDiv(null,"nsEditorMediaCaptionContent");
        divContent.innerHTML = caption;
        divCaption.appendChild(divContent);
        if(parent)
        {
        	parent.appendChild(divCaption);
        }
        return divCaption;
    };
	
	//end of function related to Media sources like img,audio,video
	
	NSEditor.prototype.__isCharTypeHTML = function() 
    {
		return (this.__config.charCounterType == "byte-html")
    };
    	
	//function using the editor
	
	this.__funcID = null;
	NSEditor.prototype.__funcExecuted = function(funcID) 
	{
		this.__funcID = funcID;
	};
	
	NSEditor.prototype.__isFuncExecuted = function(funcID) 
	{
		var retValue = (this.__funcID == funcID);
		return retValue;
	};
	
	//end of function using the editor 
    
	NSEditor.TOOLBAR_BUTTONS_BOLD = "bold";
	NSEditor.TOOLBAR_BUTTONS_ITALIC = "italic";
	NSEditor.TOOLBAR_BUTTONS_UNDERLINE = "underline";
	NSEditor.TOOLBAR_BUTTONS_STRIKETHROUGH = "strikeThrough";
	NSEditor.TOOLBAR_BUTTONS_SUBSCRIPT = "subscript";
	NSEditor.TOOLBAR_BUTTONS_SUPERSCRIPT = "superscript";
	NSEditor.TOOLBAR_BUTTONS_FONTFAMILY = "fontFamily";
	NSEditor.TOOLBAR_BUTTONS_FONTSIZE = "fontSize";
	NSEditor.TOOLBAR_BUTTONS_PARAGRAPHFORMAT = "paragraphFormat";
	NSEditor.TOOLBAR_BUTTONS_ALIGN = "align";
	NSEditor.TOOLBAR_BUTTONS_ORDEREDLIST = "orderedList";
	NSEditor.TOOLBAR_BUTTONS_UNORDEREDLIST = "unorderedList";
	NSEditor.TOOLBAR_BUTTONS_UNDO = "undo";
	NSEditor.TOOLBAR_BUTTONS_REDO = "redo";
	NSEditor.MODE_TEXTAREA = "textArea";
	NSEditor.MODE_IFRAME = "iframe";
	
	return NSEditor;
})();
nsModuleExport(this,"NSEditor",NSEditor);"use strict";
/*https://www.brainbell.com/javascript/making-resizable-table-js.html*/
var NSResizableTable = (function()
{
	function NSResizableTable(table,setting,doc)
	{
		this.__table = table;
		this.__setting = setting;
		this.__doc = doc;
		this.util = new NSUtil();	
		
		this.__config = null;
		this.__dom = null;
	    this.__id = null;
	    this.__origTableProp = {};
	    this.__arrResizer = [];
	    this.__objDrag = null;
	    this.__initialize();
	};
	
	NSResizableTable.prototype.__initialize = function()
	{
		if(this.util.hasStyleClass(this.__table,"nsResizableTable"))
		{
			this.util.warning("NSResizableTable","Table has already been processed");
			return;
		}
		this.__dom = this.util.getDomVariables();
		this.__setSetting();
		this.util.addStyleClass(this.__table,"nsResizableTable");
		this.__initCols();
	};
	
	NSResizableTable.prototype.__setSetting = function()
	{
		var setting = this.__setting ? this.__setting : {};
		this.__config = {
				getRowCallback: setting["getRowCallback"]
		}
	};
	
	NSResizableTable.prototype.__initCols = function()
	{
		var table = this.__table;
		var row = table.getElementsByTagName("tr")[0];
		if(this.__config.getRowCallback)
		{
			row = this.__config.getRowCallback(table,this)
		}
		var arrCols = row ? row.children : null;
		if(arrCols)
		{
			this.__origTableProp["overflow"] = table.style.overflow;
			table.style.overflow = "hidden";
			var tableHeight = table.offsetHeight;
			for (var count=0;count < arrCols.length;count++)
			{
				var col = arrCols[count];
				var resizer = this.__createResizer(count,tableHeight);
				col.appendChild(resizer);
				this.util.addStyleClass(col,"nsResizableTableColumn");
				this.__addEventToResizer(resizer);
				this.__arrResizer.push(resizer);
			}
		}
	};
	
	NSResizableTable.prototype.__createResizer = function(colIndex,height)
	{
		var doc = this.__doc || this.__dom.doc;
		var id = this.__getID() + "_col" + colIndex;
		var resizer = this.util.createDiv(id,"nsColumnResizer",doc);
		resizer.style.height = height + "px";
		return resizer;
	};
	
	NSResizableTable.prototype.__addEventToResizer = function(resizer)
	{
		var self = this;
		var resizeEventHandler = function(event)
		{
			event = self.util.getEvent(event);
			event.stopPropagation();
			event.preventDefault();
			event.stopImmediatePropagation();
		};
		this.util.addEvent(resizer,"mousedown touchstart",this.__resizerMouseDownHandler.bind(this,resizer));
		this.util.addEvent(resizer,"click",resizeEventHandler);
		this.util.addEvent(resizer,"dblclick",resizeEventHandler);
		this.util.addEvent(resizer,"mouseover",this.__resizerMouseOverHandler.bind(this,resizer));
		this.util.addEvent(resizer,"mouseout",this.__resizerMouseOutHandler.bind(this,resizer));
	};
	
	NSResizableTable.prototype.__resizerMouseDownHandler = function(resizer,event)
	{
		event = this.util.getEvent(event);
		var doc = this.__doc || this.__dom.doc;
		resizer = event.target;
		this.__objDrag = {dragging: true,resizer: resizer};
		this.__objDrag.resizerMouseMove = this.__resizerMouseOverHandler.bind(this,resizer);
		this.__objDrag.resizerMouseUp = this.__resizerMouseOutHandler.bind(this,resizer);
		this.util.addEvent(resizer,"mouseover",this.__objDrag.resizerMouseMove);
		this.util.addEvent(resizer,"mouseout",this.__objDrag.resizerMouseUp);
		this.__objDrag.docMouseMove = this.__docMouseMoveHandler.bind(this,resizer);
		this.__objDrag.docMouseUp = this.__docMouseUpHandler.bind(this,resizer);
		this.util.addEvent(doc,"mousemove touchmove",this.__objDrag.docMouseMove);
		this.util.addEvent(doc,"mouseup",this.__objDrag.docMouseUp);
		this.__objDrag.currentColumn = event.target.parentElement;
		this.__objDrag.nextColumn = this.__objDrag.currentColumn.nextElementSibling;
		this.__objDrag.pageX = event.pageX; 
		var padding = this.__getPaddingDiff(this.__objDrag.currentColumn);
		this.__objDrag.currentColumnWidth = this.__objDrag.currentColumn.offsetWidth - padding;
		if (this.__objDrag.nextColumn)
		{
			this.__objDrag.nextColumnWidth = this.__objDrag.nextColumn.offsetWidth - padding;
		}
		var item = {column: this.__objDrag.currentColumn,index: this.__objDrag.currentColumn.cellIndex};
		this.__dispatchEvent(NSResizableTable.COLUMN_RESIZING_START,item,item);
	};
	
	NSResizableTable.prototype.__resizerMouseOverHandler = function(resizer,event)
	{
		//if(this.__objDrag && this.__objDrag.dragging)
		//{
			event = this.util.getEvent(event);
			this.util.addStyleClass(event.target,"nsColumnResizerMoving");
		//}
	};
	
	NSResizableTable.prototype.__resizerMouseOutHandler = function(resizer,event)
	{
		//if(this.__objDrag && this.__objDrag.dragging)
		//{
			event = this.util.getEvent(event);
			this.util.removeStyleClass(event.target,"nsColumnResizerMoving");
		//}
	};
	
	NSResizableTable.prototype.__docMouseMoveHandler = function(resizer,event)
	{
		if(this.__objDrag && this.__objDrag.dragging)
		{
			event = this.util.getEvent(event);
			if(this.__objDrag.currentColumn)
			{
				this.util.makeBodyUnselectable();
				var diffX = event.pageX - this.__objDrag.pageX;
				if(this.__objDrag.nextColumn)
				{
					this.__objDrag.nextColumn.style.width = (this.__objDrag.nextColumnWidth - diffX) + "px";
				}
				this.__objDrag.currentColumn.style.width = (this.__objDrag.currentColumnWidth + diffX) + "px";
				var item = {column: this.__objDrag.currentColumn,index: this.__objDrag.currentColumn.cellIndex};
				this.__dispatchEvent(NSResizableTable.COLUMN_RESIZING,item,item);
			}
		}
	};
	
	NSResizableTable.prototype.__docMouseUpHandler = function(resizer,event)
	{
		if(this.__objDrag)
		{
			event = this.util.getEvent(event);
			var doc = this.__doc || this.__dom.doc;
			this.util.removeEvent(this.__objDrag.resizer,"mouseover",this.__objDrag.resizerMouseMove);
			this.util.removeEvent(this.__objDrag.resizer,"mouseout",this.__objDrag.resizerMouseUp);
			this.util.removeEvent(doc,"mousemove touchmove",this.__objDrag.docMouseMove);
			this.util.removeEvent(doc,"mouseup",this.__objDrag.docMouseUp);
			this.util.makeBodySelectable();
			var currentColumn = this.__objDrag.currentColumn;
			this.__objDrag = null;
			event.stopImmediatePropagation();
			var item = {column: currentColumn,index: currentColumn.cellIndex};
			this.__dispatchEvent(NSResizableTable.COLUMN_RESIZING_END,item,item);
		}
	};
	
	/*********************************Start of Util Function*******************************/
	NSResizableTable.prototype.__getID = function()
	{
		if(!this.__id)
		{
			this.__id = "compResizableTable" + this.util.getUniqueId();
		}
		return this.__id;
	};
	
	NSResizableTable.prototype.__getPaddingDiff = function(column)
	{
		if (this.util.getStyleValue(column,"box-sizing") == "border-box")
		{
			return 0;
		}
		var padLeft = this.util.getStyleValue(column,"padding-left");
		var padRight = this.util.getStyleValue(column,"padding-right");
		return (parseInt(padLeft) + parseInt(padRight));
	 };
	 
	 NSResizableTable.prototype.__dispatchEvent = function(eventType,data,param,bubbles,cancelable)
	 {
		this.util.dispatchEvent(this.__table,eventType,data,param,bubbles,cancelable);
	 };
	/*********************************End of Util Function*******************************/
	
	NSResizableTable.prototype.destroy = function()
	{
		for(var key in this.__origTableProp)
		{
			this.__table.style[key] = this.__origTableProp[key];
		}
		this.__origTableProp = {};
	};
	
	NSResizableTable.COLUMN_RESIZING_START = "columnResizingStart";
	NSResizableTable.COLUMN_RESIZING = "columnResizing";
	NSResizableTable.COLUMN_RESIZING_END = "columnResizingEnd";
	
	return NSResizableTable;
})();
nsModuleExport(this,"NSResizableTable",NSResizableTable);var NSTablePicker = (function()
{
	var NSTablePicker = function(setting)
	{
		var self = this;
		var config = {};
	    
	    var util = null;
	    var win = null;
		var doc = null;
		var deviceSupport = null;
		var parent = null;
	    var container = null;
	    var tblContainerCon = null;
	    var tblContainer = null;
	    var labelContainerCon = null;
	    var labelContainer = null;
	    var arrCells = [];
	    var strDefaultStyle = "";
	    var nsPopUp = null;
	    var id = null;
		
		var initialize = function()
		{
			if(!setting)
			{
				setting = {};
			}
			util = new NSUtil();
			var obj = util.getDomVariables();
    		win = obj.win;
    		doc = obj.doc;
    		deviceSupport = util.getSupportedEvents();
			config = {
			    context: setting["context"] || win,
			    isPopUp: Boolean.parse(setting["isPopUp"]),
			    popUpPos: setting["popUpPos"] || util.POS_BOTTOMRIGHT,
			    trigger: setting["trigger"],
			    triggerEvent: setting["triggerEvent"] || "click",
			    closeOnOutsideClick: util.isUndefinedOrNull(setting["closeOnOutsideClick"]) ? true : Boolean.parse(setting["closeOnOutsideClick"]),
			    element: setting["element"],
				width: setting["width"] || 200,
				height: setting["height"] || 200,
				cellWidth: setting["cellWidth"] || 20,
				cellHeight: setting["cellHeight"] || 20,
				rowCount: setting["rowCount"] || 10,
				columnCount: setting["columnCount"] || 10,
				enableShowDimension: util.isUndefinedOrNull(setting["enableShowDimension"]) ? true : Boolean.parse(setting["enableShowDimension"]),
				theme: setting["theme"] || "White",
				cellMouseOverCallback: setting["cellMouseOverCallback"],
				cellMouseOutCallback: setting["cellMouseOutCallback"],
				cellClickCallback: setting["cellClickCallback"],
				popUpOpenCallback: setting["popUpOpenCallback"],
				popUpCloseCallback: setting["popUpCloseCallback"],
			};
			if (!config.isPopUp && !config.element) 
			{
				util.throwNSError("NSTablePicker","Element in setting is missing");
	        }
	   		if(!setting.customClass)
    		{
    			setting.customClass = {};
    		}
    		config.customClass = {
    				container:setting.customClass["container"],
    				tableContainer:setting.customClass["tableContainer"],
    				table:setting.customClass["table"],
    				rowContainer:setting.customClass["rowContainer"],
    				row:setting.customClass["row"],
    				cellContainer:setting.customClass["cellContainer"],
    				cell:setting.customClass["cell"],
    				labelContainer:setting.customClass["labelContainer"],
    				label:setting.customClass["label"]
    		};

			createComponent();
		};
		
		var createComponent = function()
		{
			if(container)
			{
				if(container.parentElement)
				{
					container.parentElement.removeChild(container);
				}
				resetVars();
			}
			if(config.isPopUp)
			{
				var popUpSetting = {type:"div",width:null,position:config.popUpPos,closeOnOutsideClick:config.closeOnOutsideClick
									,hideOrRemoveOnOutsideClick: "hide",width: "auto"};
				nsPopUp = new util.nsPopUp(popUpSetting);
				nsPopUp.create();
				parent = nsPopUp.getPopUp();
				if(config.trigger)
				{
					if(util.isElement(config.trigger))
					{
						util.addEvent(config.trigger,config.triggerEvent,handleTriggerEvent);
					}
					else
					{
						util.warning("NSTablePicker","Trigger is not a element");
					}
				}
			}
			else
			{
				parent = config.element;
			}
			container = util.createDiv(getID() + "Container","nsTablePicker");
			parent.appendChild(container);
			setTheme(config.theme);
			applyCustomClass(container,"container");
			var radius = util.getStyleValue(container, "border-radius", true);
			createTable(config.rowCount,config.columnCount);
			createLabel();
			if(!radius)
			{
				radius = 0;
			}
			else
			{
				radius = util.getDimensionAsNumber(container,radius);
			}
			if(radius)
			{
				radius = parseInt(radius,10) * 2;
			}
			var labelHeight = 0;
			if(labelContainerCon)
			{
				labelHeight = labelContainerCon.offsetHeight;
			}
			//for Firefox
			//container.style.width = (config.width + radius) + "px";
			//container.style.height = (config.height + radius + labelHeight) + "px";
			/*var paddingLeft = util.getStyleValue(tblContainerCon, "padding-left", true);
			if(!paddingLeft)
			{
				paddingLeft = 0;
			}
			else
			{
				paddingLeft = util.getDimensionAsNumber(tblContainerCon,paddingLeft);
			}
			var paddingRight = util.getStyleValue(tblContainerCon, "padding-right", true);
			if(!paddingRight)
			{
				paddingRight = 0;
			}
			else
			{
				paddingRight = util.getDimensionAsNumber(tblContainerCon,paddingRight);
			}
			tblContainerCon.style.width = (config.width + paddingLeft + paddingRight) + "px";*/
			tblContainerCon.style.height = (config.height) + "px";
			/*if(labelContainerCon)
			{
				var orignalValue = parent.style.display;
				parent.style.display = "block";
				tblContainerCon.style.height = (container.offsetHeight - labelContainerCon.offsetHeight) + "px";
				parent.style.display = (orignalValue) ? orignalValue : "";
			}*/
			calculateCellDimensions();
		};
		
		var calculateCellDimensions = function()
		{
			if(!config.cellWidth || !config.cellHeight)
			{
				var orignalValue = parent.style.display;
				parent.style.display = "block";
				if(!config.cellWidth)
				{
					var availableWidth = tblContainer.offsetWidth;
					config.cellWidth = availableWidth / config.columnCount;
				}
				if(!config.cellHeight)
				{
					var availableHeight = tblContainer.offsetHeight;
					config.cellHeight = availableHeight / config.rowCount;
				}
				parent.style.display = (orignalValue) ? orignalValue : "";
			}
			if(config.cellWidth && config.cellHeight)
			{
				var id = getID() + "Container";
				util.addCSSClassInDOM(["#" + id + ".nsTablePicker .nsTableCellContainer"],["width:" + config.cellWidth + "px;height:" + config.cellHeight + "px;"]);
			}
		};
		
		var createLabel = function()
		{
			if(config.enableShowDimension)
			{
				labelContainerCon = util.createDiv(null,"nsTablePickerLblCon");
				applyCustomClass(labelContainerCon,"labelContainer");
				labelContainer = util.createDiv(null,"nsTablePickerLbl");
				applyCustomClass(labelContainer,"label");
				labelContainerCon.appendChild(labelContainer);
				container.appendChild(labelContainerCon);
			}
		};
		
		var createTable = function(rowCount,colCount)
		{
			tblContainerCon = util.createDiv(null,"nsTablePickerTblCon");
			applyCustomClass(tblContainerCon,"tableContainer");
			tblContainer = util.createDiv(null,"nsTablePickerTbl");
			for(var rowIndex = 0;rowIndex < rowCount;rowIndex++)
			{
				var rowCon = createRow(rowIndex,colCount);
				tblContainer.appendChild(rowCon);
			}
			applyCustomClass(tblContainer,"table");
			tblContainerCon.appendChild(tblContainer);
			container.appendChild(tblContainerCon);
		};
		
		var createRow = function(rowIndex,colCount)
		{
			var rowContainer = util.createDiv(null,"nsTableRowContainer");
			rowContainer.setAttribute("ns-row-index",rowIndex);
			applyCustomClass(rowContainer,"rowContainer");
			var row = util.createDiv(null,"nsTableRow");
			for(var cellIndex = 0;cellIndex < colCount;cellIndex++)
			{
				var cellCon = createCell(rowIndex,cellIndex,row);
				row.appendChild(cellCon);
			}
			applyCustomClass(row,"row");
			rowContainer.appendChild(row);
			return rowContainer;
		};
		
		var createCell = function(rowIndex,cellIndex,row)
		{
			var cellContainer = util.createDiv(null,"nsTableCellContainer");
			cellContainer.setAttribute("ns-row-index",rowIndex);
			cellContainer.setAttribute("ns-cell-index",cellIndex);
			applyCustomClass(cellContainer,"cellContainer");
			var cell = util.createDiv(null,"nsTableCell");
			cellContainer.appendChild(cell);
			applyCustomClass(cell,"cell");
			strDefaultStyle = cell.className;
			util.addEvent(cellContainer,"mouseover",cellMouseOverHandler.bind(null,cell,rowIndex,cellIndex));
			util.addEvent(cellContainer,"mouseout",cellMouseOutHandler.bind(null,cell,rowIndex,cellIndex));
			util.addEvent(cellContainer,"click",cellClickHandler.bind(null,cell,rowIndex,cellIndex));
			arrCells.push({rowIndex: rowIndex,cellIndex: cellIndex,row: row,cell: cell,cellContainer: cellContainer});
			return cellContainer;
		};
		
		var cellMouseOverHandler = function(cell,rowIndex,cellIndex,event)
		{
			event = util.getEvent(event);
			if(config.cellMouseOverCallback)
			{
				config.cellMouseOverCallback(event,cell,rowIndex + 1,cellIndex + 1);
			}
		    if (event.target)
		    {
		    	var xPos = (cellIndex + 1) * config.width / config.columnCount;
			    var yPos = (rowIndex + 1) * config.height / config.rowCount;
		    }
		    renderCells(rowIndex,cellIndex);
		    refreshLabel(xPos,yPos,rowIndex,cellIndex);
		};
		
		var cellMouseOutHandler = function(cell,rowIndex,cellIndex,event)
		{
			event = util.getEvent(event);
			if(config.cellMouseOutCallback)
			{
				config.cellMouseOutCallback(event,cell,rowIndex + 1,cellIndex + 1);
			}
			renderCells(null,null);
			refreshLabel(0,0,null,null);
		};
		
		var cellClickHandler = function(cell,rowIndex,cellIndex,event)
		{
			event = util.getEvent(event);
			event.preventDefault();
			if(config.cellClickCallback)
			{
				config.cellClickCallback(event,cell,rowIndex + 1,cellIndex + 1);
			}
		};
		
		var renderCells = function(activeRowIndex,activeCellIndex)
		{
			for(var cellCount = 0;cellCount < arrCells.length;cellCount++)
			{
				var item = arrCells[cellCount];
				var styleClass = strDefaultStyle;
                if (item.rowIndex == activeRowIndex && item.cellIndex === activeCellIndex) 
                {
                	styleClass += " nsTableCellActive";
                } 
                else if (item.rowIndex <= activeRowIndex && item.cellIndex <= activeCellIndex) 
                {
                	styleClass += " nsTableCellSelected";
                } 

                /*if(item.rowIndex <= selectedRow && item.cellIndex <= selectedColumn) 
                {
                  	styleClass += " nsTableCellActive";
                }*/
                item.cell.setAttribute("class",styleClass);
			}
		};
		
		var refreshLabel = function(xPos,yPos,activeRowIndex,activeCellIndex)
		{
			if(config.enableShowDimension)
			{
				if(activeRowIndex == null)
				{
					labelContainer.innerHTML = "";
				}
				else
				{
					labelContainer.innerHTML = (activeRowIndex + 1)  + " x " + (activeCellIndex + 1);
				}
			}
		};
		
		var applyCustomClass = function(element,type)
    	{
    		if(element && type && config.customClass[type])
    		{
    			util.addStyleClass(element,config.customClass[type]);
    		}
    	};
    	
    	var handleTriggerEvent= function(event)
    	{
    		if(nsPopUp)
    		{
    			event = util.getEvent(event);
    			event.stopPropagation();
    			if(nsPopUp.isOpen())
    			{
    				close(event);
    			}
    			else
    			{
    				open(event);
    			}
    		}
    	};
    	
    	var resetVars = function()
    	{
    		container = null;
			arrCells = [];
			strDefaultStyle = "";
    	};
    	
    	var getID = function()
    	{
    		if(!id)
    		{
    			var comp = config.isPopUp ? (config.trigger ? config.trigger : null) : config.element;
    			if(comp)
    			{
    				if(comp.hasAttribute("id"))
        			{
        				id = comp.getAttribute("id");
        			}
        			else if(comp.hasAttribute("name"))
        			{
        				id = comp.getAttribute("name");
        			}
    			}
    			if(!id)
    			{
    				id = "comp" + util.getUniqueId();
    			}
    		}
    		return id;
    	};
		
		var setTheme = function(theme) 
    	{
    		if(container && config.theme)
    		{
    			util.removeStyleClass(container,"nsTablePicker" + config.theme);
    			config.theme = theme;
    			util.addStyleClass(container,"nsTablePicker" + config.theme);
    		}
    	};
    	
    	var open = function(event) 
    	{
    		if(nsPopUp)
    		{
    			nsPopUp.show();
    			if(config.trigger)
    			{
    				nsPopUp.placePopUp(config.trigger);
    			}
    			else if(event)
    			{
    				nsPopUp.placePopUp(event);
    			}
    			if(config.popUpOpenCallback)
    			{
    				config.popUpOpenCallback(event,self);
    			}
    		}
    		else
    		{
    			util.warning("NSTablePicker","PopUp is not enabled");
    		}
    	};
    	
    	var close = function(event) 
    	{
    		if(nsPopUp)
    		{
    			nsPopUp.hide();
    			if(config.popUpCloseCallback)
    			{
    				config.popUpCloseCallback(event,self);
    			}
    		}
    		else
    		{
    			util.warning("NSTablePicker","PopUp is not enabled");
    		}
    	};
    	
    	var remove = function()
    	{
    		if(nsPopUp)
    		{
    			nsPopUp.remove();
    			nsPopUp = null;
    		}
    		else if(container)
    		{
    			if(container.parentElement)
				{
					container.parentElement.removeChild(container);
				}
    		}
    		resetVars();
    	};
    	
    	var isOpen = function() 
    	{
    		if(nsPopUp)
    		{
    			return nsPopUp.isOpen();
    		}
    		return false;
    	};
		
		initialize();
		
		self.setTheme = setTheme;
		self.open = open;
		self.close = close;
		self.remove = remove;
		self.isOpen = isOpen;
	};
	
	return NSTablePicker;
})();
nsModuleExport(this,"NSTablePicker",NSTablePicker);"use strict"; 
var NSTableUtil = (function()
{
	function NSTableUtil(doc,win) 
	{		
		var self = this;
		var util = new NSUtil();
		var dom = util.getDomVariables();
		
		this.doc = doc || dom.doc;
		this.win = win || dom.window;
		
		this.getRowsCount = function(table) 
		{
	        return table.rows.length;
	    };
	    
	    this.getColumnsCount = function(table) 
	    {
	    	var arrFlatRows = getFlattenRows(table);
	        var colCount = arrFlatRows.reduce(function(total,cells,currentIndex,arr) 
	        {
	            return Math.max(total, cells.length);
	        },0);
	        return colCount;
	    };
	    
	    //appendRow
	    this.insertRow = function(table,rowReference,isInsertBelow,callback) 
	    {
	    	var arrRet = [];
	    	var row = null;
	        if (!rowReference) 
	        {
	            var colCount = this.getColumnsCount(table);
	            row = this.doc.createElement("tr");
	            for (var colIndex = 0;colIndex < colCount; colIndex++) 
	            {
	            	var cell = this.doc.createElement("td");
	            	callback && callback(cell,row,table,colIndex,rowReference,isInsertBelow);
	                row.appendChild(cell);
	                arrRet.push(cell);
	            }
	        }
	        else 
	        {
	            row = rowReference.cloneNode(true);
	            var arrCells = rowReference.querySelectorAll("td,th");
	            for (var colIndex = 0;colIndex < arrCells.length; colIndex++) 
	            {
	            	var cell = arrCells[colIndex];
	            	var rowspan = cell.getAttribute("rowspan");
	                if (rowspan && parseInt(rowspan, 10) > 1) 
	                {
	                    var newRowSpan = parseInt(rowspan, 10) - 1;
	                    if(newRowSpan > 1)
	                    {
	                    	cell.getAttribute("rowspan",newRowSpan);
	                    }
	                }
	            }
	            arrCells = row.querySelectorAll("td,th");
	            for (var colIndex = 0;colIndex < arrCells.length; colIndex++) 
	            {
	            	var cell = arrCells[colIndex];
	            	util.removeAllChildren(cell);
	            	callback && callback(cell,row,table,colIndex,rowReference,isInsertBelow);
	                arrRet.push(cell);
	            }
	        }
	        if (isInsertBelow && rowReference && rowReference.nextSibling) 
	        {
	            if(rowReference.parentNode)
	            {
	            	var parent = rowReference.parentNode;
	            	parent.insertBefore(row,rowReference.nextSibling);
	            }
	                
	        }
	        else if (!isInsertBelow && rowReference) 
	        {
	        	if(rowReference.parentNode)
	            {
	            	var parent = rowReference.parentNode;
	            	parent.insertBefore(row,rowReference);
	            }
	        }
	        else 
	        {
	        	var ref = table;
	        	if(table.tBodies && table.tBodies.length)
	        	{
	        		ref = table.tBodies[0];
	        	}
	        	ref.appendChild(row);
	        }
	        return {row: row,cells: arrRet};
	    };
		
		this.removeRow = function(table,rowIndex,callback) 
		{
			var arrRet = [];
			var arrFlatRows = getFlattenRows(table);
			var row = table.rows[rowIndex];
			var arrCells = arrFlatRows[rowIndex];
			for(var colIndex = 0;colIndex < arrCells.length;colIndex++)
			{
				var cell = arrCells[colIndex];
				var dec = false;
				if (rowIndex - 1 >= 0 && arrFlatRows[rowIndex - 1][colIndex] == cell) 
				{
	                dec = true;
	            }
				else if (arrFlatRows[rowIndex + 1] && arrFlatRows[rowIndex + 1][colIndex] === cell) 
				{
	                if (cell.parentNode == row && cell.parentNode.nextSibling) 
	                {
	                    dec = true;
	                    var nextCell = colIndex + 1;
	                    while (arrFlatRows[rowIndex + 1][nextCell] == cell) 
	                    {
	                        nextCell++;
	                    }
	                    var nextRow = util.findNextNode(cell.parentNode, function(element) 
	                    { 
	                    	return util.isElementOfType(element,"tr"); 
	                    },table,true);
	                    if (arrFlatRows[rowIndex + 1][nextCell]) 
	                    {
	                        nextRow.insertBefore(cell,arrFlatRows[rowIndex + 1][nextCell]);
	                    }
	                    else 
	                    {
	                        nextRow.appendChild(cell);
	                    }
	                }
	            }
	            else 
	            {
	            	callback && callback(cell,row,table,colIndex,rowIndex);
	            	removeNode(cell);
	            	arrRet.push(cell);
	            }
				if (dec && (cell.parentNode === row || cell !== arrFlatRows[rowIndex][colIndex - 1])) 
				{
	                var rowSpan = cell.rowSpan;
	                if (rowSpan - 1 > 1) 
	                {
	                    cell.setAttribute("rowspan", (rowSpan - 1).toString());
	                }
	                else 
	                {
	                    cell.removeAttribute("rowspan");
	                }
		        }
			}
			removeNode(row);
			return {row: row,cells: arrRet};
		};
		
		//appendColumn
		this.insertColumn = function(table,refIndex,isInsertAfter,callback)
		{
			var arrRet = [];
			var arrFlatRows = getFlattenRows(table);
	        if (util.isUndefinedOrNull(refIndex) || refIndex < 0) 
	        {
	            refIndex = getColumnsCount(table) - 1;
	        }
	        for (var rowCount = 0;rowCount < arrFlatRows.length;rowCount++) 
	        {
	            var cell = this.doc.createElement("td");
	            var refCell = arrFlatRows[rowCount][refIndex];
	            var isAdded = false;
	            if (isInsertAfter) 
	            {
	            	var newRefIndex = refIndex + 1;
	                if ((arrFlatRows[rowCount] && refCell && newRefIndex >= arrFlatRows[rowCount].length) || refCell !== arrFlatRows[rowCount][newRefIndex]) 
	                {
	                	var parent = refCell.parentNode;
	                	if(parent)
	                	{
	                		if (refCell.nextSibling) 
		                    {
	                			parent.insertBefore(cell,refCell.nextSibling);
		                    }
		                    else 
		                    {
		                    	parent.appendChild(cell);
		                    }
	                		isAdded = true;
	                	}
	                }
	            }
	            else 
	            {
	            	var newRefIndex = refIndex - 1;
	                if (newRefIndex < 0 || (arrFlatRows[rowCount][refIndex] !== arrFlatRows[rowCount][newRefIndex] && arrFlatRows[rowCount][refIndex].parentNode)) 
	                {
	                	var parent = refCell.parentNode;
	                	if(parent)
	                	{
	                		parent.insertBefore(cell,arrFlatRows[rowCount][refIndex]);
	                		isAdded = true;
	                	}
	                }
	            }
	            if(isAdded)
	            {
	            	callback && callback(cell,table,refIndex,isInsertAfter);
	            	arrRet.push(cell);
	            }
	            else 
	            {
	            	var refCell = arrFlatRows[rowCount][refIndex];
	            	var colspan = refCell.getAttribute("colspan");
	            	colspan = colspan ? parseInt(colspan,10) : 1;
	            	colspan++;
	            	refCell.setAttribute("colspan",colspan);
	            }
	        }
	        return arrRet;
		};
		
		this.removeColumn = function(table,colIndex,callback)
		{
			var arrRet = [];
			var arrFlatRows = getFlattenRows(table);
			for(var rowIndex = 0;rowIndex < arrFlatRows.length;rowIndex++)
			{
				var arrCells = arrFlatRows[rowIndex];
				var cell = arrCells[colIndex];
				var dec = false;
				if ((colIndex - 1) >= 0 && arrFlatRows[rowIndex][colIndex - 1] == cell) 
				{
	                dec = true;
	            }
	            else if ((colIndex + 1) < arrCells.length && arrFlatRows[rowIndex][colIndex + 1] == cell) 
	            {
	                dec = true;
	            }
	            else 
	            {
	            	callback && callback(cell,table,colIndex);
	            	removeNode(cell);
	            	arrRet.push(cell);
	            }
				if (dec && (rowIndex - 1 < 0 || cell !== arrFlatRows[rowIndex - 1][colIndex])) 
				{
	                var colspan = cell.colSpan;
	                colspan = (colspan - 1) > 1 ? (colspan - 1) : null;
	                if(colspan)
	                {
	                	cell.setAttribute("colspan",colspan);
	                }
	            }
			}
			return arrRet;
		};
		
		//splitVertical
		this.splitCellsVertical = function(arrCells,table)
		{
			for(var count = 0;count < arrCells.length;count++)
			{
				this.splitCellVertical(arrCells[count],table);
			}
			//Table.normalizeTable(table);
		};
		
		this.splitCellVertical = function(cell,table)
		{
			var objCell = getCoordinates(table,cell);
			 var objProp = {};
            if (cell.colSpan < 2) 
            {
            	getFlattenRows(table, function(paramCell,newRowIndex,newColIndex,colSpan,rowSpan) 
                {
                    if (objCell.rowIndex != newRowIndex && objCell.colIndex == newColIndex && paramCell != cell) 
                    {
                       storeProperties(paramCell,"colspan",paramCell.colSpan + 1, objProp);
                    }
                    return true;
                });
            }
            else 
            {
               storeProperties(cell,"colspan",cell.colSpan - 1,objProp);
            }
            var newCell = this.doc.createElement("td");
			var br = this.doc.createElement("br");
            newCell.appendChild(br);
            if (cell.rowSpan > 1) 
            {
               storeProperties(newCell,"rowspan",cell.rowSpan,objProp);
            }
            var cellWidth = cell.offsetWidth;
            util.insertAfterElement(cell,newCell);
            var calcWidth = cellWidth / table.offsetWidth / 2;
            storeProperties(cell,"width", (calcWidth * 100).toFixed(10) + '%', objProp);
            storeProperties(newCell,"width", (calcWidth * 100).toFixed(10) + '%', objProp);
            executeProperties(objProp);
            //instance(jodit).removeSelection(cell);
		};
		
		//splitHorizontal
		this.splitCellsHorizontal = function(arrCells,table)
		{
			for(var count = 0;count < arrCells.length;count++)
			{
				this.splitCellHorizontal(arrCells[count],table);
			}
			//Table.normalizeTable(table);
		};
		
		this.splitCellHorizontal = function(cell,table)
		{
			var newCell = this.doc.createElement("td");
			var br = this.doc.createElement("br");
            newCell.appendChild(br);
            var objCell = getCoordinates(table,cell);
            var objProp = {};
            if (cell.rowSpan < 2) 
            {
            	var row = util.findParent(cell,"tr");
            	var newRow = this.doc.createElement("tr");
                getFlattenRows(table, function(paramCell,newRowIndex,newColIndex,colSpan,rowSpan) 
                {
                    if (objCell.rowIndex == newRowIndex && objCell.colIndex != newColIndex && paramCell !== cell) 
                    {
                    	storeProperties(paramCell,"rowspan",paramCell.rowSpan + 1,objProp);
                    }
                    return true;
                });
                util.insertAfterElement(row,newRow);
                newRow.appendChild(newCell);
            }
            else 
            {
            	var parentRow = null;
                var afterCell = null;
            	storeProperties(cell,"rowspan",cell.rowSpan - 1,objProp);
                getFlattenRows(table, function(paramCell,newRowIndex,newColIndex,colSpan,rowSpan) 
                {
                    if (newRowIndex > objCell.rowIndex && newRowIndex < objCell.rowIndex + cell.rowSpan 
                    	&& objCell.colIndex > newColIndex && cell.parentNode.rowIndex == newRowIndex) 
                    {
                    	afterCell = paramCell;
                    }
                    if (objCell.rowIndex < newRowIndex && paramCell === cell) 
                    {
                    	parentRow = table.rows[newRowIndex];
                    }
                    return true;
                });
                if (afterCell) 
                {
                	util.insertAfterElement(afterCell,newCell);
                }
                else 
                {
                	parentRow.insertBefore(newCell,parentRow.firstChild);
                }
            }
            if (cell.colSpan > 1) 
            {
            	storeProperties(newCell,"colspan",cell.colSpan,objProp);
            }
            executeProperties(objProp);
            //instance(jodit).removeSelection(cell);
		};
		
		//__mark
		var storeProperties = function(cell,prop,propValue,objProp)
		{
			var cellID = cell.getAttribute("data-cell-util-id");
			if(!cellID)
			{
				cellID = util.getUniqueId();
				cell.setAttribute("data-cell-util-id",cellID);
			}
			if (!objProp[cellID]) 
			{
				objProp[cellID] = {cell: cell,objCellProps: {}};
	        }
			objProp[cellID].objCellProps[prop] = propValue;
		};
		
		//__unmark
		var executeProperties = function(objProp)
		{
			for(var cellID in objProp)
			{
				var cell = objProp[cellID].cell;
				var objCellProps = objProp[cellID].objCellProps;
				for(var prop in objCellProps)
				{
					var propValue =  objCellProps[prop];
					switch(prop) 
					{
	                    case "remove":
	                    	removeNode(cell);
	                    break;
	                    case "rowspan":
	                        (propValue > 1) ? cell.setAttribute("rowspan",propValue) : cell.removeAttribute("rowspan");
	                    break;
	                    case "colspan":
	                    	(propValue > 1) ? cell.setAttribute("colspan",propValue) : cell.removeAttribute("colspan");
	                    break;
	                    case "width":
	                        cell.style.width = propValue;
	                    break;
	                }
				}
				cell.removeAttribute("data-cell-util-id");
			}
		};
		
		//formalCoordinate
		var getCoordinates = function(table,cell,isMax)
		{
			isMax = Boolean.parse(isMax);
			var objRet = {rowIndex: 0,colIndex: 0,width: 1,height: 1};
			var callback = function(paramCell,newRowIndex,newColIndex,colSpan,rowSpan)
			{
				if (cell === paramCell) 
	            {
					objRet.rowIndex = newRowIndex;
					objRet.colIndex = newColIndex;
					objRet.width = colSpan || 1;
					objRet.height = rowSpan || 1;
	                if (isMax) 
	                {
	                	objRet.rowIndex += (rowSpan || 1) - 1;
	                	objRet.colIndex += (colSpan || 1) - 1;
	                }
	                return false;
	            }
				return true;
			};
	        getFlattenRows(table,callback);
	        return objRet;
		};
		
		//formalMatrix
		//returns rows and cells flattening considering colspan's and rowspan's
		// we don't need to handle hidden rows or width = 0 rows as rowIndex will handle it
		var getFlattenRows = function(table,callback) 
		{
	        var arrFlatRows = [[]];
	        if(table && table.rows)
	        {
	        	var arrRows = (table.rows.length) ? table.rows : Array.prototype.slice.call(table.rows);
	        	for(var rowCount = 0; rowCount < arrRows.length; rowCount++) 
	        	{
	        		var arrCells = (arrRows[rowCount].cells.length) ? arrRows[rowCount].cells : Array.prototype.slice.call(arrRows[rowCount].cells);
	                for(var colCount = 0; colCount < arrCells.length; colCount++) 
	                {
	                	var arrRowsTemp = getFlattenCells(arrFlatRows,table,arrCells[colCount],rowCount,callback);
	                	if(!arrRowsTemp)
	                	{
	                		return arrFlatRows;
	                	}
	                	arrFlatRows = arrRowsTemp;
	                	
	                }
	        	}
	        }
	        return arrFlatRows;
	    };
	    
	    var getFlattenCells = function(arrRows,table,cell,rowIndex,callback) 
		{
	    	if(!arrRows[rowIndex])
	    	{
	    		arrRows[rowIndex] = [];
	    	}
	    	var colSpan = cell.colSpan;
	    	var rowSpan = cell.rowSpan;
	    	var colIndex = 0;
	    	while(arrRows[rowIndex][colIndex]) 
	    	{
	    		colIndex++;
	        }
	    	for(var rowCount = 0; rowCount < rowSpan; rowCount++) 
	    	{
	            for(var colCount = 0; colCount < colSpan; colCount++) 
	            {
	                if (!arrRows[rowIndex + rowCount]) 
	                {
	                	arrRows[rowIndex + rowCount] = [];
	                }
	                var newRowIndex = rowIndex + rowCount;
	                var newColIndex = colIndex + colCount;
	                if (callback) 
	                {
	                	var value = callback(cell,newRowIndex,newColIndex,colSpan,rowSpan);
	                	if(!value)
	                	{
	                		return null;
	                	}
	                }
	                arrRows[newRowIndex][newColIndex] = cell;
	            }
	        }
	    	return arrRows;
		};
		
		var removeNode = function(node)
		{
			if (node && node.parentNode)
	    	{
	    		node.parentNode.removeChild(node);
	    	}
		};
	};
	
	return NSTableUtil;
})();
nsModuleExport(this,"NSTableUtil",NSTableUtil); var NSEditorUtil = (function()
{
	var NSEditorUtil = function(nsEditor)
	{
    	this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.selection = nsEditor.__selection;
		
		this.REGEX_BLOCK = /^(PRE|DIV|P|LI|H[1-6]|BLOCKQUOTE|TD|TH|TABLE|BODY|HTML|FIGCAPTION|FIGURE|DT|DD)$/i;
		this.REGEX_KEY_REMOVAL_TAGS = /^(IMG|BR|IFRAME|SCRIPT|INPUT|TEXTAREA|HR)$/i;
		this.REGEX_EMPTY_TAGS = /^(IMG|BR|IFRAME|SCRIPT|INPUT|TEXTAREA|HR|TABLE)$/i;
		this.SPACE_REG_EXP  = /[\s\n\t\r\uFEFF\u200b]+/g;
		this.SPACE_REG_EXP_START = /^[\s\n\t\r\uFEFF\u200b]+/g;
		this.SPACE_REG_EXP_END = /[\s\n\t\r\uFEFF\u200b]+$/g;
		this.INVISIBLE_SPACE =  '\uFEFF';
		this.INVISIBLE_SPACE_REG_EXP =  /[\uFEFF]/g;

		
		this.ZERO_WIDTH_SPACE = String.fromCharCode(8203),
		
		//isOrContains
		this.isExistsInsideEditor = function(node)
		{
			var textArea = this.__nsEditor.__getTextArea();
    		var parent = this.util.findParentByCallback(node,function(paramElement){
				return paramElement === textArea || (paramElement && paramElement.parentNode === textArea);
			},textArea);
    		return !this.util.isUndefinedOrNull(parent);
		};
		
		//closest
		this.getClosestElement = function(element,tags,root)
		{
			var condition;
	        if (typeof tags === 'function') 
	        {
	            condition = tags;
	        }
	        else if (tags instanceof RegExp) 
	        {
	            condition = function (tag) 
	            { 
	            	return tag && tags.test(tag.nodeName); 
	            };
	        }
	        else 
	        {
	            condition = function (tag) 
	            {
	                return tag && new RegExp('^(' + tags + ')$', 'i').test(tag.nodeName);
	            };
	        }
	        return this.util.findParentByCallback(element, condition, root);
		};
		
		this.isNode = function(element, win) 
		{
	        if (!element) 
	        {
	            return false;
	        }
	        if(!win)
	        {
	        	win = this.__nsEditor.__getWindow();
	        }
	        if (typeof win === 'object' && win && (typeof win.Node === 'function' || typeof win.Node === 'object')) 
	        {
	            return element instanceof win.Node;
	        }
	        return false;
	    };
		
		this.isBlock = function(element, win) 
		{
	        if(element && typeof element === "object")
	        {
	        	var isNode = this.isNode(element, win);
	        	var isBlock = this.REGEX_BLOCK.test(element.nodeName);
	        	if(isNode && !isBlock)
	        	{
	        		var display = this.util.getStyleValue(element,"display");
	        		if(display && display == "block")
	        		{
	        			isBlock = true;
	        		}
	        	}
	        	if(isNode && isBlock)
	        	{
	        		return true;
	        	}
	        }
	        return false; 
	    };
	    
	    //elementIsBlock
	    this.isTagBlock = function(tag) 
		{
	    	(tag && this.REGEX_BLOCK.test(tag));
		};
	    
	    this.isTable = function(element, win) 
	    {
	        return this.isNode(element, win) && /^(TABLE|THEAD|TBODY|TR|TH|TD)$/i.test(typeof element === 'string' ? element : element.nodeName);
	    }
		
	    this.isCell = function(element, win) 
	    {
	    	return this.isNode(element, win) && /^(td|th)$/i.test(typeof element === 'string' ? element : element.nodeName);
		};
		
		this.isImage = function(element, win) 
		{
		    return this.isNode(element, win) && /^(img|svg|picture|canvas)$/i.test(typeof element === 'string' ? element : element.nodeName);
		};
		
		//isMediaComponent
	    this.isCustomMedia = function(element)
	    {
	    	return element && (/nsEditorMediaContainerContainer/.test(element.className));
	    };
	    
	    //isComponent
	    this.isCustomMediaOrTable = function(element) 
	    {
	        return element && (this.isCustomMedia(element) || /^(TABLE|HR)$/.test(element.nodeName));
	    };

	    this.isFormatElement = function(element) 
	    {
	    	return element && element.nodeType == 1 && /^(P|DIV|H[1-6]|PRE|LI|TH|TD)$/i.test(element.nodeName) && !this.isCustomMediaOrTable(element) && !this.containsNode(element,"div");
	    };
	    
	    this.isRangeFormatElement = function(element) 
	    {
	        return element && element.nodeType === 1 && (/^(BLOCKQUOTE|OL|UL|FIGCAPTION|TABLE|THEAD|TBODY|TR|TH|TD)$/i.test(element.nodeName));
	    };
	    
	    this.isMedia = function(node) 
	    {
	        return node && /^(IMG|IFRAME|AUDIO|VIDEO|CANVAS)$/i.test(typeof node === 'string' ? node : node.nodeName);
	    };
	    
	    this.isBreak = function (node) 
	    {
	        return node && /^BR$/i.test(typeof node === 'string' ? node : node.nodeName);
	    };
	    
	    this.isList = function (node) 
	    {
	    	 return node && /^(OL|UL)$/i.test(typeof node === 'string' ? node : node.nodeName);
	    };
	    
	    this.isListCell = function (node) 
	    {
	    	return node && /^LI$/i.test(typeof node === 'string' ? node : node.nodeName);
	    };
	    
	    this.isAnchor = function(node) 
	    {
	    	return node && /^A$/i.test(typeof node === 'string' ? node : node.nodeName);
	    };
	    
	    this.trim = function(value) 
	    {
	    	return value.replace(this.SPACE_REG_EXP_END, "").replace(this.SPACE_REG_EXP_START, "");
	    };
		
		this.getOffset = function(element,recursive,doc) 
		{
			recursive = Boolean.parse(recursive);
			doc = doc ? doc : this.__nsEditor.__getDocument();
			var body = doc.body;
			var win = doc.defaultView || doc.parentWindow;
			var docElem = doc.documentElement || {clientTop: 0,clientLeft: 0,scrollTop: 0,scrollLeft: 0};
		    var scrollTop = win.pageYOffset || docElem.scrollTop || body.scrollTop;
		    var scrollLeft = win.pageXOffset || docElem.scrollLeft || body.scrollLeft;
		    var clientTop = docElem.clientTop || body.clientTop || 0;
		    var clientLeft = docElem.clientLeft || body.clientLeft || 0;
		    var topValue = null;
		    var leftValue = null;
		    var rect = element.getBoundingClientRect();
		    if(!recursive && !this.__nsEditor.__isModeTextArea())
		    {
		    	 var offset = this.getOffset(this.__nsEditor.__compTextArea,true);
		         topValue = rect.top + offset.top;
		         leftValue = rect.left + offset.left;
		    }
		    else
		    {
		    	topValue = rect.top + scrollTop - clientTop;
		        leftValue = rect.left + scrollLeft - clientLeft;
		    }
		    return {
		        top: Math.round(topValue),
		        left: Math.round(leftValue),
		        width: rect.width,
		        height: rect.height
		    };
		};
		
		this.getOffsetFromEditor = function(element,textArea,doc) 
		{
			textArea = textArea ? textArea : this.__nsEditor.__getTextArea();
			var offsetLeft = 0;
	        var offsetTop = 0;
	        var offsetElement = element.nodeType === 3 ? element.parentElement : element;

	        while (offsetElement && !this.util.hasStyleClass(offsetElement,"nsEditor") && offsetElement !== textArea) 
	        {
	            offsetLeft += offsetElement.offsetLeft;
	            offsetTop += offsetElement.offsetTop;
	            offsetElement = offsetElement.offsetParent;
	        }
	        var iframe = !this.__nsEditor.__isModeTextArea();
	        return {
	            left: offsetLeft + (iframe ? textArea.offsetLeft : 0),
	            top: (offsetTop - textArea.scrollTop) + (iframe ? textArea.parentElement.offsetTop : 0)
	        };
		};
		
		this.getContentWidth = function(element,win) 
		{
		    var getValue = function (value) 
		    {
		    	if(value)
		    	{
		    		return parseInt(value, 10);
		    	}
		    	return 0;
		    };
		    var style = win.getComputedStyle(element);
		    var width = element.offsetWidth;
		    var paddingLeft = getValue(style.getPropertyValue("padding-left"));
		    var paddingRight = getValue(style.getPropertyValue("padding-right"));
		    return (width - paddingLeft - paddingRight);

		};
		
		this.isEditable = function(element) 
		{
			element = element ? element : this.__nsEditor.__getTextArea();
	        if(element && element.nodeType === 1 && Boolean.parse(element.getAttribute("contenteditable")))
	        {
	        	return true;
	        }
	        return false;
	    };
	    
	    this.isNonEditable = function (element) 
	    {
	        return element && element.nodeType === 1 && !Boolean.parse(element.getAttribute("contenteditable"));
	    };
	    
	    this.isEmptyTextNode = function(node) 
	    {
	        if((this.util.isTextNode(node) && (!node.nodeValue || node.nodeValue.replace(this.INVISIBLE_SPACE_REG_EXP, "") .length === 0)))
	        {
	        	return true;
	        }
	        return false;
	    };
	    
	    this.isEmptyNode = function(node,regexNonEmptyTags) 
	    {
	    	if(!node) 
			{
	            return true;
	        }
			if(this.util.isTextNode(node))
			{
				return node.nodeValue === null || node.nodeValue.trim().length === 0;
			}
			regexNonEmptyTags = regexNonEmptyTags || /^(img|svg|canvas|input|textarea|form)$/;
			if(regexNonEmptyTags.test(node.nodeName.toLowerCase()))
			{
				return false;
			}
			var self = this;
			var value = this.util.loopAllChildren(node,function(paramNode) 
			{
                if ((self.util.isTextNode(paramNode) && paramNode.nodeValue !== null &&
                    paramNode.nodeValue.trim().length !== 0) ||
                    (self.util.isElement(paramNode) && regexNonEmptyTags.test(paramNode.nodeName.toLowerCase()))) 
                {
                    return false;
                }
            });
			return value;
	    };
	    
	    //to find whether element is a node related to the text style
	    this.isTextStyleElement = function (element) 
	    {
	        return element && element.nodeType !== 3 && /^(strong|span|font|b|var|i|em|u|ins|s|strike|del|sub|sup|mark|a|label|code)$/i.test(element.nodeName);
	    };
	    
	    this.getCharLength = function(content,charCounterType) 
	    {
            return /byte/.test(charCounterType) ? this.getByteLength(content) : content.length;
        }
	    
	    this.getByteLength = function(strExp) 
	    {
	    	var win = this.__nsEditor.__getWindow();
	    	var browserDetail = this.__nsEditor.__browserDetail;
	        var encoder = win.encodeURIComponent;
	        var cr = 0;
	        var cl;
	        //edge
	        if (browserDetail.isIE && !browserDetail.isMSIE) 
	        {
	            cl = win.unescape(encoder(strExp.toString())).length;
	            if (encoder(strExp.toString()).match(/(%0A|%0D)/gi) !== null) 
	            {
	                cr = encoder(strExp.toString()).match(/(%0A|%0D)/gi).length;
	            }
	        } 
	        else 
	        {
	            cl = (new win.TextEncoder('utf-8').encode(strExp.toString())).length;
	        }
	        if (encoder(strExp.toString()).match(/(%0A|%0D)/gi) !== null) 
            {
                cr = encoder(strExp.toString()).match(/(%0A|%0D)/gi).length;
            }
            return cl + cr;
	    }
	    
	    this.compareElements = function(element1, element2) 
	    {
	    	var objRet = {};
	        var ele1 = element1;
	        var bNode = element2;
	        while (ele1 && ele2 && ele1.parentNode !== ele2.parentNode) 
	        {
	            ele1 = ele1.parentNode;
	            ele2 = ele2.parentNode;
	        }
	        if (!ele1 || !ele2) 
	        {
	        	objRet = {ancestor: null,element1: element1,element2: element2, result: 0};
	        }
	        else 
	        {
	        	var children = ele1.parentNode.childNodes;
		        var aIndex = this.getIndexFromArray(children, ele1);
		        var bIndex = this.getIndexFromArray(children, ele2);
		        var result = aIndex > bIndex ? 1 : aIndex < bIndex ? -1 : 0;
		        objRet = {ancestor: ele1.parentNode,element1: element1,element2: element2,result: result};
	        }
	        return objRet;
	    };
	    
	    this.getIndexFromArray = function(arrData,value) 
	    {
	    	var index = arrData.findIndex(function(paramValue,index,arr){
	    		if(paramValue == value)
	    		{
	    			return true;
	    		}
	    	});
	    	return index;
	    };
	    
	    this.setElementPosition = function(controller, referEl, position, offset)
	    {
	    	var rtl = false;
	    	offset = offset ? offset :  {left: 0, top: 0};
	    	var body = this.__nsEditor.__getTextArea();
	    	if (rtl)
	    	{
	    		offset.left *= -1;
	    	}
            var offset = this.getOffsetFromEditor(referEl,body);
            controller.style.visibility = 'hidden';
            controller.style.display = 'block';

            // Height value of the arrow element is 11px
            var topMargin = position === 'top' ? -(controller.offsetHeight + 2) : (referEl.offsetHeight + 12);
            controller.style.top = (offset.top + topMargin + offset.top) + 'px';

            var l = offset.left - body.scrollLeft + offset.left;
            var controllerW = controller.offsetWidth;
            var referElW = referEl.offsetWidth;

            // rtl (Width value of the arrow element is 22px)
            if (rtl) 
            {
                var rtlW = (controllerW > referElW) ? controllerW - referElW : 0;
                var rtlL = rtlW > 0 ? 0 : referElW - controllerW;
                controller.style.left = (l - rtlW + rtlL) + 'px';
                
                if (rtlW > 0) 
                {
                    controller.firstElementChild.style.left = ((controllerW - 14 < 10 + rtlW) ? (controllerW - 14) : (10 + rtlW)) + 'px';
                }
                
                var overSize = body.offsetLeft - controller.offsetLeft;
                if (overSize > 0) 
                {
                    controller.style.left = '0px';
                    controller.firstElementChild.style.left = overSize + 'px';
                }
            } 
            else 
            {
                controller.style.left = l + 'px';

                var overSize = body.offsetWidth - (controller.offsetLeft + controllerW);
                if (overSize < 0) 
                {
                    controller.style.left = (controller.offsetLeft + overSize) + 'px';
                    //controller.firstElementChild.style.left = (20 - overSize) + 'px';
                } 
                else 
                {
                    //controller.firstElementChild.style.left = '20px';
                }
            }

            controller.style.visibility = '';
	    };
	    
	    this.stopEvent = function(event)
	    {
	    	event = this.util.getEvent(event);
	    	event.preventDefault();
	    	event.stopPropagation();
	    	event.stopImmediatePropagation();
	    };
	    
	    //isWysiwygDiv
	    this.containsNode = function (node,type) 
	    {
	    	if(node)
	    	{
	    		var textArea = this.__nsEditor.__getTextArea();
	    		if(textArea.contains(node))
	    		{
	    			if(type)
	    			{
	    				return this.util.isElementOfType(node,type);
	    			}
	    			else
	    			{
	    				return true;
	    			}
	    		}
	    	}
	        return false;
	    };
	    
	    this.onlyZeroWidthSpace = function(text) 
	    {
	    	var onlyZeroWidthRegExp = new RegExp('^' + String.fromCharCode(8203) + '+$');
	        if (typeof text !== 'string')
	        {
	        	text = text.textContent;
	        }
	        return text === '' || onlyZeroWidthRegExp.test(text);
	    };
	    
	    this.getFormatElement = function(element,callback) 
	    {
	        if (element)
	        {
		        while (element) 
		        {
		            if (this.containsNode(element,"div"))
		            {
		            	return null;
		            }
		            if (this.isRangeFormatElement(element))
		            {
		            	element.firstElementChild;
		            }
		            if (this.isFormatElement(element))
		            {
		            	if(!callback || callback(element))
		            	{
		            		return element;
		            	}
		            }
		            element = element.parentNode;
		        }
	        }
	        return null;
	    };
	    
	    //safeRemove
	    this.removeNode = function(node) 
	    {
	    	if (node && node.parentNode)
	    	{
	    		node.parentNode.removeChild(node);
	    	}
	    };
	    
	    this.isIgnoreNodeChange = function (element) 
	    {
	        return element && element.nodeType !== 3 && (this.isNonEditable(element) || !this.isTextStyleElement(element));
	    };
	    
	    //wrap
	    this.wrapNode = function(currentNode,newParent)
	    {
			if(currentNode.parentNode) 
			{
				var doc = this.__nsEditor.__getDocument();
				var wrapper = this.util.isString(newParent) ? this.util.createElement(tag,null,null,doc) : newParent;
				this.selection.saveSelection();
				currentNode.parentNode.insertBefore(wrapper,currentNode);
				wrapper.appendChild(currentNode);
				this.selection.restoreSelection();
				return wrapper;
			}
	    };
	    
	    //wrapInline
	    this.wrapAllInlineSiblings = function (node,tag) 
	    {
	    	this.selection.saveSelection();
	    	var doc = this.__nsEditor.__getDocument();
	    	var win = this.__nsEditor.__getWindow();
	    	var textArea = this.__nsEditor.__getTextArea();
	        var startNode = node;
	        var endNode = node;
	        var findNext = false;
	        do 
	        {
	            findNext = false;
	            var tmpNode = startNode.previousSibling;
	            if (tmp && !this.isBlock(tmp,win)) 
	            {
	                findNext = true;
	                startNode = tmpNode;
	            }
	        } 
	        while(findNext);
	        do 
	        {
	            findNext = false;
	            var tmpNode = endNode.nextSibling;
	            if (tmpNode && !this.isBlock(tmp,win)) 
	            {
	                findNext = true;
	                endNode = tmpNode;
	            }
	        } 
	        while(findNext);
	        var parent = this.util.isString(tag) ? doc.createElement(tag) : tag;
	        if (startNode.parentNode) 
	        {
	            startNode.parentNode.insertBefore(parent,startNode);
	        }
	        var nextNode = startNode;
	        while(nextNode) 
	        {
	        	nextNode = startNode.nextSibling;
	            parent.appendChild(startNode);
	            if (startNode === endNode || !nextNode) 
	            {
	                break;
	            }
	            startNode = nextNode;
	        }
	        this.selection.restoreSelection();
	        return parent;
	    };
	    
	    //normalizeNode
	    this.mergeTextNodes = function(node)
	    {
	    	if(node)
	    	{
	    		if (this.util.isTextNode(node) && node.nodeValue != null && node.parentNode) 
	    		{
	    			while (this.util.isTextNode(node.nextSibling)) 
	    			{
	    				if (node.nextSibling.nodeValue != null) 
	    				{
	    					node.nodeValue += node.nextSibling.nodeValue;
	    				}
	    				node.nodeValue = node.nodeValue.replace(this.INVISIBLE_SPACE_REG_EXP,"");
	    				this.removeNode(node.nextSibling);
	    			}
	    		} else 
	    		{
	    			this.mergeTextNodes(node.firstChild);
	    		}
	    		this.mergeTextNodes(node.nextSibling);
	    	}
	    };
	    
	    this.insertNodeWrappingRange = function(node)
	    {
	    	if(node)
	    	{
	    		if(!this.selection)
	    		{
	    			this.selection = this.__nsEditor.__selection;
	    		}
	    		if(this.selection.isCollapsed())
				{
					this.selection.insertNode(node,false,false);
				}
				else
				{
					var range = this.selection.getRange();
					var fragment = range.extractContents();
					node.appendChild(fragment);
					range.insertNode(node);
				}
	    	}
	    }
	    
    };
	
	return NSEditorUtil;
})();
nsModuleExport(this,"NSEditorUtil",NSEditorUtil); var NSToolBar = (function()
{
	var NSToolBar = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		this.selection = nsEditor.__selection;
		
		this.__parentContainer = null;
		this.__divToolBarContainer = null;
		this.__divToolBarContent = null;
		this.__editorDropDown = null;
		
		this.__groupedContainer = null;
		this.__btnGrouped = null;
		this.__groupedContainerDropdown = null;
		this.__groupedContainerDropdownContent = null;
		
		this.__nsToolTipInElement = null;
		this.__config = null;
		this.__toolBarPadding = null;
		this.__groupedTools = [];
		
		this.__windowClickRef = null;
		
		this.__arrowSVG = "<svg class=\"nsEditorIcon nsEditorIconArrow\" viewBox=\"0 0 10 10\"><path d=\"M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z\"></path></svg>"
		
		this.__initialize = function()
		{
			var self = this;
			this.__nsEditor.__listenInternalEvent("resize",this.__resizeHandler.bind(this));
			this.__nsEditor.__listenInternalEvent("lineNumberVisibilityChanged",function(event){
				self.__divToolBarContainer.style.paddingLeft = (self.__nsEditor.__divLineNumberContainer.offsetWidth + 10) + "px";
			});
			this.__nsEditor.__listenInternalEvent("iframeInitialized",function(event){
				if(self.__nsEditor.__frameContentWindow)
				{
					self.util.addEvent(self.__nsEditor.__frameContentWindow,"click",self.__windowClickRef);
				}
			});
			this.__nsEditor.__listenInternalEvent("viewSourceChanged",function(event){
				var isDefaultDisabled = event.detail.isSourceMode;
				var item = event.detail.item;
				var key = event.detail.key;
				var arrKeys = Object.keys(self.__nsEditor.__toolBarButton);
				for(var count = 0;count < arrKeys.length;count++)
				{
					var itemKey = arrKeys[count];
					var toolBarItem = self.__nsEditor.__toolBarButton[itemKey];
					if(item != toolBarItem)
					{
						var disabled = toolBarItem.checkDisability ? toolBarItem.checkDisability(itemKey,toolBarItem,item,key,isDefaultDisabled) : true;
						self.__makeToolBarItemDisabled(toolBarItem,(isDefaultDisabled ? disabled : !disabled));
					}
				}
			});
			this.__nsEditor.__listenInternalEvent("textAreaInitialized",function(event){
				setTimeout(function()
				{
					self.__updateToolBarGrouping.call(self)
				}, 500)
			});
		};
		
		this.getToolBarContainer = function()
		{
			return this.__divToolBarContainer;
		};
		
		this.createToolBar = function()
		{
			this.__parentContainer = this.__nsEditor.__divOuterContainer;
			this.__config = this.__nsEditor.__config;
			this.__nsToolTipInElement = new this.util.nsToolTipInElement();
			this.__divToolBarContainer = this.util.createDiv(this.__nsEditor.getID() + "toolbarcontainer","nsEditorToolBarContainer");
			this.__parentContainer.appendChild(this.__divToolBarContainer);
			this.__divToolBarContent = this.util.createDiv(this.__nsEditor.getID() + "toolbarcontent","nsEditorToolBarContent");
			this.__divToolBarContainer.appendChild(this.__divToolBarContent);
			if(this.__config["enableToolBar"])
			{
				this.__createToolBarComponents();
			}
			else
			{
				this.__nsEditor.__handleVisibilityOfComponent(this.__divToolBarContainer,"enableToolBar");
			}
			this.__initSticy();
			if(!this.__windowClickRef)
			{
				this.__windowClickRef = this.__windowClickHandler.bind(this);
				this.util.addEvent(this.__nsEditor.__context,"click",this.__windowClickRef);
			}
			this.__editorDropDown =  this.util.createElement("ul",this.__nsEditor.getID() + "dropDown","nsEditorToolBarDropdown");
			this.__nsEditor.__compFixed.appendChild(this.__editorDropDown);
		};
		
		this.updateToolbar = function(element)
		{
			var self = this;
			var checkForTags = function(arrTags,item)
			{
				if(arrTags && arrTags.length > 0)
				{
					var tempElement = element;
					while (tempElement && tempElement.nodeType == 1) 
					{
						if (arrTags.indexOf(tempElement.tagName.toLowerCase()) > -1) 
						{
							self.__makeToolBarItemActive(item,true);
						}
						tempElement = tempElement.parentNode;
					}
				}
			};
			var checkForCSS = function(objCSS,item)
			{
				if(objCSS)
				{
					var tempElement = element;
					while (tempElement && tempElement.nodeType == 1) 
					{
						var arrCSS = Object.keys(objCSS);
						for(var cssCount = 0;cssCount < arrCSS.length;cssCount++)
						{
							if(isCSSValuePresentInElement(arrCSS[cssCount],objCSS[arrCSS[cssCount]]))
							{
								self.__makeToolBarItemActive(item,true);
							}
						}
						tempElement = tempElement.parentNode;
					}
					self.__nsEditor.__selection.setFocus();
				}
			};
			var isCSSValuePresentInElement = function(property,value)
			{
				var cssValue = self.util.getStyleValue(element,property);
				if(cssValue)
				{
					if(typeof (value) === "function")
					{
						var callback = value;
						if(callback && callback(cssValue.toString().toLowerCase()))
						{
							return true;
						}
					}
					else if(cssValue.toString().toLowerCase() === value)
					{
						return true;
					}
				}
				return false;
			};
			
			var arrKeys = Object.keys(this.__nsEditor.__toolBarButton);
			for(var count = 0;count < arrKeys.length;count++)
			{
				var key = arrKeys[count];
				var item = this.__nsEditor.__toolBarButton[key];
				this.__makeToolBarItemActive(item,false);
				var arrTags = item.tags;
				checkForTags(arrTags,item);
				var css = item.css;
				checkForCSS(css,item);
			}
		};
		
		this.destroy = function() 
		{
			if(this.__stickyScrollRef)
	    	{
	    		this.util.removeEvent(this.__nsEditor.__context,"scroll wheel mousewheel",this.__stickyScrollRef);
	    		this.__stickyScrollRef = null;
	    	}
			if(this.__windowClickRef)
			{
				this.util.removeEvent(this.__nsEditor.__context,"click",this.__windowClickRef);
				if(this.__nsEditor.__frameContentWindow)
				{
					this.util.removeEvent(this.__nsEditor.__frameContentWindow,"click",this.__windowClickRef);
				}
				this.__windowClickRef = null;
			}
		};
		
		this.__createToolBarComponents = function()
		{
			this.util.removeAllChildren(this.__divToolBarContent);
			if(this.__config["toolBarButton"] && this.__config["toolBarButton"].length > 0)
			{
				for(var count = 0;count < this.__config["toolBarButton"].length;count++)
				{
					var key = this.__config["toolBarButton"][count];
					if(this.__nsEditor.__toolBarButton[key])
					{
						this.__createToolBarButton(this.__nsEditor.__toolBarButton[key],this.__divToolBarContent,key);
						this.__updateShortKeyDictionary(this.__nsEditor.__toolBarButton[key],this.__divToolBarContent,key);
					}
				}
			}
		};
		
		this.__createToolBarButton = function(item,parent,key)
		{
			if(item)
			{
				var self = this;
				var btnItem =  this.util.createElement("button",null,"nsEditorToolBarButton");
				btnItem.innerHTML = item.html;
				if(item.tooltip && item.tooltip.length > 0)
				{
					this.__nsToolTipInElement.addToolTip(btnItem,item.tooltip);
				}
				if(item.isDropdown)
				{
					this.util.addStyleClass(btnItem,"nsEditorToolBarButtonDropdown");
					btnItem.appendChild(this.util.getElementFromHtml(this.__arrowSVG));
					this.util.addEvent(btnItem,"click",(function(item){
						return function(event){
							self.__toolBarDropdownClickHandler.call(self,item,key,event);
						};
					})(item));
				}
				else
				{
					this.util.addEvent(btnItem,"click",(function(item){
						return function(event){
							self.__toolBarButtonClickHandler.call(self,item,key,event);
						};
					})(item));
				}
				if(parent)
				{
					parent.appendChild(btnItem);
				}
				item.control = btnItem;
				item.selected = false;
				return btnItem;
			}
			return null;
		};
		
		this.__updateShortKeyDictionary = function(item,parent,key)
		{
			if(item)
			{
				if(item.shortKey)
				{
					var shortKey = item.shortKey;
					if(!this.util.isArray(shortKey))
					{
						shortKey = [shortKey];
					}
					for(var count = 0;count < shortKey.length;count++)
					{
						var tempKey = shortKey[count].toLowerCase();
						if(this.__nsEditor.__objShortKey[tempKey])
						{
							this.util.warning("NSEditor",tempKey + " has already been assigned to " + this.__nsEditor.__objShortKey[tempKey].key + ". It will overriden by " + key + ".")
						}
						this.__nsEditor.__objShortKey[tempKey] = {item: item,parent: parent,key: key};
					}
				}
				var arrItem = item.dataSource;
				if(arrItem && arrItem.length > 0)
				{
					for(var count = 0;count < arrItem.length;count++)
					{
						var childItem = arrItem[count];
						if(childItem.hasOwnProperty("htmlKey"))
						{
							childItem = this.__nsEditor.__toolBarButton[childItem["htmlKey"]];
						}
						if(childItem)
						{
							this.__updateShortKeyDictionary(childItem,item,childItem.value);
						}
					}
				}
			}
		}
		
		this.__makeToolBarItemActive = function(item,isActive)
		{
			if(item && this.__nsEditor.__config.enableToolBarActive)
			{
				item.selected = isActive;
				if(item.control)
				{
					isActive ? this.util.addStyleClass(item.control,"nsEditorToolBarItemActive") : this.util.removeStyleClass(item.control,"nsEditorToolBarItemActive");
				}
			}
		};
		
		this.__makeToolBarItemDisabled = function(item,isDisabled)
		{
			if(item)
			{
				item.selected = false;
				item.disabled = isDisabled;
				if(item.control)
				{
					isDisabled ? this.util.addStyleClass(item.control,"nsEditorToolBarButtonDisabled") : this.util.removeStyleClass(item.control,"nsEditorToolBarButtonDisabled");
				}
			}
		};
		
		this.__createToolBarDropdown = function(parentItem,key,event)
		{
			var arrItem = parentItem.dataSource;
			if(arrItem && arrItem.length > 0)
			{
				var self = this;
				this.util.removeAllChildren(this.__editorDropDown);
				for(var count = 0;count < arrItem.length;count++)
				{
					var item = arrItem[count];
					var value = item.value;
					if(item.hasOwnProperty("htmlKey"))
					{
						item = this.__nsEditor.__toolBarButton[item["htmlKey"]];
					}
					if(item)
					{
						var child = this.util.createElement("li",null,"nsEditorToolBarDropdownItem");
						child.innerHTML = item.html;
						child.setAttribute("data-nsEditor-value",value);
						this.util.addEvent(child,"click",(function(item){
							return function(event){
								self.__toolBarButtonClickHandler.call(self,item,key,event);
							};
						})(item));
						this.__editorDropDown.appendChild(child);
					}
				}
				this.__placeElementByEvent(this.__editorDropDown,event,{left: -22,top: 15});
				return this.__editorDropDown;
			}
			return null;
		};
		
		this.__toolBarDropdownClickHandler = function(item,key,event)
		{
			var dropdown = this.__createToolBarDropdown(item,event);
			if(dropdown)
			{
				this.__showToolBarDropdown(dropdown);
				this.editorUtil.stopEvent(event);
			}
		};
		
		this.__toolBarButtonClickHandler = function(item,key,event)
		{
			if(item)
			{
				if(!this.__nsEditor.getDisabled())
				{
					if(item.command)
					{
						this.__nsEditor.__executeCommand(item.command,item,key);
					}
					if(item.click)
					{
						item.click(item,key,event);
					}
					this.__makeToolBarItemActive(item,true);
				}
			}
		};
		
		this.__windowClickHandler = function(event)
		{
			//if(this.hasFocus())
			//{
				if (!this.util.hasStyleClass(event.target,"nsEditorToolBarButtonDropdown")) 
				{
					this.__hideToolBarDropdown();
				}
				this.__hideGroupedPopUp();
			//}
		};
		
		this.__showToolBarDropdown = function(dropdown)
		{
			if(!this.__isToolBarDropdownVisible())
			{
				dropdown = dropdown || this.__editorDropDown;
				var con = this.__isGroupedPopUpVisible() ? null : this.__parentContainer;
				var maxZIndex = this.util.getMaxZIndex(con);
				if(maxZIndex > 0)
				{
					var parent = dropdown.parentNode;
					parent.style.zIndex = maxZIndex + 1;
					dropdown.style.zIndex = maxZIndex + 1;
				}
				this.util.addStyleClass(dropdown,"nsEditorToolBarDropdownShow");
			}
		};
		
		this.__hideToolBarDropdown = function(dropdown)
		{
			dropdown = dropdown || this.__editorDropDown;
			this.util.removeStyleClass(dropdown,"nsEditorToolBarDropdownShow");
			var parent = dropdown.parentNode;
			parent.style.zIndex = "";
			dropdown.style.zIndex = "";
		};
		
		this.__isToolBarDropdownVisible = function(dropdown)
		{
			dropdown = dropdown || this.__editorDropDown;
			return this.util.hasStyleClass(dropdown,"nsEditorToolBarDropdownShow");
		};
		
		this.__resizeHandler = function(event)
		{
			var origEvent = event.originalEvent;
			this.__hideToolBarDropdown();
			this.__hideToolBarDropdown();
			this.__updateToolBarGrouping();
			this.__stickyScrollHandler(event);
		};
		
		this.__updateToolBarGrouping = function()
		{
			if (this.__divToolBarContainer && this.__divToolBarContainer.parentNode) 
			{
				var beforeGroupedTools = this.__groupedTools.length;
				var hasToolGrouped = false;

				while(this.__isToolbarOverflowing()) 
				{
					this.__groupLastTool();
					hasToolGrouped = true;
				}
				if (!hasToolGrouped && this.__groupedTools.length) 
				{
					while(this.__groupedTools.length && !this.__isToolbarOverflowing()) 
					{
						this.__ungroupFirstTool();
					}
					if (this.__isToolbarOverflowing()) 
					{
						this.__groupLastTool();
					}
				}
				if (this.__groupedTools.length !== beforeGroupedTools) 
				{
					this.__nsEditor.__dispatchInternalEvent("toolbarUpdate");
				}
			}
			this.__createHorizontalSeparator
		};
		
		this.__isToolbarOverflowing = function()
		{
			var win = this.__nsEditor.__getWindow();
			var arrToolBar = this.__nsEditor.__config.toolBarButton;
			var retValue = false;
			if(win && arrToolBar && arrToolBar.length) 
			{
				//uiDirection for later use
				var uiDir = "ltr";
				var toolbarRect = this.__divToolBarContainer.getBoundingClientRect();
				var lastChildRect = this.__divToolBarContainer.lastChild.getBoundingClientRect();
				if (!this.__toolBarPadding) 
				{
					var cssProperty = (uiDir == "ltr") ? "paddingRight" : "paddingLeft";
					//this.__toolBarPadding = this.util.getStyleValue(this.__divToolBarContainer,cssProperty,false,true,win);
					var computedStyle = win.getComputedStyle(this.__divToolBarContainer);
					this.__toolBarPadding = parseInt(computedStyle[cssProperty]);
				}
				if (uiDir == "ltr") 
				{
					//console.log(lastChildRect.right + " > " + (toolbarRect.right - this.__toolBarPadding));
					retValue = (lastChildRect.right) > (toolbarRect.right - this.__toolBarPadding);
				} 
				else 
				{
					retValue = lastChildRect.left < toolbarRect.left + this.__toolBarPadding;
				}
			}
			return retValue;
		};
		
		this.__groupLastTool = function()
		{
			if (!this.__groupedTools.length) 
			{
				this.__divToolBarContainer.appendChild(this.__getOverflowContainer());
			}
			var arrItem = this.__divToolBarContent.querySelectorAll(".nsEditorToolBarButton");
			if(arrItem && arrItem.length)
			{
				var btnItem = arrItem[arrItem.length - 1];
				this.__addToolInParent(btnItem,this.__groupedContainerDropdownContent,true);
				this.__groupedTools.unshift(btnItem);
				this.__refreshDividerInGroupedContent();
			}
		};
		
		this.__ungroupFirstTool = function()
		{
			var btnItem = this.__groupedTools[0];//this.__groupedContainerDropdownContent.querySelectorAll(".nsEditorToolBarButton")[0];
			this.__addToolInParent(btnItem,this.__divToolBarContent,false);
			this.__groupedTools.splice(0,1);
			if (!this.__groupedTools.length) 
			{
				this.__divToolBarContainer.removeChild(this.__getOverflowContainer());
			}
			//this.__refreshDividerInGroupedContent();
		};
		
		this.__getOverflowContainer = function()
		{
			if(!this.__groupedContainer)
			{
				this.__groupedContainer = this.util.createDiv(null,"nsEditorToolBarOveflowCon");
				this.__btnGrouped =  this.util.createElement("button",null,"nsEditorToolBarButton");
				this.__btnGrouped.innerHTML = "<i class='ns-icon ns-editor-vertical-dots' aria-hidden='true'></i>"; 
				this.__nsToolTipInElement.addToolTip(this.__btnGrouped,"Show Tools");
				this.__groupedContainer.appendChild(this.__btnGrouped);
				this.util.addEvent(this.__btnGrouped,"click",this.__handleOverflowClick.bind(this));
				var content = "<div class=\"nsEditorToolBarOveflowDropdown\">\r\n" + 
						"	<div class=\"nsEditorToolBarOveflowDropdownToolbar\">\r\n" + 
						"		<div class=\"nsEditorToolBarOveflowDropdownContent\">\r\n" + 
						"		</div>\r\n" + 
						"	</div>\r\n" + 
						"</div>";
				this.__groupedContainerDropdown = this.util.getElementFromHtml(content);
				this.__nsEditor.__compFixed.appendChild(this.__groupedContainerDropdown);
				this.__groupedContainerDropdownContent = this.__groupedContainerDropdown.querySelector(".nsEditorToolBarOveflowDropdownContent");
			}
			return this.__groupedContainer;
		};
		
		this.__refreshDividerInGroupedContent = function()
		{
			var arrItem = this.__groupedContainerDropdownContent.querySelectorAll(".nsEditorToolBarHorizontalSeparator");
			for(var count = arrItem.length - 1;count > -1;count--)
			{
				this.__groupedContainerDropdownContent.removeChild(arrItem[count]);
			}
			arrItem = this.__groupedContainerDropdownContent.querySelectorAll(".nsEditorToolBarButton");
			var afterElement = 3;
			for(var count = afterElement - 1;count < arrItem.length;count = count + afterElement)
			{
				var btn = arrItem[count];
				var div = this.util.createDiv(null,"nsEditorToolBarHorizontalSeparator");
				this.util.insertAfterElement(btn,div);
			}
		};
		
		this.__addToolInParent = function(btnItem,parent,isFirst)
		{
			isFirst ? parent.insertBefore(btnItem,parent.firstChild) : parent.appendChild(btnItem);
		};
		
		this.__handleOverflowClick = function(event)
		{
			this.__isGroupedPopUpVisible() ? this.__hideGroupedPopUp() : this.__showGroupedPopUp();
			this.editorUtil.stopEvent(event);
		};
		
		this.__showGroupedPopUp = function()
		{
			if(!this.__isGroupedPopUpVisible())
			{
				var con = this.__groupedContainerDropdown;
				this.util.addStyleClass(con,"nsEditorToolBarOveflowDropdownVisible");
				var rect = this.__groupedContainerDropdownContent.getBoundingClientRect();
				con.style.width = rect.width + "px";
				//console.log(con.getBoundingClientRect().width + " == " + this.__groupedContainerDropdownContent.getBoundingClientRect().width);
				this.__placeElementByEvent(con,event,{left: (-1 * rect.width) ,top: ((this.__btnGrouped.getBoundingClientRect().height) / 2)});
				var maxZIndex = this.util.getMaxZIndex(this.__parentContainer);
				if(maxZIndex > 0)
				{
					var parent = con.parentNode;
					parent.style.zIndex = maxZIndex + 1;
					con.style.zIndex = maxZIndex + 2;
				}
			}
		};
		
		this.__hideGroupedPopUp = function()
		{
			if(this.__groupedContainerDropdown)
			{
				var con = this.__groupedContainerDropdown;
				this.util.removeStyleClass(con,"nsEditorToolBarOveflowDropdownVisible");
				con.style.width = "";
				var parent = con.parentNode;
				parent.style.zIndex = "";
				con.style.zIndex = "";
			}
		};
		
		this.__isGroupedPopUpVisible = function()
		{
			return this.util.hasStyleClass(this.__groupedContainerDropdown,"nsEditorToolBarOveflowDropdownVisible");
		};
		
		//part for sticky header
	    
	    this.__stickyScrollRef = null;
	    this.__compDuplicate = null;
	    this.__isSticked = false;
	    this.__initSticy = function () 
		{
	    	if(!this.__stickyScrollRef)
	    	{
	    		this.__stickyScrollRef = this.__stickyScrollHandler.bind(this);
	    		this.util.addEvent(this.__nsEditor.__context,"scroll wheel mousewheel",this.__stickyScrollRef);
	    	}
		};
		
		this.__stickyScrollHandler = function (event) 
		{
			//event = this.util.getEvent(event);
			var win = this.__nsEditor.__context;
			var doc = this.__nsEditor.__dom.doc;
			var container = this.__parentContainer;
			var scrollTop = win.pageYOffset || (doc.documentElement && doc.documentElement.scrollTop) || 0;
			var offsetEditor = this.editorUtil.getOffset(container,true,doc);
			var hasScroll = (scrollTop > offsetEditor.top && scrollTop  < offsetEditor.top + offsetEditor.height);
			var enableInMobile = this.__config.enableStickyToolbarForMobile && this.__isDeviceMobile();
			var performSticky = !this.__isSourceMode && hasScroll && !enableInMobile;
			if(this.__config.enableStickyToolbar && this.__config.enableToolBar)
			{
				if(performSticky)
				{
					this.__makeSticky(this.__divToolBarContainer);
				}
				else
				{
					this.__removeSticky(this.__divToolBarContainer);
				}
				this.__nsEditor.__dispatchInternalEvent("stickyChanged",{isSticky: performSticky},{isSticky: performSticky});
			}
		};
		
		this.__isDeviceMobile = function() 
		{
			return false;
		};
		
		this.__makeSticky = function(comp) 
		{
			var container = this.__parentContainer;
			if(!this.__isSticked)
			{
				this.__createDuplicate(comp);
				this.util.addStyleClass(container,"nsEditorSticky");
				this.__isSticked = true;
			}
			var style = {top: 0,width: container.offsetWidth};
			this.util.css(comp,style);
			if(this.__nsEditor.__browserDetail.isMSIE && this.__compDuplicate)
			{
				style = {height: comp.offsetHeight};
				this.util.css(this.__compDuplicate,style);
			}
		};
		
		this.__removeSticky = function(comp) 
		{
			if(this.__isSticked)
			{
				var container = this.__parentContainer;
				var style = {top: "",width: ""};
				this.util.css(comp,style);
				this.util.removeStyleClass(container,"nsEditorSticky");
				this.__isSticked = false;
			}
		};
		
		this.__createDuplicate = function(comp) 
		{
			if(this.__nsEditor.__browserDetail.isMSIE && !this.__compDuplicate)
			{
				this.__compDuplicate = this.util.createDiv(null,"nsEditorStickyToolbar");
				comp.parentNode.insertBefore(this.__compDuplicate,comp);
			}
		};
		
		this.isToolbarSticky = function() 
		{
			return this.util.hasStyleClass(this.__parentContainer,"nsEditorSticky");
		};
	    
	    //end of sticky header
		
		this.__createHorizontalSeparator = function()
		{
			var comp = this.util.createElement("span",null,"nsEditorToolBarVerticalSeparator");
			return comp;
		};
		
		this.__placeElementByEvent = function(element,event,posOffset)
		{
			posOffset = posOffset || {left: 0,top: 0};
			var offset = this.util.getEventPosition(event);
			element.style.left = (offset.left + (posOffset.left * 1)) + "px";
			element.style.top = (offset.top + (posOffset.top * 1)) + "px";
		};
		
		this.__initialize();
	};
		
	return NSToolBar;
})();
nsModuleExport(this,"NSToolBar",NSToolBar); var NSSelection = (function()
{
	var NSSelection = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.__savedSelection = null;
		
		this.__initialize = function()
		{
			
		};
		
		/* Start of selection function */
		this.getSelection = function() 
		{
			if(this.__nsEditor.__isModeTextArea())
			{
				if (this.__nsEditor.__context.getSelection) 
				{
					return this.__nsEditor.__context.getSelection();
				} 
				else if (this.__nsEditor.__dom.doc.selection) 
				{
				   return this.__nsEditor.__dom.doc.selection;
				}
			}
			else
			{
				var contentWindow = this.__nsEditor.__compTextArea.contentWindow;
				if (contentWindow) 
				{
					if (contentWindow.getSelection) 
					{
						return contentWindow.getSelection();
					}
					if (contentWindow.selection) 
					{
						return contentWindow.selection;
					}
				}
				var doc = this.__frameContentDoc;
				if (doc.getSelection) 
				{
					return doc.getSelection();
				}
				if (doc.selection) 
				{
					return doc.selection;
				}
			}
			return null;
		};
		
		//restore
	    this.restoreSelection = function(objSaved) 
		{
	    	objSaved = objSaved || this.__savedSelection;
	    	if(objSaved)
	    	{
	    		if(objSaved instanceof Range)
	    		{
	    			var selection = null;
					var self = this;
					var setTextRange = function(win,doc)
					{
						if(win.getSelection || doc.createRange) 
						{
							selection = win.getSelection();
					        try 
					        {
					        	selection.removeAllRanges();
					        } 
					        catch (error) 
					        {
					        	doc.body.createTextRange().select();
					        	if(doc.selection)
					        	{
					        		doc.selection.empty();
					        	}
					        }
					        selection.addRange(objSaved);
						}
						else if (doc.selection) 
						{
							objSaved.select();
						}
					};
					if(this.__nsEditor.__isModeTextArea())
					{
						setTextRange(this.__nsEditor.__context,this.__nsEditor.__dom.doc);
					}
					else
					{
						setTextRange(this.__nsEditor.__frameContentWindow,this.__nsEditor.__frameContentDoc);
					}
	    		}
	    		else if(this.util.isArray(objSaved))
	    		{
	    			var range = null;
	    			for(var count = 0;count < objSaved.length;count++) 
					{
	    				var item = objSaved[count];
	    				var start = item.start;
	    				var end = item.end;
	    				if(start) 
	    				{
	    					range = this.createRange();
	    					if(item.collapsed || !end) 
	    					{
	    						var previousNode = start.previousSibling;
	    						if(this.util.isTextNode(previousNode)) 
	    						{
	    							range.setStart(previousNode,(previousNode.nodeValue ? previousNode.nodeValue.length : 0));
	    						} 
	    						else 
	    						{
	    							range.setStartBefore(start);
	    						}
	    						this.editorUtil.removeNode(start);
	    						range.collapse(true);
	    					}
	    					else 
	    					{
	    						range.setStartAfter(start);
	    						this.editorUtil.removeNode(start);
	    						range.setEndBefore(end);
	    						this.editorUtil.removeNode(end);
	    					}
	    				}

					}
	    			if(range) 
	    			{
	    				this.selectRange(range);
	    			}
	    		}
	    	}
		};
		
		//save
		this.saveSelection = function(saveSelection,wrapText)
		{
			saveSelection = (saveSelection == null) ? true : Boolean.parse(saveSelection);
			var savedSelection = null;
			if(wrapText)
			{
				savedSelection = [];
				var selection = this.getSelection();
				if(selection && selection.rangeCount) 
				{
					var ranges = [];
					var rangeCount = selection.rangeCount;
					var start = null;
					var end = null;
					for(var count = 0;count < rangeCount;count++) 
					{
						ranges[count] = selection.getRangeAt(count);
						if (ranges[count].collapsed) 
						{
							start = this.__createWrapper(true,ranges[count]);
							savedSelection[count] = {start:start,collapsed:true,startMarker: start.outerHTML};
						} 
						else 
						{
							start = this.__createWrapper(true,ranges[count]);
							end = this.__createWrapper(false,ranges[count]);
							savedSelection[count]  = {start: start,end: end,collapsed: false,startMarker: start.outerHTML,endMarker: end.outerHTML};
						}
					}
					selection.removeAllRanges();
					for(var count = rangeCount - 1;count > -1; --count) 
					{
						var start = savedSelection[count].start;
						if(start) 
						{
							if(savedSelection[count].collapsed) 
							{
								ranges[count].setStartAfter(start);
								ranges[count].collapse(true);
							} 
							else 
							{
								//doing setStartAfter as with setStartBefore the element added gets added before the start selection span
								//ranges[count].setStartBefore(start);
								ranges[count].setStartAfter(start);
								if(savedSelection[count].end) 
								{
									var end = savedSelection[count].end;
									if(end) 
									{
										//doing setEndBefore as with setEndAfter the element added wraps after the end selection span
										//ranges[count].setEndAfter(end);
										ranges[count].setEndBefore(end);
									}
								}
							}
						}
						try 
						{
							selection.addRange(ranges[count].cloneRange());
						} 
						catch(error)
						{
						}
					}
				}
			}
			else 
			{
				savedSelection = this.getRange();
			}
			if(saveSelection)
			{
				this.__savedSelection = savedSelection;
			}
			return savedSelection;
		};
		
		this.__createWrapper = function(isStart,range)
		{
			var clonedRange;
			var doc = this.__nsEditor.__getDocument();
			var textArea = this.__nsEditor.__getTextArea();
			if (range) 
			{
				clonedRange = range.cloneRange();
				clonedRange.collapse(isStart);
			}
			var wrapper = this.util.createElement("span",null,"nsEditorSelectionWrapper nsEditorSelectionWrapper" + (isStart ? "Start" : "End"),doc);
			this.util.css(wrapper,{lineHeight: 0,display:"none"});
			wrapper.appendChild(doc.createTextNode(this.editorUtil.INVISIBLE_SPACE));
			if(clonedRange) 
			{
				if (this.editorUtil.isExistsInsideEditor(isStart ? clonedRange.startContainer : clonedRange.endContainer)) 
				{
					clonedRange.insertNode(wrapper);
				}
			}
			return wrapper;
		};
		
		//isMarker
		this.isSelectionWrapper = function(node)
		{
			node && this.util.hasStyleClass(node,"nsEditorSelectionWrapper");
		}
		
		/* end of selection function */
		
		/* Start of range function */
		
		this.getRange = function() 
		{
			var selection = this.getSelection();
			if (selection) 
			{
				if (selection.rangeCount && selection.rangeCount > 0) 
				{
					return selection.getRangeAt(0);
				} 
				else
				{
					return this.createRange();
				}
			}
			return null;
		};
		
		this.createRange = function() 
		{
			var doc = this.__nsEditor.__getDocument();
			var range = doc.createRange();
			return range;
		};
		
		this.selectRange = function(range,focus) 
		{
			focus = this.util.isUndefinedOrNull(focus) ? true : Boolean.parse(focus);
			if(focus && !this.hasFocus()) 
			{
				this.setFocus();
			}
			var selection = this.getSelection();
			if (selection) 
			{
				selection.removeAllRanges();
				selection.addRange(range);
			}
			this.__nsEditor.__dispatchInternalEvent("selectionchange",{range:range},{range:range});
		};
		
		//select
		this.selectElement = function(node,isInward) 
		{
			if(node)
			{
				isInward = Boolean.parse(isInward);
				var isExistsInside = this.editorUtil.isExistsInsideEditor(node);
				if(isExistsInside)
				{
					var range = this.createRange();
				    range[isInward ? "selectNodeContents" : "selectNode"](node);
				    this.selectRange(range);
				}
				else
				{
					this.util.warning("NSEditor","Node element must be in editor");
				}
			}
		};
		
		this.createDefaultRange = function() 
	    {
			this.setFocus();
	        var range = this.createRange();
	        var body = this.__nsEditor.__getTextArea();
	        var focusElement = body.firstElementChild;
	        if (!focusElement) 
	        {
	        	body.innerHTML = this.__config.defaultValue;
	        	focusElement = body.firstElementChild;
	        }
	        range.setStart(focusElement, 0);
	        range.setEnd(focusElement, 0);
	        return range;
	    };
		
		/* end of range function */
		
		this.insertNode = function(node,insertCursorAfter,checkCharCount) 
		{
			if(node)
			{
				checkCharCount = this.util.isUndefinedOrNull(checkCharCount) ? true : Boolean.parse(checkCharCount);
				if (!this.__nsEditor.__checkCharCount(node, null)) 
				{
	            	return false;
	        	}
				insertCursorAfter = this.util.isUndefinedOrNull(insertCursorAfter) ? true : Boolean.parse(insertCursorAfter);
				if (!this.hasFocus() && !this.__nsEditor.__isSourceMode) 
		        {
					//this.restoreSelection();
		            this.setFocus();
		        }
				if (!this.isCollapsed()) 
				{
					this.__nsEditor.__executeCommand("Delete");
				}
				var tempNode = null;
				var selection = this.getSelection();
				var textArea = this.__nsEditor.__getTextArea();
				if(selection && selection.rangeCount)
				{
					var range = selection.getRangeAt(0);
					if (this.util.isElementInOrParent(range.commonAncestorContainer,textArea)) 
					{
			                if (/^(BR|HR|IMG|VIDEO)$/i.test(range.startContainer.nodeName) && range.collapsed) 
			                {
			                	tempNode = range.startContainer.parentNode;
			                	if(tempNode)
			                	{
			                		tempNode.insertBefore(node, range.startContainer);
			                	}
			                }
			                else 
			                {
			                    range.deleteContents();
			                    range.insertNode(node);
			                }
		            }
		            else 
		            {
		            	textArea.appendChild(node);
		            }
				}
				else 
	            {
	            	textArea.appendChild(node);
	            }
				if (insertCursorAfter) 
				{
		            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) 
		            {
		            	if(node.lastChild)
		            	{
		            		this.setCursorAfter(node.lastChild);
		            	}
		            }
		            else 
		            {
		                this.setCursorAfter(node);
		            }
		        }
				this.__nsEditor.__dispatchInternalEvent("insertedNode");
				return true;
			}
	    };
	    
	    this.insertHTML = function(html) 
	    {
	        if (html) 
	        {
	        	var doc = this.__nsEditor.__getDocument();
	        	var textArea = this.__nsEditor.__getTextArea(); 
	        	var divTemp = doc.createElement("div");
	        	var fragment = doc.createDocumentFragment();
		        if (!this.hasFocus() && !this.__isSourceMode) 
		        {
		            this.setFocus();
		        }
		        if (!this.editorUtil.isNode(html)) 
		        {
		            divTemp.innerHTML = html.toString();
		        }
		        else 
		        {
		            divTemp.appendChild(html);
		        }
		        var lastChild = divTemp.lastChild;
		        if (this.__isSourceMode || !lastChild) 
		        {
		            return;
		        }
		        while (divTemp.firstChild) 
		        {
		            lastChild = divTemp.firstChild;
		            fragment.appendChild(divTemp.firstChild);
		        }
		        if(this.insertNode(fragment, false))
		        {
		        	if (lastChild) 
		        	{
			            this.setCursorAfter(lastChild);
			        }
			        else 
			        {
			            this.setCursorIn(fragment);
			        }
			        var lastEditorElement = textArea.lastChild;
			        while(this.util.isTextNode(lastEditorElement) && lastEditorElement.previousSibling && lastEditorElement.nodeValue &&
			            /^\s*$/.test(lastEditorElement.nodeValue)) 
			        {
			            lastEditorElement = lastEditorElement.previousSibling;
			        }
			        if (lastChild) 
			        {
			            if (lastEditorElement && lastChild === lastEditorElement &&
			            		this.util.isElement(lastChild)) 
			            {
			            	textArea.appendChild(doc.createElement("br"));
			            }
			            this.setCursorAfter(lastChild);
			        }
		        }
		        
	        }
	    };
		
		//remove
		this.removeSelectedContent = function() 
		{
			var selection = this.getSelection();
			var element = this.getElementUnderCursor();
			if (selection && element) 
			{
				for (var count = 0;count < selection.rangeCount; count++) 
				{
					selection.getRangeAt(count).deleteContents();
					selection.getRangeAt(count).collapse(true);
				}
			}
		};

		this.removeNode = function(node)
		{
			var isExistsInside = this.editorUtil.isExistsInsideEditor(node);
    		if(isExistsInside)
			{
    			this.editorUtil.removeNode(node);
			}
    		//afterRemoveNode
    		this.__nsEditor.__dispatchInternalEvent("removedNode",{node: node},{node: node});
		};
		
		this.insertCursorAtPoint = function (xPos,yPos) 
		{
	        var self = this;
	        this.removeMarkers();
	        try 
	        {
	        	var doc = this.__nsEditor.__getDocument();
	        	var range = this.createRange();
	        	if(doc.caretPositionFromPoint) 
	        	{
                    var caret = doc.caretPositionFromPoint(xPos,yPos);
                    if (caret) 
                    {
                        range.setStart(caret.offsetNode,caret.offset);
                    }
                }
	        	else if(doc.caretRangeFromPoint) 
                {
                    var caret = doc.caretRangeFromPoint(xPos,yPos);
                    range.setStart(caret.startContainer, caret.startOffset);
                }
	            range.collapse(true);
	            this.selectRange(range);
	            return true;
	        }
	        catch (error) 
	        { 
	        	
	        }
	        return false;
	    };
	    
	    this.isCollapsed = function() 
	    {
	        var selection = this.getSelection();
	        if(selection)
	        {
	        	for (var count = 0; count < selection.rangeCount; count++) 
		        {
		            if (!selection.getRangeAt(count).collapsed) 
		            {
		                return false;
		            }
		        }
	        }
	        return true;
	    };
	    
	    //isFocused
	    this.hasFocus = function () 
	    {
	    	var doc = this.__nsEditor.__getDocument();
	    	var textArea = this.__nsEditor.__getTextArea(); 
	        return (doc.hasFocus && doc.hasFocus() && textArea === doc.activeElement);
	    };
	    
	    this.setFocus = function() 
		{
			if(this.__nsEditor.__isModeTextArea())
			{
				this.__nsEditor.__compTextArea && this.__nsEditor.__compTextArea.focus();
			}
			else
			{
				this.__nsEditor.__frameContentWindow && this.__nsEditor.__frameContentWindow.focus();
			}
		};
		
		//current
		this.getElementUnderCursor = function(parseChildren)
		{
			parseChildren = this.util.isUndefinedOrNull(parseChildren) ? true : Boolean.parse(parseChildren);
	        if (!this.__nsEditor.__isSourceMode) 
	        {
	            var selection = this.getSelection();
	            if (selection && selection.rangeCount > 0) 
	            {
	                var range = selection.getRangeAt(0);
	                var node = range.startContainer
	                var isRight = false;
	                var getChild = function(paramNode) 
	                {
	                    return isRight ? paramNode.lastChild : paramNode.firstChild;
	                };
	                if (!this.util.isTextNode(node)) 
	                {
	                    node = range.startContainer.childNodes[range.startOffset];
	                    if (!node) 
	                    {
	                        node = range.startContainer.childNodes[range.startOffset - 1];
	                        isRight = true;
	                    }
	                    if (node && selection.isCollapsed && !this.util.isTextNode(node)) 
	                    {
	                        if (!isRight && this.util.isTextNode(node.previousSibling)) 
	                        {
	                            node = node.previousSibling;
	                        }
	                        else if (parseChildren) 
	                        {
	                            var current = getChild(node);
	                            while (current) 
	                            {
	                                if (current && this.util.isTextNode(current)) 
	                                {
	                                    node = current;
	                                    break;
	                                }
	                                current = getChild(current);
	                            }
	                        }
	                    }
	                    if (node && !selection.isCollapsed && !this.util.isTextNode(node)) 
	                    {
	                        var leftChild = node;
	                        var rightChild = node;
	                        do 
	                        {
	                            leftChild = leftChild.firstChild;
	                            rightChild = rightChild.lastChild;
	                        } 
	                        while (leftChild && rightChild && !this.util.isTextNode(leftChild));
	                        if (leftChild === rightChild && leftChild && this.util.isTextNode(leftChild)) 
	                        {
	                            node = leftChild;
	                        }
	                    }
	                }
	                var isExistsInside = this.editorUtil.isExistsInsideEditor(node);
	                if (node && isExistsInside) 
	                {
	                    return node;
	                }
	            }
	        }
	        return null;
		};
		
		this.setCursorAfter = function(node) 
		{
	    	if(node)
	    	{
	    		var isExistsInside = this.editorUtil.isExistsInsideEditor(node);
				if(isExistsInside)
				{
					var range = this.createRange();
					var fakeNode = null;
			        if (!this.util.isTextNode(node)) 
			        {
			            fakeNode = this.__nsEditor.__dom.doc.createTextNode("");
			            range.setStartAfter(node);
			            range.insertNode(fakeNode);
			            range.selectNode(fakeNode);
			        }
			        else 
			        {
			            range.setEnd(node, node.nodeValue !== null ? node.nodeValue.length : 0);
			        }
			        range.collapse(false);
					this.selectRange(range);
					return fakeNode;
				}
				else
				{
					this.util.warning("NSEditor","Node element must be in editor");
				}
	    	}
	    	return null;
		};
		
		this.setCursorBefore = function(node) 
		{
	    	if(node)
	    	{
	    		var isExistsInside = this.editorUtil.isExistsInsideEditor(node);
				if(isExistsInside)
				{
					var range = this.createRange();
					var fakeNode = null;
			        if (!this.util.isTextNode(node)) 
			        {
			            fakeNode = this.__nsEditor.__dom.doc.createTextNode("");
			            range.setStartAfter(node);
			            range.collapse(true);
			            range.insertNode(fakeNode);
			            range.selectNode(fakeNode);
			        }
			        else 
			        {
			            range.setStart(node, node.nodeValue !== null ? node.nodeValue.length : 0);
			        }
			        range.collapse(true);
					this.selectRange(range);
					return fakeNode;
				}
				else
				{
					this.util.warning("NSEditor","Node element must be in editor");
				}
	    	}
	    	return null;
		};
		
		this.setCursorIn = function(node,inStart) 
		{
	    	if(node)
	    	{
	    		inStart = this.util.isUndefinedOrNull(inStart) ? true : Boolean.parse(inStart);
	    		var isExistsInside = this.editorUtil.isExistsInsideEditor(node);
				if(isExistsInside)
				{
					var range = this.createRange();
					var startNode = node;
					var lastNode = node;
					do 
					{
			            if(this.util.isTextNode(startNode)) 
			            {
			                break;
			            }
			            lastNode = startNode;
			            startNode = inStart ? startNode.firstChild : startNode.lastChild;
			        } 
					while (startNode);
					if (!startNode) 
					{
			            var fakeNode = this.__nsEditor.__dom.doc.createTextNode("");
			            if (!/^(img|br|input)$/i.test(lastNode.nodeName)) 
			            {
			            	lastNode.appendChild(fakeNode);
			            	lastNode = fakeNode;
			            }
			            else 
			            {
			            	startNode = lastNode;
			            }
			        }
					range.selectNodeContents(startNode || lastNode);
			        range.collapse(inStart);
			        this.selectRange(range);
			        return lastNode;
				}
				else
				{
					this.util.warning("NSEditor","Node element must be in editor");
				}
	    	}
	    	return null;
		};
		
		//getHTML
		this.getSelectedHTML = function() 
		{
			var selection = this.getSelection();
	        if (selection && selection.rangeCount > 0) 
	        {
	        	var doc = this.__nsEditor.__getDocument();
	            var range = selection.getRangeAt(0);
	            var clonedSelection = range.cloneContents();
	            var div = doc.createElement("div");
	            div.appendChild(clonedSelection);
	            return div.innerHTML;
	        }
	        return "";
	    };
	    
	    this.getSelectedNodes = function()
	    {
	    	var selection = this.getSelection();
	        if (selection && selection.rangeCount > 0) 
	        {
	        	var self = this;
	        	var arrNodes = [];
	        	var doc = this.__nsEditor.__getDocument();
	        	var textArea = this.__nsEditor.__getTextArea();
	        	var range = selection.getRangeAt(0);
	        	var arrChild = textArea.childNodes;
	        	var elementOffset = (range.startOffset < arrChild.length) ? range.startOffset : arrChild.length - 1;
	        	var start = (range.startContainer == textArea)? arrChild[elementOffset] : range.startContainer;
	            var end = (range.endContainer == textArea) ? arrChild[range.endOffset - 1] : range.endContainer;
	            var callback = function(node)
	            {
	            	if(node && node != textArea && !self.editorUtil.isEmptyTextNode(node) && !self.isSelectionWrapper(node))
	            	{
	            		arrNodes.push(node);
                    }
                    var retValue =  (node == end || (node && node.contains && node.contains(end)));
                    return retValue;
	            };
	            this.util.findNode(start,callback,textArea,true,"nextSibling","");
	            if (arrNodes.length === 0 && this.editorUtil.isEmptyTextNode(start)) 
	            {
	            	arrNodes.push(start);
	            }
	            return arrNodes;
	        }
	        return null;
	    };
	    
	  //eachSelection
	    this.loopSelectedNodes = function(callback)
	    {
	    	if(callback)
	    	{
	    		var arrNodes = this.getSelectedNodes();
		    	if(arrNodes && arrNodes.length)
		    	{
		    		var doc = this.__nsEditor.__getDocument();
		    		var textArea = this.__nsEditor.__getTextArea();
		    		var self = this;
		    		var callbackNode = function(node)
		    		{
		    			if (node != textArea && self.editorUtil.isExistsInsideEditor(node)) 
		    			{
		    				if(node.nodeName.match(/^(UL|OL)$/)) 
		    				{
		                        var arrChild = Array.from(node.childNodes);
		                        if(arrChild && arrChild.length)
		                        {
		                        	for(var count = 0;count < arrChild.length;count++)
		                        	{
		                        		callbackNode(arrChild);
		                        	}
		                        }
		                    }
		    				else
		    				{
		    					if(self.util.isElementOfType(node,"li"))
		    					{
		    						if (node.firstChild) 
		    						{
			                            node = node.firstChild;
			                        }
			                        else 
			                        {
			                            var tempNode = doc.createTextNode("\uFEFF");
			                            node.appendChild(tempNode);
			                            node = tempNode;
			                        }
		    					}
		    					callback(node);
		    				}
	                    }
		    		};
		    		for(count = 0;count < arrNodes.length;count++)
		    		{
		    			var node = arrNodes[count];
		    			callbackNode(node);
		    		}
		    	}
	    	}
	    };
	    
	    /*Select.prototype.wrapInTag = function (tagOrCallback) {
	        var _this = this;
	        selector_1.$$('*[style*=font-size]', this.area).forEach(function (elm) {
	            elm.style &&
	                elm.style.fontSize &&
	                elm.setAttribute('data-font-size', elm.style.fontSize.toString());
	        });
	        this.doc.execCommand('fontsize', false, '7');
	        selector_1.$$('*[data-font-size]', this.area).forEach(function (elm) {
	            var fontSize = elm.getAttribute('data-font-size');
	            if (elm.style && fontSize) {
	                elm.style.fontSize = fontSize;
	                elm.removeAttribute('data-font-size');
	            }
	        });
	        var result = [];
	        selector_1.$$('font[size="7"]', this.area).forEach(function (font) {
	            try {
	                if (checker_1.isFunction(tagOrCallback)) {
	                    tagOrCallback(font);
	                }
	                else {
	                    result.push(Dom_1.Dom.replace(font, tagOrCallback, _this.jodit.create.inside));
	                }
	            }
	            finally {
	                if (font.parentNode) {
	                    Dom_1.Dom.unwrap(font);
	                }
	            }
	        });
	        return result;
	    };
	    Select.prototype.applyCSS = function (cssRules, nodeName, options) {
	        var _this = this;
	        if (nodeName === void 0) { nodeName = 'span'; }
	        var WRAP = 1, UNWRAP = 0, defaultTag = 'SPAN';
	        var mode;
	        var findNextCondition = function (elm) {
	            return elm !== null &&
	                !Dom_1.Dom.isEmptyTextNode(elm) &&
	                !_this.isMarker(elm);
	        };
	        var checkCssRulesFor = function (elm) {
	            return (!Dom_1.Dom.isTag(elm, 'font') &&
	                Dom_1.Dom.isElement(elm) &&
	                ((checker_1.isPlainObject(options) &&
	                    each_1.each(options, function (cssPropertyKey, cssPropertyValues) {
	                        var value = css_1.css(elm, cssPropertyKey, undefined, true);
	                        return (value !== null &&
	                            value !== '' &&
	                            cssPropertyValues.indexOf(value.toString().toLowerCase()) !== -1);
	                    })) ||
	                    (typeof options === 'function' && options(_this.jodit, elm))));
	        };
	        var isSuitElement = function (elm) {
	            if (!elm) {
	                return false;
	            }
	            var reg = RegExp('^' + elm.nodeName + '$', 'i');
	            return ((reg.test(nodeName) ||
	                !!(options && checkCssRulesFor(elm))) &&
	                findNextCondition(elm));
	        };
	        var toggleStyles = function (elm) {
	            if (isSuitElement(elm)) {
	                if (elm.nodeName === defaultTag && cssRules) {
	                    Object.keys(cssRules).forEach(function (rule) {
	                        if (mode === UNWRAP ||
	                            css_1.css(elm, rule) ===
	                                normalize_1.normilizeCSSValue(rule, cssRules[rule])) {
	                            css_1.css(elm, rule, '');
	                            if (mode === undefined) {
	                                mode = UNWRAP;
	                            }
	                        }
	                        else {
	                            css_1.css(elm, rule, cssRules[rule]);
	                            if (mode === undefined) {
	                                mode = WRAP;
	                            }
	                        }
	                    });
	                }
	                if (!Dom_1.Dom.isBlock(elm, _this.win) &&
	                    (!elm.getAttribute('style') || elm.nodeName !== defaultTag)) {
	                    Dom_1.Dom.unwrap(elm);
	                    if (mode === undefined) {
	                        mode = UNWRAP;
	                    }
	                }
	            }
	        };
	        if (this.isCollapsed()) {
	            var clearStyle = false;
	            if (this.current() &&
	                Dom_1.Dom.closest(this.current(), nodeName, this.area)) {
	                clearStyle = true;
	                var closest = Dom_1.Dom.closest(this.current(), nodeName, this.area);
	                if (closest) {
	                    this.setCursorAfter(closest);
	                }
	            }
	            if (nodeName.toUpperCase() === defaultTag || !clearStyle) {
	                var node = this.jodit.create.inside.element(nodeName);
	                node.appendChild(this.jodit.create.inside.text(consts.INVISIBLE_SPACE));
	                this.insertNode(node, false, false);
	                if (nodeName.toUpperCase() === defaultTag && cssRules) {
	                    css_1.css(node, cssRules);
	                }
	                this.setCursorIn(node);
	                return;
	            }
	        }
	        var selInfo = this.save();
	        normalize_1.normalizeNode(this.area.firstChild);
	        this.wrapInTag(function (font) {
	            if (!Dom_1.Dom.next(font, findNextCondition, font.parentNode) &&
	                !Dom_1.Dom.prev(font, findNextCondition, font.parentNode) &&
	                isSuitElement(font.parentNode) &&
	                font.parentNode !== _this.area &&
	                (!Dom_1.Dom.isBlock(font.parentNode, _this.win) ||
	                    consts.IS_BLOCK.test(nodeName))) {
	                toggleStyles(font.parentNode);
	                return;
	            }
	            if (font.firstChild &&
	                !Dom_1.Dom.next(font.firstChild, findNextCondition, font) &&
	                !Dom_1.Dom.prev(font.firstChild, findNextCondition, font) &&
	                isSuitElement(font.firstChild)) {
	                toggleStyles(font.firstChild);
	                return;
	            }
	            if (Dom_1.Dom.closest(font, isSuitElement, _this.area)) {
	                var leftRange = _this.createRange(), wrapper = Dom_1.Dom.closest(font, isSuitElement, _this.area);
	                leftRange.setStartBefore(wrapper);
	                leftRange.setEndBefore(font);
	                var leftFragment = leftRange.extractContents();
	                if ((!leftFragment.textContent ||
	                    !string_1.trim(leftFragment.textContent).length) &&
	                    leftFragment.firstChild) {
	                    Dom_1.Dom.unwrap(leftFragment.firstChild);
	                }
	                if (wrapper.parentNode) {
	                    wrapper.parentNode.insertBefore(leftFragment, wrapper);
	                }
	                leftRange.setStartAfter(font);
	                leftRange.setEndAfter(wrapper);
	                var rightFragment = leftRange.extractContents();
	                if ((!rightFragment.textContent ||
	                    !string_1.trim(rightFragment.textContent).length) &&
	                    rightFragment.firstChild) {
	                    Dom_1.Dom.unwrap(rightFragment.firstChild);
	                }
	                Dom_1.Dom.after(wrapper, rightFragment);
	                toggleStyles(wrapper);
	                return;
	            }
	            var needUnwrap = [];
	            var firstElementSuit;
	            if (font.firstChild) {
	                Dom_1.Dom.find(font.firstChild, function (elm) {
	                    if (elm && isSuitElement(elm)) {
	                        if (firstElementSuit === undefined) {
	                            firstElementSuit = true;
	                        }
	                        needUnwrap.push(elm);
	                    }
	                    else {
	                        if (firstElementSuit === undefined) {
	                            firstElementSuit = false;
	                        }
	                    }
	                    return false;
	                }, font, true);
	            }
	            needUnwrap.forEach(Dom_1.Dom.unwrap);
	            if (!firstElementSuit) {
	                if (mode === undefined) {
	                    mode = WRAP;
	                }
	                if (mode === WRAP) {
	                    css_1.css(Dom_1.Dom.replace(font, nodeName, _this.jodit.create.inside), cssRules && nodeName.toUpperCase() === defaultTag
	                        ? cssRules
	                        : {});
	                }
	            }
	        });
	        this.restore(selInfo);
	    };
	    Select.prototype.splitSelection = function (currentBox) {
	        if (!this.isCollapsed()) {
	            return null;
	        }
	        var leftRange = this.createRange();
	        var range = this.range;
	        leftRange.setStartBefore(currentBox);
	        var cursorOnTheRight = this.cursorOnTheRight(currentBox);
	        var cursorOnTheLeft = this.cursorOnTheLeft(currentBox);
	        var br = null;
	        if (cursorOnTheRight || cursorOnTheLeft) {
	            br = this.jodit.create.inside.element('br');
	            range.insertNode(br);
	            var clearBR = function (start, getNext) {
	                var next = getNext(start);
	                while (next) {
	                    var nextSib = getNext(next);
	                    if (next &&
	                        (Dom_1.Dom.isTag(next, 'br') || Dom_1.Dom.isEmptyTextNode(next))) {
	                        Dom_1.Dom.safeRemove(next);
	                    }
	                    else {
	                        break;
	                    }
	                    next = nextSib;
	                }
	            };
	            clearBR(br, function (n) { return n.nextSibling; });
	            clearBR(br, function (n) { return n.previousSibling; });
	            if (cursorOnTheRight) {
	                leftRange.setEndBefore(br);
	                range.setEndBefore(br);
	            }
	            else {
	                leftRange.setEndAfter(br);
	                range.setEndAfter(br);
	            }
	        }
	        else {
	            leftRange.setEnd(range.startContainer, range.startOffset);
	        }
	        var fragment = leftRange.extractContents();
	        if (currentBox.parentNode) {
	            try {
	                currentBox.parentNode.insertBefore(fragment, currentBox);
	                if (cursorOnTheRight && br && br.parentNode) {
	                    var range_3 = this.createRange();
	                    range_3.setStartBefore(br);
	                    this.selectRange(range_3);
	                }
	            }
	            catch (e) {
	                console.log(e);
	            }
	        }
	        return currentBox.previousElementSibling;
	    };*/
		
		
		/*Select.prototype.cursorInTheEdge = function (start, parentBlock) {
	        var _a;
	        var end = !start, range = (_a = this.sel) === null || _a === void 0 ? void 0 : _a.getRangeAt(0), current = this.current(false);
	        if (!range ||
	            !current ||
	            !Dom_1.Dom.isOrContains(parentBlock, current, true)) {
	            return null;
	        }
	        var container = start ? range.startContainer : range.endContainer;
	        var offset = start ? range.startOffset : range.endOffset;
	        var check = function (elm) {
	            return elm && !Dom_1.Dom.isTag(elm, 'br') && !Dom_1.Dom.isEmptyTextNode(elm);
	        };
	        if (Dom_1.Dom.isText(container)) {
	            var text = container.nodeValue || '';
	            if (end && text.replace(constants_1.INVISIBLE_SPACE_REG_EXP_END, '').length > offset) {
	                return false;
	            }
	            var inv = constants_1.INVISIBLE_SPACE_REG_EXP_START.exec(text);
	            if (start &&
	                ((inv && inv[0].length < offset) || (!inv && offset > 0))) {
	                return false;
	            }
	        }
	        else {
	            var children = Array.from(container.childNodes);
	            if (end) {
	                if (children.slice(offset).some(check)) {
	                    return false;
	                }
	            }
	            else {
	                if (children.slice(0, offset).some(check)) {
	                    return false;
	                }
	            }
	        }
	        var next = start
	            ? Dom_1.Dom.prev(current, check, parentBlock)
	            : Dom_1.Dom.next(current, check, parentBlock);
	        return !next;
	    };
	    Select.prototype.cursorOnTheLeft = function (parentBlock) {
	        return this.cursorInTheEdge(true, parentBlock);
	    };
	    Select.prototype.cursorOnTheRight = function (parentBlock) {
	        return this.cursorInTheEdge(false, parentBlock);
	    };*/
		
		
		this.removeMarkers = function()
		{
			
		};
		
		this.__initialize();
	};
		
	return NSSelection;
})();
nsModuleExport(this,"NSSelection",NSSelection); var NSExecCommand = (function()
{
	var NSExecCommand = function(nsEditor)
	{
    	this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		this.selection = nsEditor.__selection;
		this.doc = null;
		this.win = null;
		this.root = null;
		this.__addingCSS;
		
		var self = this;
		var browser = null;
		var objCommand = {};
		var objCommandWithExec = {};
		
		this.initialize = function()
		{
			this.__nsEditor.__listenInternalEvent("textAreaInitialized",function(){
				self.doc = self.__nsEditor.__getDocument();
				self.win = self.__nsEditor.__getWindow();
				self.root = self.__nsEditor.__getTextArea();
			});
			var browser = self.util.getBrowser();
			objCommand = {bold:{tag:function(){
					return browser.isMSIE ? "strong" : "b";
				},css: {"font-weight": "bold"}},
				italic: {tag:function(){
					return browser.isMSIE ? "em" : "i";
				},css: {"font-style": "italic"} },
				underline: {tag:"u",css: {"text-decoration": "underline"},override: false},
				strikethrough: {tag:"s",css: {"text-decoration": "line-through"},override: false},
				justifycenter:{css: {"text-align": "center"}},
				justifyleft: {css: {"text-align": "left"}},
				justifyright: {css: {"text-align": "right"}},
				justifyfull: {css: {"text-align": "justify"}},
				subscript: {tag:"sub",css: {"vertical-align": "sub"}},
				superscript: {tag:"sup",css: {"vertical-align": "super"}},
				
				undo: {},
				redo: {},
				outdent: {css: {"margin-left": "-25"}},
				indent: {css: {"margin-left": "+25"}},
				fontname: {css:{"font-family": "##args##"}},
				fontsize: {"7": {css: {"font-size": "xx-large"}},
						   "6": {css: {"font-size": "x-large"}},
						   "5": {css: {"font-size": "large"}},
						   "4": {css: {"font-size": "medium"}},
						   "3": {css: {"font-size": "small"}},
						   "2": {css: {"font-size": "x-small"}},
						   "1": {css: {"font-size": "xx-small"}}},
				forecolor: {css:{"color": "##args##"}},
				backcolor: {css:{"background-color": "##args##"}},
			};
			objCommandWithExec = {
				insertorderedlist: {exec: this.handleList.bind(this),type: "ol"},
				insertunorderedlist: {exec: this.handleList.bind(this),type: "ul"},
			};
		};
		
		this.execute = function(commandName,showDefaultUI,valueArgument)
		{
			var item = objCommand[commandName.toLowerCase()];
			if(item)
			{
				if(!item.css && valueArgument && item[valueArgument])
				{
					item = item[valueArgument];
				}
				if(item.tag || item.css)
				{
					var tag = item.tag;
					if(this.util.isFunction(tag))
					{
						tag = tag(commandName,item);
					}
					if(!this.__nsEditor.__config.enableTagsForProps && item.css)
					{
						tag = null;
					}
					var css = item.css;
					if(item.css && valueArgument)
					{
						css = {}
						for(var prop in item.css)
						{
							var key = this.util.convertCSSPropToJS(prop);
							var value = item.css[prop];
							if(value == "##args##")
							{
								value = valueArgument;
							}
							css[key] = value;
						}
					}
					this.applyStyle({tag: tag,css: css});
					return true;
				}
			}
			else if(objCommandWithExec[commandName.toLowerCase()])
			{
				item = objCommandWithExec[commandName.toLowerCase()];
				if(item.exec)
				{
					return item.exec(item);
				}
			}
			
			return false;
		};
		
		this.applyStyle = function(option)
		{
			option.tag = option.tag || "span";
			
			var savedSelection = null;
			if(this.selection.isCollapsed())
			{
				var span = this.util.createElement("span",null,"nsEditorElement nsEditorSelectedWrapper",this.doc);
				this.selection.insertNode(span,false,false);
				this.selection.setCursorIn(span);
				savedSelection = this.selection.saveSelection(false,true);
				this.replaceNode(span,option.tag);
				this.editorUtil.removeNode(span);
			}
			else
			{
				/*var origDomSelection = this.selection.getSelection();
				if(origDomSelection && (origDomSelection.anchorNode == origDomSelection.focusNode))
				{
					option.selectedNode = origDomSelection.anchorNode;
				}*/
				var origRange = this.selection.getSelection().getRangeAt(0);
				savedSelection = this.selection.saveSelection(false,true);
				this.editorUtil.mergeTextNodes(this.root.firstChild);
				this.insertTagRestoringSize(this.replaceNode.bind(this),option);
			}
			this.selection.restoreSelection(savedSelection);
		};
		
		//Select.prototype.wrapInTag
		this.insertTagRestoringSize = function(tagOrCallback,option)
		{
			var arrElement = this.root.querySelectorAll("*[style*=font-size]");
			var arrFontsEle = [];
			for(var count = 0;count < arrElement.length;count++)
			{
				var element = arrElement[count];
				if(element && element.style && element.style.fontSize)
				{
					arrFontsEle.push({element: element,size: element.style.fontSize.toString()});
				}
			}
			var font = this.util.createElement("font",null,"nsEditorElement nsEditorSelectedWrapper",this.doc);
			font.setAttribute("size","7");
			this.editorUtil.insertNodeWrappingRange(font);
			//this.doc.execCommand('fontsize', false, '7');
			for(var count = 0;count < arrFontsEle.length;count++)
			{
				var item = arrFontsEle[count];
				if(item.element && item.element.style && item.size)
				{
					item.element.style.fontSize = item.size;
				}
			}
			var result = [];
			var arrFonts = this.root.querySelectorAll('font[size="7"]');
			for(var count = 0;count < arrFonts.length;count++)
			{
				var font = arrFonts[count];
				try
				{
					if (tagOrCallback && this.util.isFunction(tagOrCallback)) 
					{
						tagOrCallback(font,option);
					} 
					else if(tagOrCallback)
					{
						result.push(this.util.replaceElement(font,tagOrCallback,null,null,this.doc));
					}
				}
				finally
				{
					if (font.parentNode) 
					{
						this.util.insertElementParentsParent(font);
	                }
				}
			}
		};
		
		//applyToElement
		this.replaceNode = function(node,option)
		{
			var self = this;
			var defaultTag = "span";
			if(this.checkSuitableParent(node,option) || this.checkSuitableChild(node,option) || this.checkClosestWrapper(node,option) || this.unwrapChildren(node,option)) 
			{
				return false;
			}
			if (this.__addingCSS == null) 
			{
				//WRAP
				this.__addingCSS = true;
			}
			if (this.__addingCSS != true) 
			{
				return false;
			}
			var wrapper = node;
			if (this.editorUtil.isTagBlock(option.tag)) 
			{
				var ulReg = /^(ul|ol|li|td|th|tr|tbody|table)$/i;
				var parent = this.util.findParentByCallback(node,function(paramNode){
						if (paramNode && self.editorUtil.isBlock(paramNode,self.win)) 
						{
							if (ulReg.test(option.tag) || !ulReg.test(node.nodeName)) 
							{
								return true;
							}
						}
						return false;
					},this.root);
				if (parent) 
				{
					wrapper = parent;
				} 
				else 
				{
					wrapper = this.wrapUnwrappedText(node);
				}
			}

			var newWrapper = this.util.replaceElement(wrapper,option.tag,null,null,this.doc);
			this.util.addStyleClass(newWrapper,"nsEditorSpan")
			if(this.editorUtil.isTagBlock(option.tag)) 
			{
				this.postProcessListElement(newWrapper,option);
			}
			//&& this.__nsEditor.__config["enterElement"] == option.tag
			if(option.css && defaultTag == option.tag) 
			{
				this.util.css(newWrapper,option.css);
			}
			return true;
		};
		
		this.checkSuitableParent = function(node,option) 
		{
			var parentNode = node.parentNode;
			var nextNode = !this.util.findNextNode(node,this.isNormalNode.bind(this,option),parentNode);
			var prevNode = !this.util.findPrevNode(node,this.isNormalNode.bind(this,option),parentNode);
			var isSuit = this.isSuitableElement(option,parentNode,false);
			var isBlock = !this.editorUtil.isBlock(parentNode,this.win);
			var isTag = this.editorUtil.isTagBlock(option.tag);
			//&& !this.util.findNextNode(node,this.isNormalNode.bind(this,option),parentNode)
			//&& !this.util.findPrevNode(node,this.isNormalNode.bind(this,option),parentNode) 
			if (parentNode  
				&& this.isSuitableElement(option,parentNode,false) && parentNode != this.root &&
				(!this.editorUtil.isBlock(parentNode,this.win) || this.editorUtil.isTagBlock(option.tag))) 
			{
				this.toggleStyles(parentNode,option);
				return true;
			}

			return false;
		};
		
		this.checkSuitableChild = function(node,option)
		{
			var firstChild = node.firstChild;
			if (firstChild && !this.util.findNextNode(firstChild,this.isNormalNode.bind(this,option),node) &&
				!this.util.findPrevNode(firstChild,this.isNormalNode.bind(this,option),node) &&
				this.isSuitableElement(option,firstChild,false)) 
			{
				this.toggleStyles(firstChild,option);
				return true;
			}

			return false;
		};
		
		this.checkClosestWrapper = function(node,option) 
		{
			var wrapper = this.editorUtil.getClosestElement(node,this.isSuitableElement.bind(this,option),this.root);
			if (wrapper) 
			{
				if (this.editorUtil.isTagBlock(option.tag)) 
				{
					this.toggleStyles(wrapper,option);
					return true;
				}
				var leftRange = this.selection.createRange();
				leftRange.setStartBefore(wrapper);
				leftRange.setEndBefore(node);
				var leftFragment = leftRange.extractContents();
				if ((!leftFragment.textContent || !this.editorUtil.trim(leftFragment.textContent).length) && leftFragment.firstChild) 
				{
					this.util.insertElementParentsParent(leftFragment.firstChild);
				}
				if (wrapper.parentNode) 
				{
					wrapper.parentNode.insertBefore(leftFragment,wrapper);
				}
				leftRange.setStartAfter(node);
				leftRange.setEndAfter(wrapper);

				var rightFragment = leftRange.extractContents();
				if ((!rightFragment.textContent || !this.editorUtil.trim(rightFragment.textContent).length) && rightFragment.firstChild) 
				{
					this.util.insertElementParentsParent(rightFragment.firstChild);
				}
				this.util.insertAfterElement(wrapper,rightFragment);
				this.toggleStyles(wrapper,option);
				return true;
			}
			return false;
		};
		
		this.unwrapChildren = function(node,option)
		{
			var needUnwrap = [];
			var firstElementSuit;
			if(node.firstChild) 
			{
				var self = this;
				this.util.findNode(node.firstChild,function(paramNode)
				{
					if(paramNode && self.isSuitableElement(paramNode)) 
					{
						if (firstElementSuit === undefined) 
						{
							firstElementSuit = true;
						}
						needUnwrap.push(paramNode);
					} 
					else 
					{
						if(firstElementSuit === undefined) 
						{
							firstElementSuit = false;
						}
					}
					return false;
				},node,true);
			}
			for(var count = 0;count < needUnwrap.length;count++)
			{
				var paramNode = needUnwrap[count];
				this.util.insertElementParentsParent(paramNode);
			}
			return firstElementSuit;
		}
		
		this.toggleStyles = function(node,option) 
		{
			var css = option.css;
			var element = option.tag || "span";
			var defaultTag = "span";
			var elementIsDefault = (defaultTag == node.nodeName.toLowerCase());
			if (css && elementIsDefault)
			{
				for(var key in css)
				{
					var nodeValue = this.util.getStyleValue(node,key,false,true,this.win);
					var valueToBeSet = this.normalizeCssValue(key,css[key]);
					if(nodeValue && /color/i.test(key) && /^rgb/i.test(nodeValue.toString())) 
					{
						nodeValue = this.util.colorToHex(nodeValue.toString()) || nodeValue;
					}
					//console.log(key + "," + nodeValue + "," + valueToBeSet);
					if (this.__addingCSS == false || (nodeValue == valueToBeSet)) 
					{
						this.util.css(node,key,'');
						if(this.__addingCSS == undefined) 
						{
							//UNWRAP
							this.__addingCSS = false;
						}
					}
					else 
					{
						this.util.css(node, key, css[key]);
						if(this.__addingCSS == undefined) 
						{
							//WRAP
							this.__addingCSS = true;
						}
					}
				}
			}
			var isBlock = this.editorUtil.isBlock(node,this.root);
			var isSuitableInline = !isBlock && (!node.hasAttribute('style') || node.nodeName.toLowerCase() != defaultTag);
			var isSuitableBlock = !isSuitableInline && isBlock && node.nodeName.toLowerCase() == element;
			if (isSuitableInline || isSuitableBlock) 
			{
				// toggle `<strong>test</strong>` toWYSIWYG `test`, and
				// `<span style="">test</span>` toWYSIWYG `test`
				this.util.insertElementParentsParent(node);
				if(this.__addingCSS == undefined) 
				{
					this.__addingCSS = false;
				}
			}
		};
		
		this.isSuitableElement = function(option,node,strict)
		{
			if(node) 
			{
				strict = this.util.isUndefinedOrNull(strict) ? true : Boolean.parse(strict);
				var element = option.tag || this.__nsEditor.__config["enterElement"];
				var elementIsDefault = (this.__nsEditor.__config["enterElement"] == option.tag);
				var elmHasSameStyle = this.isStyleValueExists(node,option.css);
				var elmIsSame = (node.nodeName.toLowerCase() == element);

				return (((!elementIsDefault || !strict) && elmIsSame) || (elmHasSameStyle && this.isNormalNode(option,node)));
			}
			return false;
		};
		
		this.isStyleValueExists = function(node,objStyle)
		{
			var matches = false;
			if(node && this.util.isElement(node) && !this.util.hasStyleClass(node,"nsEditorSelectedWrapper")) 
			{
				matches = true;
				var style = this.win.getComputedStyle(node);
				for(var styleProp in objStyle)
				{
					if(style[styleProp] != objStyle[styleProp])
					{
						matches = false;
						break;
					}
				}
			}
			return matches;
		};

		this.isNormalNode = function(option,node) 
		{
			return (node != null && !this.editorUtil.isEmptyTextNode(node) && !this.selection.isSelectionWrapper(node));
		};
		
		this.normalizeCssValue = function(key,value)
		{
			switch (this.util.toKebabCase(key)) 
			{
				case 'font-weight':
					switch (value.toString().toLowerCase()) {
						case '700':
						case 'bold':
							return "bold";

						case '400':
						case 'normal':
							return "normal";

						case '900':
						case 'heavy':
							return "heavy";
					}

					return this.util.isNumeric(value) ? Number(value) : value;
			}

			if (/color/i.test(key) && /^rgb/i.test(value.toString())) 
			{
				return this.util.colorToHex(value.toString()) || value;
			}
			return value;
		};

		
		this.postProcessListElement = function(wrapper,option) 
		{
	        if (/^(OL|UL)$/i.test(option.tag) && wrapper.tagName.toLowerCase() == option.tag.toLowerCase()) 
	        {
	            var li = this.util.replaceElement(wrapper,"li",null,null,this.doc);
	            var ul = this.editorUtil.wrapNode(li,option.tag);
	            if(ul) 
	            {
	                wrapper = ul;
	            }
	        }
	    };
	    
	    /********* List related functions *******************/
		
		this.handleList = function(item)
		{
			var selection = this.selection.getSelection();
			var anchorNode = selection.anchorNode;
			if(anchorNode) 
			{
				var container = anchorNode.nodeType != Node.TEXT_NODE && anchorNode.nodeType != Node.COMMENT_NODE ? anchorNode : anchorNode.parentElement;
				var range = selection.getRangeAt(0);
				//selected all list
				if(range.commonAncestorContainer && range.commonAncestorContainer.nodeName.toLowerCase() == item.type) 
				{
					this.removeList(range);
				}
				//selected li
				else if (container.nodeName.toLowerCase() == "li") 
				{
					this.removeListItem(container,range,selection,item.type);
				}
				else
				{
					this.createList(container,range,selection,item.type);
				}
				return true;
			}
		};
		
		this.createList = function(container,range,selection,type)
		{
			var fragment = range.extractContents();
			var list = this.doc.createElement(type);
			list.setAttribute("class","nsExecCommandList");
			var li = this.doc.createElement("li");
			li.style.cssText = container.style.cssText;
			li.appendChild(fragment);
			list.appendChild(li);
			range.insertNode(list);
			selection.selectAllChildren(list);
		};
		
		this.removeList = function(range)
		{
			var list = range.commonAncestorContainer;
			if(list.childNodes && list.childNodes.length) 
			{
				var arrChildren = list.childNodes;
				for(var count = 0;count < arrChildren.length;count++)
				{
					var child = arrChildren[count];
					if(child.childNodes && child.childNodes.length > 1 && 
					   child.firstChild.nodeType != Node.TEXT_NODE &&
					   child.firstChild.nodeType != Node.COMMENT_NODE)
					{
						var span = this.doc.createElement("span");
						span.setAttribute("class","nsExecListCommand");
						for(var childCount = 0;childCount < child.childNodes.length;childCount++)
						{
							span.appendChild(child.childNodes[childCount]);
						}
				        list.parentElement.insertBefore(span,list);
					}
					else 
					{
				        var text = this.doc.createTextNode(child.textContent);
				        list.parentElement.insertBefore(text,list);
				    }
				}
			}
			list.parentElement.removeChild(list);
		};
		
		this.removeListItem = function(container,range,selection,type) 
		{
			this.movePreviousListItem(container,type);
			this.moveNextListItem(container,type);
			var span = this.doc.createElement("span");
			span.setAttribute("class","nsExecListCommand");
			span.style.cssText = container.style.cssText;
			var fragment = range.extractContents();
			span.appendChild(fragment);
			var dest = container.parentElement.nextElementSibling ? container.parentElement.nextElementSibling : container.parentElement.parentElement.lastChild;
			container.parentElement.parentElement.insertBefore(span,dest);
			selection.selectAllChildren(container);
			var list = container.parentElement;
			list.removeChild(container);
			if(!list.childNodes || !list.childNodes.length) 
			{
			    list.parentElement.removeChild(list);
			}
		};
		
		this.movePreviousListItem = function(container,type) 
		{
			if (container.previousElementSibling && container.previousElementSibling.nodeName.toLowerCase() == "li") 
			{
			    var list = this.moveListItem(container.previousElementSibling,true,type);
			    if (list) 
			    {
			    	container.parentElement.parentElement.insertBefore(list,container.parentElement);
			    }
			}
		};
		
		this.moveNextListItem = function(container,type) 
		{
			if (container.nextElementSibling && container.nextElementSibling.nodeName.toLowerCase() == "li") 
			{
			    var list = this.moveListItem(container.nextElementSibling,false,type);
			    if(list) 
			    {
			    	if(container.parentElement.nextSibling)
			    	{
			    		container.parentElement.parentElement.insertBefore(list,container.parentElement.nextSibling);
			    	}
			    	else
			    	{
			    		container.parentElement.parentElement.appendChild(list);
			    	}
			    }
			}
		};
		
		this.moveListItem = function(sibling,isPrevious,type) 
		{
			if(!sibling || sibling.nodeName.toLowerCase() != "li") 
			{
			    return null;
			}
			var children = [];
			while (sibling && sibling.nodeName.toLowerCase() == "li") 
			{
			    children.push(sibling);
			    sibling = isPrevious ? sibling.previousElementSibling : sibling.nextElementSibling;
			}
			if (!children || children.length <= 0) 
			{
			    return null;
			}
			var list = this.doc.createElement(type);
			list.setAttribute("class","nsExecCommandList");
			if(isPrevious) 
			{
				children.reverse();
			}
			for(var count = 0;count < children.length;count++)
			{
				list.appendChild(children[count]);
			}
			return list;
		};
		
		/********* end of List related functions *******************/
		
	    this.initialize();
		
    };
	
	return NSExecCommand;
})();
nsModuleExport(this,"NSExecCommand",NSExecCommand); var NSStack = (function()
{
	var NSStack = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.arrCommands = [];
        this.index = -1;
		
		this.__initialize = function()
		{
			
		};
		
		this.clearRedo = function() 
		{
	        this.arrCommands.length = this.index + 1;
	    };
	    
	    this.clear = function() 
	    {
	        this.arrCommands.length = 0;
	        this.index = -1;
	    };
	    
	    this.push = function(command) 
	    {
	        this.clearRedo();
	        this.arrCommands.push(command);
	        this.index += 1;
	    };
	    
	    this.undo = function() 
	    {
	        if(this.canUndo()) 
	        {
	            if (this.arrCommands[this.index]) 
	            {
	                this.arrCommands[this.index].undo();
	            }
	            this.index -= 1;
	            return true;
	        }
	        return false;
	    };
	    
	    this.redo = function() 
	    {
	        if (this.canRedo()) 
	        {
	            this.index += 1;
	            if (this.arrCommands[this.index]) 
	            {
	                this.arrCommands[this.index].redo();
	            }
	            return true;
	        }
	        return false;
	    };
	    
	    this.canUndo = function () 
	    {
	        return this.index >= 0;
	    };
	    
	    this.canRedo = function () 
	    {
	        return this.index < this.arrCommands.length - 1;
	    };
		
		this.__initialize();
	};
		
	return NSStack;
})();
nsModuleExport(this,"NSStack",NSStack); var NSEditorModal = (function()
{
	var NSEditorModal = function(nsEditor,nsParentPluggin,setting)
	{
		this.__nsEditor = nsEditor;
		this.__nsParentPluggin = nsParentPluggin;
		this.__setting = setting;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.__divModalMask = null;
		this.__divDragMask = null;
		this.__id = null;
		this.__compOuterContainer = null;
		this.__originalValue = null;
		this.__objDrag = null;
		
		this.__initialize = function()
		{
			this.__setSetting();
			this.__componentsInitialized();
		};
		
		this.__setSetting = function()
		{
			if(!this.__setting)
			{
				throw this.util.throwNSError("NSEditorModal","Setting for Pluggin " + this.__nsParentPluggin.name + " is not defined");
			}
			var config = this.__setting;
			if(!config.contentCallback)
			{
				throw this.util.throwNSError("NSEditorModal","ContentCallback in setting for Pluggin " + this.__nsParentPluggin.name + " is not defined");
			}
			this.__config = {
								container: config["container"] || this.__nsEditor.__getFixedComp(),
								title: config["title"] || "",
								enableDraggable: this.util.isUndefinedOrNull(config["enableDraggable"]) ? true : Boolean.parse(config["enableDraggable"]),
								enableReset: this.util.isUndefinedOrNull(config["enableReset"]) ? true : Boolean.parse(config["enableReset"]),
								showMask: this.util.isUndefinedOrNull(config["showMask"]) ? true : Boolean.parse(config["showMask"]),
								contentCSSClass: config["contentCSSClass"] || "",
								contentCallback: this.util.getFunction(config["contentCallback"]),
								footerCallback: this.util.getFunction(config["footerCallback"]),
								closeCallback: this.util.getFunction(config["closeCallback"]),
								isFullScreen: Boolean.parse(config["isFullScreen"])
						    };
			
		};
		
		this.__componentsInitialized = function()
		{
			this.__createComponents();
			this.__nsEditor.__listenInternalEvent("resized change changePlace readonly",this.hide.bind(this));
			this.__nsEditor.__listenInternalEvent("destroy",this.destroy.bind(this));
		};
		
		this.__createComponents = function()
		{
			this.__id = this.__nsEditor.getID() + this.__nsParentPluggin.name + "EditorModal";
			if(!this.__divModalMask)
			{
				if(this.__config.container.querySelector(".nsEditorModalMask"))
				{
					this.__divModalMask = this.__config.container.querySelector(".nsEditorModalMask");
				}
				else
				{
					this.__divModalMask = this.util.createDiv(this.__id + "ModalMask","nsEditorModalMask");
					this.__config.container.appendChild(this.__divModalMask);
					this.util.addEvent(this.__divModalMask,"click",this.close.bind(this));
					this.util.addEvent(this.__divModalMask,"mouseDown",this.__maskMouseDownHandler.bind(this));
				}
			}
			if(!this.__divDragMask)
			{
				if(this.__config.container.querySelector(".nsEditorModalDragMask"))
				{
					this.__divDragMask = this.__config.container.querySelector(".nsEditorModalDragMask");
				}
				else
				{
					this.__divDragMask = this.util.createDiv(this.__id + "DragMask","nsEditorModalDragMask");
					this.__config.container.appendChild(this.__divDragMask);
					this.util.addEvent(this.__divDragMask,"mouseDown",this.__maskMouseDownHandler.bind(this));
				}
			}
			this.destroy();
			this.__compOuterContainer = this.__getContainer();
			this.__config.container.appendChild(this.__compOuterContainer);
			this.__hide();
		};
		
		this.toggle = function()
		{
			this.isHidden() ? this.show() : this.hide();
		};
		
		this.show = function() 
		{
			if (this.__config.enableReset) 
		    {
				this.reset();
		    }
		    this.showAtCenter();
		};
		
		this.hide = function()
		{
			if (!this.isHidden()) 
			{
				this.__hide();
				this.__nsEditor.__dispatchInternalEvent("modalhide",{modal:this});
		    }
		};
		
		this.showAtCenter = function()
		{
			var doc = this.__nsEditor.__dom.doc;
			var html = doc.documentElement || doc.body;
			var body = doc.body;
			var htmlRect = html.getBoundingClientRect();
			if (this.__config.isFullScreen) 
			{
				var modalContent = this.__compOuterContainer.querySelector(".nsEditorModalContentContainer");
		        this.__compOuterContainer.style.display = "block";

		        var rectContainer = this.__compOuterContainer.getBoundingClientRect();
		        var rectContent = modalContent.getBoundingClientRect();
		        this.__compOuterContainer.style.left = "-100000px";

		        var contentWidth = htmlRect.width - rectContainer.width + rectContent.width;
		        var contentHeight = htmlRect.height - rectContainer.height + rectContent.height;
		        this.util.css(modalContent,{width: contentWidth,height: contentHeight});
		        this.util.css(this.__compOuterContainer,{width: htmlRect.width,height: htmlRect.height,left: 0});
		        
		        this.__originalValue = {
		          html: {
		            overflowX: html.style.overflowX,
		            overflowY: html.style.overflowY
		          },
		          body: {
		            overflowX: body.style.overflowX,
		            overflowY: body.style.overflowY
		          }
		        };
		        var styleOverflow = {overflowX: "hidden",overflowY: "hidden"};
		        this.util.css(doc.documentElement,styleOverflow);
		        this.util.css(body,styleOverflow);
		    } 
			else 
			{
				 this.__compOuterContainer.style.display = "";
			     var popSize = this.__fitSize();
			     var titleBar = this.__compOuterContainer.querySelector(".nsEditorModalTitlebar");
			     var titleHeight = titleBar.offsetHeight | 0;
			     var left = htmlRect.width / 2 - popSize.width / 2;
			     var top = htmlRect.height / 2 - (popSize.height - titleHeight) / 2 - titleHeight;
			     this.__safeSetOffset({left: Math.max(left | 0, 0),top: Math.max(top | 0, 0)});
			     this.util.addStyleClass(this.__compOuterContainer,"nsEditorModalCentered");
		    }
			this.__show();
		};
		
		this.reset = function() 
		{
			if(!this.isDestroyed())
			{
				var divContent = this.__compOuterContainer.querySelector(".nsEditorModalContent");
				var htmlContent = this.__config.contentCallback(this,this.__nsParentPluggin);
				divContent.innerHTML = htmlContent;
			}
		};
		
		this.close = function() 
		{
			if (this.__config.isFullScreen && this.__originalValue) 
			{
				var doc = this.__nsEditor.__dom.doc;
				var body = doc.body;
				var docElement = doc.documentElement;
				this.util.css(docElement,this.__originalValue.html);
		        this.util.css(body,this.__originalValue.body);
		        this.__originalValue = null;
		    }
			this.hide();
		};
		
		this.isHidden = function()
		{
			if(!this.isDestroyed())
			{
				return (this.__compOuterContainer.style.display == "none")
			}
			return true;
		};
		
		this.isDestroyed = function()
		{
			if(this.__compOuterContainer && this.__compOuterContainer.parentElement)
			{
				return false;
			}
			return true;
		};
		
		this.destroy = function()
		{
			if(this.__compOuterContainer && this.__compOuterContainer.parentElement)
			{
				this.__compOuterContainer.parentElement.removeChild(this.__compOuterContainer);
				this.__compOuterContainer = null;
			}
		};
		
		this.__show = function()
		{
			//if (this.isHidden()) 
			//{
				var container = this.__compOuterContainer;
				container.style.display = "";
				var maxZIndex = this.util.getMaxZIndex();
				var zIndex = maxZIndex + 10;
				container.style.zIndex = zIndex;
				this.__nsEditor.__getFixedComp().style.zIndex = zIndex - 4;
				this.__showModalMask(zIndex - 2);
		    //}
		};
		
		this.__hide = function()
		{
			var container = this.__compOuterContainer;
			var style = {display: "none",zIndex: "",width: "",height: ""};
	        this.util.css(container,style);
	        this.__hideModalMask();
		};
		
		this.__fitSize = function()
		{
			var modalBody = this.__compOuterContainer.querySelector(".nsEditorModalBody");
			var modalContent = this.__compOuterContainer.querySelector(".nsEditorModalContentContainer");
			//var rectModalContent = modalContent.getBoundingClientRect();
			var rectModalBody = modalBody.getBoundingClientRect();
			modalBody.style.width = rectModalBody.width + "px";
			modalBody.style.height = rectModalBody.height + "px";
			return rectModalBody;
		};
		
		this.__safeSetOffset = function(offset) 
		{
			var doc = this.__nsEditor.__dom.doc;
			var html = doc.documentElement || doc.body;
			var htmlRect = html.getBoundingClientRect();
		    var rect = this.__compOuterContainer.getBoundingClientRect();
		    var left = offset.left;
		    if (left + rect.width > htmlRect.right) 
		    {
		        left = htmlRect.right - rect.width;
		    }
		    var top = offset.top;
		    if (top + rect.height > htmlRect.bottom) 
		    {
		        top = htmlRect.bottom - rect.height;
		    }
		    this.util.css(this.__compOuterContainer,{left: Math.max(left, 0),top: Math.max(top, 0)});
		};
		
		this.__showModalMask = function(zIndex)
		{
			if(this.__config.showMask)
			{
				this.__setModalMask();
				var style = {display: "",zIndex: zIndex};
		        this.util.css(this.__divModalMask,style);
			}
		};
		
		this.__hideModalMask = function()
		{
			var style = {display: "none",zIndex: "",width:"",height:""};
	        this.util.css(this.__divModalMask,style);
		};
		
		this.__setModalMask = function()
		{
			var doc = this.__nsEditor.__dom.doc;
			var html = doc.documentElement || doc.body;
			var htmlRect = html.getBoundingClientRect();
			var style = {width: htmlRect.width,height: htmlRect.height};
	        this.util.css(this.__divModalMask,style);
		};
		
		this.__maskMouseDownHandler = function(event)
		{
			event = this.util.getEvent(event);
			event.preventDefault();
		};
		
		this.__titleBarMouseDownHandler = function(event)
		{
			if(this.__config.enableDraggable)
			{
				event = this.util.getEvent(event);
				var win = this.__nsEditor.__dom.window;
				var doc = this.__nsEditor.__dom.doc;
				var html = doc.documentElement || doc.body;
				var htmlRect = html.getBoundingClientRect();
				this.__objDrag = {dragging:true,startX: event.clientX,startY: event.clientY,dragging:this.__dragging.bind(this),dragEnd:this.__dragEnd.bind(this)};
				this.util.addEvent(doc,"mousemove",this.__objDrag.dragging);
				this.util.addEvent(doc,"mouseup",this.__objDrag.dragEnd);
				this.util.addEvent(win,"mouseup",this.__objDrag.dragEnd);
				event.preventDefault();
				this.__dragStart(event);
			}
		};
		
		this.__dragStart = function(event)
		{
			this.__objDrag.rect = this.__compOuterContainer.getBoundingClientRect();
			var contentMask = this.__compOuterContainer.querySelector(".nsEditorModalContentMask");
			contentMask.style.visibility = "visible";
			var zIndex = this.__compOuterContainer.style.zIndex;
			this.__showModalMask(zIndex - 1);
		};
		
		this.__dragging = function(event)
		{
			if(this.__objDrag && this.__objDrag.dragging)
			{
				event = this.util.getEvent(event);
				var x = event.clientX - this.__objDrag.startX;
		        var y = event.clientY - this.__objDrag.startY;
		        var offset = {};
		        offset.left = this.__objDrag.rect.left + x;
		        offset.top = this.__objDrag.rect.top + y;
	            this.__safeSetOffset(offset);
		        event.stopPropagation();
			}
		};
		
		this.__dragEnd = function(event)
		{
			if(this.__objDrag)
			{
				var win = this.__nsEditor.__dom.window;
				var doc = this.__nsEditor.__dom.doc;
				this.util.removeEvent(doc,"mousemove",this.__objDrag.dragging);
				this.util.removeEvent(doc,"mouseup",this.__objDrag.dragEnd);
				this.util.removeEvent(win,"mouseup",this.__objDrag.dragEnd);
				if(this.__objDrag.dragging)
				{
					var contentMask = this.__compOuterContainer.querySelector(".nsEditorModalContentMask");
					contentMask.style.visibility = "hidden";
					this.util.removeStyleClass(this.__compOuterContainer,"nsEditorModalCentered");
					//this.__hideModalMask();
				}
				this.__objDrag = null;
			}
		};
		
		this.__getContainer = function()
		{
			var htmlContent = this.__config.contentCallback(this,this.__nsParentPluggin);
			var htmlFooter = this.__config.footerCallback ? this.__config.footerCallback(this,this.__nsParentPluggin) : "";
			var modalContainerClass = this.__config.isFullScreen ? "nsEditorModalContainerFullScreen" : "nsEditorModal nsEditorFor##name##";
			var html = "<div id=\"##id##ModalOuterContainer\" class=\"nsEditorModal nsEditorFor##name##\">\r\n" + 
"							<div id=\"##id##ModalContainer\" class=\"" + modalContainerClass + " nsEditorModalContainer\">\r\n" + 
"								<div id=\"##id##ModalBody\" class=\"nsEditorModalBody\">\r\n" + 
"									<div class=\"nsEditorModalShadow\"></div>\r\n" + 
"									<div id=\"##id##ModalTitlebar\" class=\"nsEditorModalTitlebar\">\r\n" + 
"										<div class=\"nsEditorModalDragHandle\">\r\n" + 
"											<span class=\"nsEditorModalCaption\">\r\n" + 
"												" + this.__config.title + " \r\n" + 
"											</span>\r\n" + 
"										</div>\r\n" + 
"										<div id=\"##id##ModalCloseButtonContainer\" class=\"nsEditorModalCloseButtonContainer\">\r\n" + 
"											<button type=\"button\" data-command=\"close\" class=\"nsEditorModalButton nsEditorModalCloseButton\" aria-label=\"Close\" title=\"Close\">\r\n" + 
"												<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.74 15.74\">\r\n" + 
"													<g>\r\n" + 
"														<path d=\"M14.15,11.63l5.61,5.61a1.29,1.29,0,0,1,.38.93,1.27,1.27,0,0,1-.4.93,1.25,1.25,0,0,1-.92.4,1.31,1.31,0,0,1-.94-.4l-5.61-5.61L6.67,19.1a1.31,1.31,0,0,1-.94.4,1.24,1.24,0,0,1-.92-.4,1.27,1.27,0,0,1-.4-.93,1.33,1.33,0,0,1,.38-.93l5.61-5.63L4.79,6a1.26,1.26,0,0,1-.38-.93,1.22,1.22,0,0,1,.4-.92,1.28,1.28,0,0,1,.92-.39,1.38,1.38,0,0,1,.94.38l5.61,5.61,5.61-5.61a1.33,1.33,0,0,1,.94-.38,1.26,1.26,0,0,1,.92.39,1.24,1.24,0,0,1,.4.92,1.29,1.29,0,0,1-.39.93L17,8.81l-2.8,2.82Z\" transform=\"translate(-4.41 -3.76)\"/>\r\n" + 
"													</g>\r\n" + 
"												</svg>\r\n" + 
"											</button>\r\n" + 
"										</div>\r\n" + 
"									</div>\r\n" + 
"									<div id=\"##id##ContentContainer\" class=\"nsEditorModalContentContainer " + this.__config.contentCSSClass + "\">\r\n" + 
"										<span id=\"##id##ContentMask\" class=\"nsEditorModalContentMask\"></span>\r\n" +
"										<div id=\"##id##Content\" class=\"nsEditorModalContent\">\r\n" +
"										</div>\r\n" +
"									</div>\r\n" + 
"									 " + (htmlFooter ? "<div class=\"nsEditorModalFooter\"></div>" : "")  + " \r\n" +
"								</div>\r\n" + 
"							</div>\r\n" + 
"						</div>";
			
			html = html.replaceAll("##id##",this.__id); 
			html = html.replaceAll("##name##",this.__nsParentPluggin.name);
			var compOuterContainer = this.util.getElementFromHtml(html);
			var compContent = compOuterContainer.querySelector(".nsEditorModalContent");
			this.__addCompInParent(compContent,htmlContent)
			var compFooter = compOuterContainer.querySelector(".nsEditorModalFooter");
			if(compFooter)
			{
				this.__addCompInParent(compFooter,htmlFooter)
			}
			var btnClose = compOuterContainer.querySelector(".nsEditorModalCloseButton");
			this.util.addEvent(btnClose,"click",this.close.bind(this));
			var compDragHandle = compOuterContainer.querySelector(".nsEditorModalDragHandle");
			this.util.addEvent(compDragHandle,"mousedown",this.__titleBarMouseDownHandler.bind(this));
			return compOuterContainer;
		};
		
		this.__addCompInParent = function(parent,content)
		{
			if(this.util.isString(content))
			{
				parent.innerHTML = content;
			}
			else
			{
				parent.appendChild(content);
			}
		};
		
		this.__initialize();
	};
	
	NSEditor.prototype.registerUtil("modal",NSEditorModal);
	
	return NSEditorModal;
})();
nsModuleExport(this,"NSEditorModal",NSEditorModal); var NSEditorInlinePopup = (function()
{
	var NSEditorInlinePopup = function(nsEditor,nsParentPluggin,setting)
	{
		this.__nsEditor = nsEditor;
		this.__nsParentPluggin = nsParentPluggin;
		this.__setting = setting;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.__divModalMask = null;
		this.__divDragMask = null;
		this.__id = null;
		this.__compOuterContainer = null;
		this.__originalValue = null;
		this.__objDrag = null;
		this.__docClickRef = null;
		
		this.__initialize = function()
		{
			this.__setSetting();
			this.__componentsInitialized();
		};
		
		this.__setSetting = function()
		{
			if(!this.__setting)
			{
				throw this.util.throwNSError("NSEditorInlinePopup","Setting for Pluggin " + this.__nsParentPluggin.name + " is not defined");
			}
			var config = this.__setting;
			if(!config.contentCallback)
			{
				throw this.util.throwNSError("NSEditorInlinePopup","ContentCallback in setting for Pluggin " + this.__nsParentPluggin.name + " is not defined");
			}
			this.__config = {
								container: config["container"] || this.__nsEditor.__getFixedComp(),
								title: config["title"] || "",
								enableArrow: this.util.isUndefinedOrNull(config["enableArrow"]) ? true : Boolean.parse(config["enableArrow"]),
								contentCallback: this.util.getFunction(config["contentCallback"])
						    };
			
		};
		
		this.__componentsInitialized = function()
		{
			this.__createComponents();
			this.__nsEditor.__listenInternalEvent("resized change changePlace readonly",this.hide.bind(this));
			this.__nsEditor.__listenInternalEvent("destroy",this.destroy.bind(this));
		};
		
		this.__createComponents = function()
		{
			this.__id = this.__nsEditor.getID() + (this.__nsParentPluggin.name ? this.__nsParentPluggin.name : "") + "EditorModal";
			this.destroy();
			this.__compOuterContainer = this.__getContainer();
			this.__config.container.appendChild(this.__compOuterContainer);
			var compArrow = this.__compOuterContainer.querySelector(".nsEditorInlinePopupArrowUp");
			//11 --> border of arrow
			compArrow.style.marginLeft = ((this.__compOuterContainer.offsetWidth / 2) - 11) + "px";
			this.__hide();
			this.util.addEvent(this.__compOuterContainer,"blur",this.__containerBlurHandler.bind(this),true);
			this.util.addEvent(this.__compOuterContainer,"click",this.editorUtil.stopEvent.bind(this.editorUtil));
		};
				
		this.show = function(element,event,offset,direction) 
		{
			this.__showAtElement(element,event,offset,direction);
			this.__nsEditor.__dispatchInternalEvent("inlinePopupShow",{inlinePopup:this});
		};
		
		this.hide = function()
		{
			if (!this.isHidden()) 
			{
				this.__hide();
				this.__nsEditor.__dispatchInternalEvent("inlinePopupHide",{inlinePopup:this});
		    }
		};
				
		this.isHidden = function()
		{
			if(!this.isDestroyed())
			{
				return this.util.hasStyleClass(this.__compOuterContainer,"nsEditorInlinePopupHide")
			}
			return true;
		};
		
		this.isDestroyed = function()
		{
			if(this.__compOuterContainer && this.__compOuterContainer.parentElement)
			{
				return false;
			}
			return true;
		};
		
		this.getHorizontalSeparator = function(id)
		{
			var div = this.util.createDiv(id,"nsEditorInlinePopupHorizontalSeparator");
			return div;
		};
		
		this.getMenuItem = function(id,cssClass,content,toolTipContent,subMenu,handler)
		{
			var button = this.__createButton(id,cssClass,content,toolTipContent);
			if(subMenu && subMenu.length > 0)
			{
				this.util.addStyleClass(button,"nsEditorInlinePopupButtonDropdown");
				var divContainer = this.util.createDiv(null,"nsEditorInlinePopupButtonDropdownContainer");
				divContainer.appendChild(button);
				var divDropdownCon = this.util.createDiv(null,"nsEditorInlinePopupDropdownContainer");
				var compDropdown = this.util.createElement("ul",null,"nsEditorInlinePopupButtonDropdown");
				for(var count = 0;count < subMenu.length;count++)
				{
					var li = subMenu[count];
					compDropdown.appendChild(li);
				}
				divDropdownCon.appendChild(compDropdown);
				divContainer.appendChild(divDropdownCon);
				this.util.addEvent(button,"click",this.__btnHandlerWithSubMenu.bind(this,button,divContainer,divDropdownCon,handler));
				return divContainer;
			}
			else
			{
				this.util.addEvent(button,"click",this.__btnHandler.bind(this,button,handler));
			}
			return button;
		};
		
		this.getSubMenuItem = function(id,cssClass,content,toolTipContent,handler)
		{
			var li = this.util.createElement("li",id,"nsEditorInlinePopupButtonDropdownItem");
			if(cssClass)
			{
				this.util.addStyleClass(li,cssClass);
			}
			var anchor = this.util.createElement("a",null,"nsEditorInlinePopupButtonDropdownItemContent");
			this.__setAttribute(anchor,{tabindex: "-1", role: "option"});
			if(content)
			{
				this.__addCompInParent(anchor,content)
			}
			if(toolTipContent)
			{
				var toolTip = this.__createTooltip(toolTipContent);
				//anchor.appendChild(toolTip);
			}
			li.appendChild(anchor);
			this.util.addEvent(li,"click",this.__btnSubMenuHandler.bind(this,li,handler));
			return li;
		};
		
		this.destroy = function()
		{
			if(this.__compOuterContainer && this.__compOuterContainer.parentElement)
			{
				this.__compOuterContainer.parentElement.removeChild(this.__compOuterContainer);
				this.__compOuterContainer = null;
			}
		};
		
		this.__createButton = function(id,cssClass,content,toolTipContent)
		{
			var button = this.util.createElement("button",id,"nsEditorInlinePopupButton");
			var objAttribute = {type: "button",tabindex: "-1",role:"button","data-title": (toolTip ? toolTip : "")};
			this.__setAttribute(button,objAttribute);
			if(cssClass)
			{
				this.util.addStyleClass(button,cssClass);
			}
			if(content)
			{
				this.__addCompInParent(button,content)
			}
			if(toolTipContent)
			{
				var toolTip = this.__createTooltip(toolTipContent);
				button.appendChild(toolTip);
			}
			return button;
		};
		
		this.__createTooltip = function(toolTipContent)
		{
			var toolTip = this.util.createElement("span",null,"nsEditorInlinePopupButtonTooltip");
			var toolTipText = this.util.createElement("span",null,"nsEditorInlinePopupButtonTooltipText");
			toolTipText.innerHTML = toolTipContent;
			toolTip.appendChild(toolTipText);
			
			return toolTip;
		};
		
		this.__btnHandler = function(button,handler,event)
		{
			event = this.util.getEvent(event);
			this.__commonBtnHandler(button,event);
			handler && handler(event,button);
			this.hide();
		};
		
		this.__btnHandlerWithSubMenu = function(button,container,dropdownContainer,handler,event)
		{
			event = this.util.getEvent(event);
			var self = this;
			this.__commonBtnHandler(button,event,function(btn){
				if(btn != button)
				{
					//var con = btn.parentElement;
					self.util.removeStyleClass(btn,"nsEditorInlinePopupButtonOpen");
				}
			});
			var isDropdownOpen = this.util.hasStyleClass(dropdownContainer,"nsEditorInlinePopupDropdownContainerVisible");
			if(isDropdownOpen)
			{
				this.util.removeStyleClass(button,"nsEditorInlinePopupButtonOpen");
				this.util.removeStyleClass(dropdownContainer,"nsEditorInlinePopupDropdownContainerVisible");
			}
			else
			{
				this.__resetMenuButtons(true);
				this.__resetSubMenuButtons();
				this.util.addStyleClass(button,"nsEditorInlinePopupButtonOpen");
				this.util.addStyleClass(dropdownContainer,"nsEditorInlinePopupDropdownContainerVisible");
			}
			handler && handler(event,button);
		};
		
		this.__btnSubMenuHandler = function(button,handler,event)
		{
			event = this.util.getEvent(event);
			this.__commonBtnHandler(button,event);
			this.hide();
			handler && handler(event,button);
		};
		
		this.__commonBtnHandler = function(button,event,callback)
		{
			var arrButton = this.__compOuterContainer.querySelectorAll(".nsEditorInlinePopupButton");
			for(var count = 0;count < arrButton.length;count++)
			{
				this.util.removeStyleClass(arrButton[count],"nsEditorInlinePopupButtonActive");
				callback && callback(arrButton[count]);
			}
			this.util.addStyleClass(button,"nsEditorInlinePopupButtonActive");
			this.editorUtil.stopEvent(event);
		};
		
		this.__containerBlurHandler = function(event)
		{
			event = this.util.getEvent(event);
			var target = event.target;
			if(!this.__compOuterContainer.contains(target))
			{
				this.editorUtil.stopEvent();
				this.hide();
			}
		};
		
		this.__setAttribute = function(element,item)
		{
			for(var key in item)
			{
				element.setAttribute(key,item[key].toString());
			}
		};
		
		this.__getContainer = function()
		{
			var html = "<div id=\"##id##InlinePopUpOuterContainer\" class=\"nsEditorInlinePopup nsEditorInlinePopupFor##name##\">\r\n" + 
"							" + (this.__config.enableArrow ? "<div id=\"##id##InlinePopUpArrow\" class=\"nsEditorInlinePopupArrow nsEditorInlinePopupArrowUp\"></div>" : "") + "\r\n" +
"							<div id=\"##id##InlinePopUpContentContainer\" class=\"nsEditorInlinePopupContentContainer\"></div> \r\n" +
"						</div>";
			html = html.replaceAll("##id##",this.__id);
			html = html.replaceAll("##name##",(this.__nsParentPluggin.name ? this.__nsParentPluggin.name : ""));
			var compOuterContainer = this.util.getElementFromHtml(html);
			compOuterContainer.setAttribute("tabindex","-1");
			var compContent = compOuterContainer.querySelector(".nsEditorInlinePopupContentContainer");
			var content = this.__config.contentCallback(compContent,this,this.__nsParentPluggin);
			this.__addCompInParent(compContent,content);
			return compOuterContainer;
		};
		
		this.__addCompInParent = function(parent,content)
		{
			if(content)
			{
				if(this.util.isString(content))
				{
					parent.innerHTML = content;
				}
				else
				{
					parent.appendChild(content);
				}
			}
		};
		
		this.__hide = function()
		{
			if (!this.isHidden()) 
			{
				if(this.__docClickRef)
				{
					this.util.removeEvent(this.__nsEditor.__dom.doc,"click",this.__docClickRef);
					this.__docClickRef = null;
				}
				this.__resetMenuButtons();
				this.__resetSubMenuButtons();
				this.util.addStyleClass(this.__compOuterContainer,"nsEditorInlinePopupHide");
			}
		};
		
		this.__showAtElement = function(element,event,offset,direction) 
		{
			this.util.removeStyleClass(this.__compOuterContainer,"nsEditorInlinePopupHide");
			var win = this.__nsEditor.__dom.win;
			var doc = this.__nsEditor.__dom.doc;
			var compTextArea = this.__nsEditor.__compTextArea;
			var self = this;
			var offsetFunc = function(el) 
			{
			    var rect = el.getBoundingClientRect();
			    var scrollLeft = win.pageXOffset || doc.documentElement.scrollLeft;
			    var scrollTop = win.pageYOffset || doc.documentElement.scrollTop;
			    var textAreaRect = {left: 0,top: 0};
			    if(!self.__nsEditor.__isModeTextArea())
			    {
			    	textAreaRect = compTextArea.getBoundingClientRect();
			    }
			    //return { top: rect.top + scrollTop + textAreaRect.top, left: rect.left + scrollLeft  + textAreaRect.left};
			    //looks like rect is including scroll position
			    var width = self.__compOuterContainer.offsetWidth;
			    //11 is top of arrow
			    return { top: rect.top + textAreaRect.top + (11/2) , left: (rect.left + textAreaRect.left - (width/4))};
			}
			direction = direction ? direction : "bottom";
			offset = offset ? offset : {left: 0,top: 0};
			offset.left = offset.left ? offset.left : 0;
			offset.top = offset.top ? offset.top : 0;
			//var eventOffset = this.util.getEventPosition(event);
			var eventOffset = offsetFunc(element);
			this.__compOuterContainer.style.left = (eventOffset.left + offset.left) + "px";
			this.__compOuterContainer.style.top = (eventOffset.top + offset.top + element.offsetHeight) + "px";
			if(!this.__docClickRef)
			{
				this.__docClickRef = this.__documentClickHandler.bind(this);
				this.util.addEvent(this.__nsEditor.__dom.doc,"click",this.__docClickRef);
			}
			/*var self = this;
			setTimeout(function() {
				self.util.removeStyleClass(self.__compOuterContainer,"nsEditorInlinePopupHide");
			}, 50);*/
			//this.__compOuterContainer.focus();
			//this.editorUtil.setElementPosition(this.__compOuterContainer,element,direction);
	    };
	    
	    this.__documentClickHandler = function(event)
	    {
	    	this.hide();
	    };
	    
	    this.__resetMenuButtons = function(excludeActive)
		{
	    	this.__resetBtn("nsEditorInlinePopupButtonOpen");
	    	!excludeActive && this.__resetBtn("nsEditorInlinePopupButtonActive");
		};
		
		this.__resetSubMenuButtons = function()
		{
			this.__resetBtn("nsEditorInlinePopupDropdownContainerVisible");
		};
		
		this.__resetBtn = function(cssClass)
		{
			var arrBtn = this.__compOuterContainer.querySelectorAll("." + cssClass);
			for(var count = 0;count < arrBtn.length;count++)
			{
				this.util.removeStyleClass(arrBtn[count],cssClass);
			}
		};
		
		this.__initialize();
	};
	
	NSEditor.prototype.registerUtil("inlinePopup",NSEditorInlinePopup);
	
	return NSEditorInlinePopup;
})();
nsModuleExport(this,"NSEditorInlinePopup",NSEditorInlinePopup); var NSEditorUIFunc = (function()
{
	var NSEditorUIFunc = function(nsEditor,nsParentPluggin,setting)
	{
		this.__nsEditor = nsEditor;
		this.__nsParentPluggin = nsParentPluggin;
		this.__setting = setting;
		
		this.horizontalAlign = {left:"left",right:"right",center:"center",justify:"justify"};
		this.verticalAlign = {top:"top",middle:"middle",bottom:"bottom",normal:"delete"};
		
		this.__initialize = function()
		{
		};
		
		//horizontal Align section start
		this.setHorizontalAlignForNodes = function(alignment,arrNodes)
		{
			this.setAlignmentForNodes(alignment,arrNodes,this.horizontalAlign,"textAlign");
		};
		
		this.setHorizontalAlignForNode = function(alignment,node)
		{
			this.setAlignmentForNode(this.horizontalAlign,alignment,node,"textAlign");
		};
		
		this.clearHorizontalAlign = function(node)
		{
			this.clearAlign(node,"textAlign");
		};
		//horizontal Align section ends
		
		//vertical Align section starts
		this.setVerticalAlignForNodes = function(alignment,arrNodes)
		{
			var callback = null;
			if(alignment == "normal")
			{
				var self = this;
				callback = function(node)
				{
					if(node) 
					{
						self.clearVerticalAlign(node);
		            }
				};
			}
			this.setAlignmentForNodes(alignment,arrNodes,this.verticalAlign,"verticalAlign",callback)
		};
		
		this.setVerticalAlignForNode = function(alignment,node)
		{
			this.setAlignmentForNode(this.verticalAlign,alignment,node,"verticalAlign");
		};
		
		this.clearVerticalAlign = function(node)
		{
			this.clearAlign(node,"verticalAlign");
		};
		//vertical Align section ends
		
		this.setAlignmentForNodes = function(alignment,arrNodes,objAlign,styleProp,callback)
		{
			var self = this;
			var doc = this.__nsEditor.__getDocument();
			var win = this.__nsEditor.__getWindow();
    		var textArea = this.__nsEditor.__getTextArea();
    		callback = callback || function(node)
			{
				if(node) 
				{
					var parent = self.util.findParentByCallback(node,function(paramNode) 
					{ 
						return self.editorUtil.isBlock(paramNode,win); 
					},textArea);
		            if (!parent) 
		            {
		            	parent = self.editorUtil.wrapAllInlineSiblings(node,self.__nsEditor.__config.enterElement);
		            }
		            self.setAlignmentForNode(objAlign,alignment,parent,styleProp);
	            }
			};
			if(arrNodes && arrNodes.length)
			{
				for(var count = 0;count < arrNodes.length;count++)
				{
					callback(arrNodes[count]);
				}
			}
			else
			{
				this.selection.loopSelectedNodes(callback);
			}
		};
		
		this.setAlignmentForNode = function(objAlign,alignment,node,styleProp)
		{
			var doc = this.__nsEditor.__getDocument();
			var win = this.__nsEditor.__getWindow();
    		var textArea = this.__nsEditor.__getTextArea();
			if(alignment && this.util.isElement(node) && this.editorUtil.isNode(node,win))
			{
				this.clearAlign(node,styleProp);
				var align = objAlign[alignment.toLowerCase()];
				if(align)
				{
					node.style[styleProp] = align;
				}
			}
		};
		
		this.clearAlign = function(node,styleProp)
		{
			var self = this;
			var clearAlign = function(paramNode)
			{
				if (self.util.isElement(paramNode)) 
				{
					if (paramNode.style[styleProp]) 
					{
						paramNode.style[styleProp] = "";
						if (!paramNode.style.cssText.trim().length) 
						{
							paramNode.removeAttribute("style");
						}
					}
				}
			};
			if(node)
			{
				var arrChild = node.childNodes;
				for(var count = 0;count < arrChild.length;count++)
				{
					clearAlign(arrChild[count]);
				}
				clearAlign(node);
			}
		};
		
		this.__initialize();
	};
	
	NSEditor.prototype.registerUtil("uiFunc",NSEditorUIFunc);
	
	return NSEditorUIFunc;
})();
nsModuleExport(this,"NSEditorUIFunc",NSEditorUIFunc);var NSEditorFullScreen = (function()
{	
	var NSEditorFullScreen = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		
		this.__orignalSetting = {height:null,width: null,changed: false};
		
		this.setSettings = function()
		{
			var self = this;
			this.__nsEditor.__toolBarButton["fullScreen"] = {html:"<i class='ns-icon ns-editor-expand' aria-hidden='true'></i>",tooltip:"Full Screen",showAsMenu: true,
												  checkDisability: function(toolBarKey,toolBarItem,item,itemKey,isDefaultDisabled)
												  {
													  //it should enabled every time
													  return !isDefaultDisabled;
												  },
												  click:function(item,key,event)
												  {
													  self.toggle();
													  event = self.util.getEvent();
													  var iTag = event.target;
													  if(event.target.nodeName.toLowerCase() === "button")
													  {
														  iTag = event.target.children[0];
													  }
													  if(iTag)
													  {
														  if(self.util.hasStyleClass(iTag,"ns-editor-expand"))
														  {
															  self.util.removeStyleClass(iTag,"ns-editor-expand");
															  self.util.addStyleClass(iTag,"ns-editor-collapse");
														  }
														  else
														  {
															  self.util.addStyleClass(iTag,"ns-editor-expand");
															  self.util.removeStyleClass(iTag,"ns-editor-collapse");
														  }
													  }
												  }};
		};
		
		this.initialize = function()
		{
			this.__nsEditor.__listenInternalEvent("toggleFullSize",this.toggle.bind(this));
		};
		
		this.componentsInitialized = function()
		{
			
		};
		
		this.resized = function(event)
		{
			if(this.isFullScreen())
			{
				this.__resizeContainer(false);
			}
		};
		
		this.destroy = function()
		{
			
		};
		
		this.toggle = function()
		{
			this.isFullScreen() ? this.restore() : this.maximize();
		};
		
		this.isFullScreen = function()
		{
			return this.util.hasStyleClass(this.__nsEditor.__divOuterContainer,"nsEditorFullScreen");
		};
		
		this.maximize = function()
		{
			if(!this.isFullScreen())
			{
				var con = this.__nsEditor.__divOuterContainer;
				var zIndex = this.util.getMaxZIndex(con);
				if(zIndex > 0)
				{
					con.style.zIndex = zIndex + 1;
				}
				this.util.addStyleClass(con,"nsEditorFullScreen");
				this.__setParentsPosition(false);
	            this.__resizeContainer(false);
	            this.__nsEditor.__dispatchInternalEvent(NSEditor.EVENT_MAXIMIZED);
	            this.__nsEditor.__dispatchInternalEvent("resizeFullScreen");
				this.__nsEditor.__dispatchEvent(NSEditor.EVENT_MAXIMIZED);
			}
		};
		
		this.restore = function()
		{
			if(this.isFullScreen())
			{
				var con = this.__nsEditor.__divOuterContainer;
				con.style.zIndex = "";
				this.util.removeStyleClass(con,"nsEditorFullScreen");
				this.__setParentsPosition(true);
	            this.__resizeContainer(true);
				this.__nsEditor.__dispatchInternalEvent(NSEditor.EVENT_RESTORED);
				this.__nsEditor.__dispatchInternalEvent("resizeFullScreen");
				this.__nsEditor.__dispatchEvent(NSEditor.EVENT_RESTORED);
			}
		};
		
		this.__setParentsPosition = function(isReset)
		{
			var parent = this.__nsEditor.__divOuterContainer.parentNode;
            while (parent && parent.nodeType !== Node.DOCUMENT_NODE) 
            {
            	isReset ? this.util.removeStyleClass(parent,"nsEditorFullScreenParent") : this.util.addStyleClass(parent,"nsEditorFullScreenParent");
            	parent = parent.parentNode;
            }
		};
		
		this.__resizeContainer = function(isReset)
		{
			var container = this.__nsEditor.__divOuterContainer;
			if(isReset)
			{
				if(this.__orignalSetting.changed)
				{
					var item = {height:this.__orignalSetting.height || "auto",
								width:this.__orignalSetting.width || "auto"};
					this.util.css(container,item);
					this.__orignalSetting = {height:null,width: null,changed: false};
					this.__nsEditor.__resizeCallback(false);
				}
			}
			else
			{
				this.__orignalSetting.height = this.util.getStyleValue(container,"height",false,true);
				this.__orignalSetting.width = this.util.getStyleValue(container,"width",false,true);
				var item = {height:this.__nsEditor.__context.innerHeight,width:this.__nsEditor.__context.innerWidth};
				this.util.css(container,item);
				this.__orignalSetting.changed = true;
				this.__nsEditor.__resizeCallback(true);
			}
		};
		
		NSEditor.prototype.maximize = function()
		{
			var objFullScreen = this.__pluginsInstances["fullScreen"].instance;
			objFullScreen.maximize();
		};
		
		NSEditor.prototype.restore = function()
		{
			var objFullScreen = this.__pluginsInstances["fullScreen"].instance;
			objFullScreen.restore();
		};
		
		NSEditor.prototype.isFullScreen = function()
		{
			var objFullScreen = this.__pluginsInstances["fullScreen"].instance;
			return objFullScreen.isFullScreen();
		};
		
		NSEditor.prototype.toggleFullScreen = function()
		{
			var objFullScreen = this.__pluginsInstances["fullScreen"].instance;
			return objFullScreen.toggle();
		};
		
	};
	NSEditor.TOOLBAR_BUTTONS_FULLSCREEN = "fullScreen";
	NSEditor.EVENT_MAXIMIZED = "maximized";
	NSEditor.EVENT_RESTORED = "restored";
	NSEditor.prototype.registerPlugin("fullScreen",NSEditorFullScreen);
	
	return NSEditorFullScreen;
})();
nsModuleExport(this,"NSEditorFullScreen",NSEditorFullScreen);var NSEditorResize = (function()
{
	var NSEditorResize = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		
		this.__enableResizeHorizontal = false;
		this.__enableResizeVertical = false;
		this.__objStart = {xPos:0,yPos:0,width:0,height:0,isResized: false};
		this.__docMouseMoveRef = null;
		this.__docMouseUpRef = null;
		
		this.setSettings = function()
		{
			this.__nsEditor.__config["enableResize"] = Boolean.parse(this.__nsEditor.__setting["enableResize"]);
			this.__nsEditor.__config["resizeDirection"] = this.__nsEditor.__setting["resizeDirection"] || NSEditor.RESIZE_DIRECTION_VERTICAL;
			this.__enableResizeHorizontal = (this.__nsEditor.__config["resizeDirection"] == NSEditor.RESIZE_DIRECTION_BOTH || this.__nsEditor.__config["resizeDirection"] == NSEditor.RESIZE_DIRECTION_HORIZONTAL);
			this.__enableResizeVertical = (this.__nsEditor.__config["resizeDirection"] == NSEditor.RESIZE_DIRECTION_BOTH || this.__nsEditor.__config["resizeDirection"] == NSEditor.RESIZE_DIRECTION_VERTICAL);
		};
		
		this.initialize = function()
		{
		};
		
		this.componentsInitialized = function()
		{
			if(this.__nsEditor.__config.enableResize && this.__nsEditor.__config.height != "auto")
			{
				this.__nsEditor.__handleVisibilityOfComponent(this.__nsEditor.__divFooterContainer,"enableResize");
				var spanResizer = this.util.createElement("span",this.__nsEditor.getID() + "Resizer","nsEditorResizer");
				if(this.__nsEditor.__config["resizeDirection"] !==  NSEditor.RESIZE_DIRECTION_BOTH)
				{
					this.util.addStyleClass(spanResizer,"nsEditorResizer" + this.__nsEditor.__config["resizeDirection"]);
				}
				spanResizer.innerHTML = "\u25E2";
				this.util.addEvent(spanResizer,"mousedown touchstart",this.__resizeMouseDownHandler.bind(this));
				this.__nsEditor.__divFooterContainer.appendChild(spanResizer);
				var self = this;
				this.__nsEditor.__listenInternalEvent(NSEditor.EVENT_MAXIMIZED,function(event){
					self.util.addStyleClass(spanResizer,"nsEditorComponentHidden");
				});
				this.__nsEditor.__listenInternalEvent(NSEditor.EVENT_RESTORED,function(event){
					self.util.removeStyleClass(spanResizer,"nsEditorComponentHidden");
				});
			}
		};
		
		this.resized = function(event)
		{
			
		};
		
		this.destroy = function()
		{
			
		};
		
		this.__resizeMouseDownHandler = function(event)
		{
			event = this.util.getEvent(event);
			var outerContainer = this.__nsEditor.__divOuterContainer;
			this.__objStart = {xPos:event.clientX,yPos:event.clientY,width:outerContainer.offsetWidth,height:outerContainer.offsetHeight,isResized: true};
			if(!this.__docMouseMoveRef)
			{
				this.__docMouseMoveRef = this.__docMouseMoveHandler.bind(this);
				this.util.addEvent(this.__nsEditor.__context,"mousemove touchmove",this.__docMouseMoveRef);
			}
			if(!this.__docMouseUpRef)
			{
				this.__docMouseUpRef = this.__docMouseUpHandler.bind(this);
				this.util.addEvent(this.__nsEditor.__context,"mouseup touchend",this.__docMouseUpRef);
			}
			this.__nsEditor.__dispatchInternalEvent("resizeStart");
			event.preventDefault();
		};
		
		this.__docMouseMoveHandler = function(event)
		{
			event = this.util.getEvent(event);
			if(this.__objStart.isResized)
			{
				if (this.__enableResizeHorizontal) 
				{
					var width = this.__objStart.width + event.clientX - this.__objStart.xPos;
					this.__nsEditor.__width(width);
	            }
				if (this.__enableResizeVertical) 
				{
					var height = this.__objStart.height + event.clientY - this.__objStart.yPos;
					this.__nsEditor.__height(height);
	            }
				this.__nsEditor.__resizeCallback();
				this.__nsEditor.__dispatchInternalEvent("resize");
			}
		};
		
		this.__docMouseUpHandler = function(event)
		{
			if(this.__objStart.isResized)
			{
				this.__objStart = {xPos:0,yPos:0,width:0,height:0,isResized: false};
				this.__nsEditor.__dispatchInternalEvent("resizeEnd");
			}
			if(this.__docMouseMoveRef)
			{
				this.util.removeEvent(this.__nsEditor.__context,"mousemove touchmove",this.__docMouseMoveRef);
				this.__docMouseMoveRef = null;
			}
			if(this.__docMouseUpRef)
			{
				this.util.removeEvent(this.__nsEditor.__context,"mouseup touchend",this.__docMouseUpRef);
				this.__docMouseUpRef = null;
			}
		};
	};
	NSEditor.RESIZE_DIRECTION_HORIZONTAL = "horizontal";
	NSEditor.RESIZE_DIRECTION_VERTICAL = "vertical";
	NSEditor.RESIZE_DIRECTION_BOTH = "both";
	NSEditor.prototype.registerPlugin("resize",NSEditorResize);
	
	return NSEditorResize;
})();
nsModuleExport(this,"NSEditorResize",NSEditorResize);var NSEditorLink = (function()
{	
	var NSEditorLink = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.name = "link";
		this.__config = null;
		
		this.__modal = null;
		this.__divBody = null;
		this.__divFooter = null;
		this.__id = null;
		
		this.setSettings = function()
		{
			var self = this;
			var setting = this.__nsEditor.__setting.link;
			if(!setting)
			{
				setting = {};
			}
			this.__config = {
					protocol: setting["protocol"]
			    };
			this.__nsEditor.__toolBarButton["link"] = {html:"<i class='ns-icon ns-editor-link' aria-hidden='true'></i>",tooltip:"Link",showAsMenu: true,
												  checkDisability: function(toolBarKey,toolBarItem,item,itemKey,isDefaultDisabled)
												  {
													  if(itemKey === "viewSourceCode")
													  {
														  return true;
													  }
													  return false;
												  },
												  click:function(item,key,event)
												  {
													  self.selection.saveSelection();
													  self.__createElements();
												  }};
		};
		
		this.initialize = function()
		{
			this.__id = this.__nsEditor.getID() + this.name;
		};
		
		this.componentsInitialized = function()
		{
			
		};
		
		this.resized = function(event)
		{
			
		};
		
		this.destroy = function()
		{
			
		};
		
		this.__createElements = function()
		{
			if(!this.__modal)
			{
				var setting = {title: "Add Link",contentCSSClass:"nsEditorLinkModalContent",enableReset: false,contentCallback: this.__getBody.bind(this),footerCallback: this.__getFooter.bind(this)}
				this.__modal = this.__nsEditor.__getUtilInstance("modal","linkModal",this.name,this,setting);
			}
			this.__modal.toggle();
		};
		
		this.__getBody = function(objModal,objLink)
		{
			if(!this.__divBody)
			{
				this.__divBody = this.util.createDiv(this.__id + "LinkModalContentContainer","nsEditorLinkModalContentContainer");
				var html = '<div class="nsEditorLinkModalContentForm">' +
		                        '<label class="nsEditorLinkModalContentFormLabel">URL</label>' +
		                        '<input id="##id##TxtUrl" class="nsEditorLinkModalContentFormTextBox" type="text" />' +
		                    '</div>' +
		                    '<div class="nsEditorLinkModalContentForm">' +
		                        '<label class="nsEditorLinkModalContentFormLabel">Text to display</label>' +
		                    	'<input id="##id##TxtText" class="nsEditorLinkModalContentFormTextBox" type="text" />' +
		                    '</div>' +
		                    '<div class="nsEditorLinkModalContentFormLast">' +
		                        '<label class="nsEditorLinkModalContentFormLabel">' +
		                    		'<input id="##id##ChkNewWindow" type="checkbox" class="nsEditorLinkModalContentFormCheckbox" checked />&nbsp; Open in new tab or window' + 
		                    		'</label>' +
		                    '</div>';
				html = html.replaceAll("##id##",this.__id);
				this.__divBody.innerHTML = html;
			}
	        return this.__divBody;
		};
		
		this.__getFooter = function(objModal,objLink)
		{
			if(!this.__divFooter)
			{
				this.__divFooter = this.util.createDiv(null,"nsEditorLinkFooterContainer");
				this.__divFooter.innerHTML = "<button class=\"nsEditorPrimaryButton nsEditorLinkFooterButton\" title=\"Submit\"><span>Submit</span></button>";
				var btnSubmit = this.__divFooter.querySelector(".nsEditorLinkFooterButton");
				this.util.addEvent(btnSubmit,"click",this.__submitHandler.bind(this));
			}
			return this.__divFooter;
		};
		
		this.__submitHandler = function(event)
		{
			this.editorUtil.stopEvent(event);
			var txtUrl = this.__divBody.querySelector("#" + this.__id + "TxtUrl");
			var txtText = this.__divBody.querySelector("#" + this.__id + "TxtText");
			var chkNewWindow = this.__divBody.querySelector("#" + this.__id + "ChkNewWindow");
			if(txtUrl.value && txtUrl.value.trim().length)
			{
				var url = this.__getLink(txtUrl.value.trim(),this.__config.protocol);
				var anchor = this.util.createElement("a");
				anchor.href = url;
				anchor.textContent = (txtText.value.trim().length) ? txtText.value.trim() : txtUrl.value.trim();
				anchor.target = (chkNewWindow.checked ? "_blank" : "");
				this.__insertLink(anchor);
			}
		};
		
		this.__getLink = function(value,protocol)
		{
	        value = value.trim();
	        var url = !value ? "" : (protocol && value.indexOf('://') === -1 && value.indexOf('#') !== 0) ? protocol + value : value.indexOf('://') === -1 ? '/' + value : value;
	        return url;
		};
		
		this.__insertLink = function(link)
		{
			var arrEvents = [{name:"closeAllPopups"}];
			var config = {insertAfterSelectedNode: false,dispatchEvents: arrEvents};
			this.__nsEditor.__addElement(link,config);
		};
	};
	
	NSEditor.prototype.registerPlugin("link",NSEditorLink);
	
	return NSEditorLink;
})();
nsModuleExport(this,"NSEditorLink",NSEditorLink);var NSEditorTable = (function()
{
	var NSEditorTable = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.__nsTablePicker = null;
		
		this.setSettings = function()
		{
			var self = this;
			this.__nsEditor.__toolBarButton["table"] = {html:"<i class='ns-icon ns-editor-table' aria-hidden='true'></i>",tooltip:"Table",showAsMenu: true,
												  checkDisability: function(toolBarKey,toolBarItem,item,itemKey,isDefaultDisabled)
												  {
													  if(itemKey === "viewSourceCode")
													  {
														  return true;
													  }
													  return false;
												  },
												  click:function(item,key,event)
												  {
													  self.selection.saveSelection();
													  self.toggle.call(self,event);
												  }};
		};
		
		this.initialize = function()
		{
			this.__initializeTablePicker();
		};
		
		this.componentsInitialized = function()
		{
			
		};
		
		this.resized = function(event)
		{
			
		};
		
		this.addStyleInIFrame = function()
		{
			var style = ".nsEditorBody table\r\n" + 
					"{\r\n" + 
					"    border-collapse: collapse;\r\n" + 
					"    margin-bottom: 10px;\r\n" + 
					"    width:100%;\r\n" + 
					"}\r\n" + 
					"\r\n" + 
					".nsEditorBody table tr \r\n" + 
					"{\r\n" + 
					"    user-select: none;\r\n" + 
					"}\r\n" + 
					"\r\n" + 
					".nsEditorBody table tr td,\r\n" + 
					".nsEditorBody table tr th\r\n" + 
					"{\r\n" + 
					"    border: 1px solid #ddd;\r\n" + 
					"    vertical-align: middle;\r\n" + 
					"    user-select: text;\r\n" + 
					"    padding: 5px 10px;\r\n" + 
					"}\r\n" + 
					"\r\n" + 
					".nsEditorBody table .nsEditorHiddenRow\r\n" + 
					"{\r\n" + 
					"	height: 0px;\r\n" + 
					"    overflow: hidden;\r\n" + 
					"    line-height: 0;\r\n" + 
					"}\r\n" + 
					"\r\n" + 
					".nsEditorBody table .nsEditorHiddenRow td\r\n" + 
					"{\r\n" + 
					"	height: 0;\r\n" + 
					"    padding: 0;\r\n" + 
					"    border-top: 0;\r\n" + 
					"    overflow: hidden;\r\n" + 
					"    line-height: 0;\r\n" + 
					"}";
			return style;
		};
		
		this.destroy = function()
		{
			if(this.__nsTablePicker)
			{
				this.__nsTablePicker.remove();
			}
		};
		
		this.toggle = function(event)
		{
			if(this.__nsTablePicker)
			{
				if(this.__nsTablePicker.isOpen())
				{
					this.__nsTablePicker.close(event);
				}
				else
				{
					this.__nsTablePicker.open(event);
					event.stopPropagation();
				}
			}
			
		};
		
		this.__tablePickerCellClick = function(event,cell,rowIndex,cellIndex)
		{
			this.__nsTablePicker.close(event);
			console.log(rowIndex,cellIndex);
			this.__createTable(rowIndex,cellIndex);
		};
		
		this.__getDefaultValues = function()
		{
			var borderMap = {thin: "0px",medium: "1px",thick: "2px"};
			var doc = this.__nsEditor.__getDocument();
			var textArea = this.__nsEditor.__getTextArea();
			var table = this.util.createElement("table",null,null,doc);
		    table.insertRow(0).insertCell(0).innerHTML = "xxx";
		    textArea.appendChild(table);
		    var td = table.getElementsByTagName("td")[0];
		    var tmpValue = this.util.getStyleValue(table, "border-left-width");
		    var tableBorder = parseInt(borderMap[tmpValue] || tmpValue, 10);
		    tmpValue = this.util.getStyleValue(td, "padding-left");
		    var cellPadding = parseInt(borderMap[tmpValue] || tmpValue, 10);
		    tmpValue = this.util.getStyleValue(td, "border-left-width");
		    cellBorder = parseInt(borderMap[tmpValue] || tmpValue, 10);
		    textArea.removeChild(table);
		    return {
		        tableBorder: tableBorder,
		        cellPadding: cellPadding,
		        cellBorder: cellBorder
		    };
		};
		
		this.__getCellWidth = function(colCount)
		{
			var textArea = this.__nsEditor.__getTextArea();
            var doc = this.__nsEditor.__getDocument();
            var parent = textArea;
			var selection = this.selection.getSelection();
			var self = this;
			if(selection && selection.rangeCount)
			{
				var scanParent = function(paramElement)
				{
					return paramElement === textArea || (paramElement && self.editorUtil.isBlock(paramElement,textArea));
				};
				var range = selection.getRangeAt(0);
				var startElement = range.startContainer;
				var blockElement = this.util.findParentByCallback(startElement,scanParent,textArea);
				if(blockElement)
				{
					parent = blockElement;
				}
			}
			var objDefault = this.__getDefaultValues();
			var tableWidth = parent.offsetWidth;
			var extraWidth = (objDefault.cellPadding * 2) - objDefault.cellBorder;
			var cellWidth = Math.floor((tableWidth / colCount) - extraWidth);
			return cellWidth;
		};
		
		this.__createTable = function(rowCount,colCount)
		{
			var textArea = this.__nsEditor.__getTextArea();
            var doc = this.__nsEditor.__getDocument();
			var table = this.util.createElement("table",null,null,doc);
			var thead = this.util.createElement("thead",null,null,doc);
			table.appendChild(thead);
			var tbody = this.util.createElement("tbody",null,null,doc);
			table.appendChild(tbody);
			this.__createFirstRow(doc,table,thead,colCount);
            var firstCell = null;
            var tr = null;
            for (var rowIndex = 1; rowIndex <= rowCount; rowIndex++) 
            {
                tr = this.__createRow(doc,rowIndex,colCount);
                if (!firstCell) 
                {
                	firstCell = tr.children[0];
                }
                tbody.appendChild(doc.createTextNode("\n"));
                tbody.appendChild(tr);
            }
            this.__insertTable(doc,textArea,table,firstCell);
		};
		
		this.__createFirstRow = function(doc,table,thead,colCount)
		{
			var cellWidth = this.__getCellWidth(colCount);
			var tr = this.util.createElement("tr",null,null,doc);
            this.util.addStyleClass(tr,"nsEditorHiddenRow");
            var td = null;
            for (var cellIndex = 1; cellIndex <= colCount; cellIndex++) 
            {
                td = this.util.createElement("td",null,null,doc);
                td.style.width = cellWidth + "px";
                tr.appendChild(td);
            }
            thead.appendChild(tr);
		};
		
		this.__createRow = function(doc,rowIndex,colCount)
		{
			var tr = this.util.createElement("tr",null,null,doc);
			tr.setAttribute("data-ns-row-index",rowIndex);
            for (var cellIndex = 1; cellIndex <= colCount; cellIndex++) 
            {
            	var td = this.__createCell(doc,"td",rowIndex,cellIndex);
                tr.appendChild(doc.createTextNode("\n"));
                tr.appendChild(doc.createTextNode("\t"));
                tr.appendChild(td);
            }
            return tr;
		};
		
		this.__createCell = function(doc,nodeName,rowIndex,cellIndex)
		{
			nodeName = nodeName.toLowerCase();
			var node = this.util.createElement(nodeName,null,null,doc);
			node.setAttribute("data-ns-row-index",rowIndex);
			node.setAttribute("data-ns-cell-index",cellIndex);
			//this.__nsEditor.__nsToolTipInElement.addToolTip(node,"" + cellIndex);
			var div = this.util.createDiv();
			div.appendChild(this.util.createElement("br",null,null,doc));
			node.appendChild(div);
            return node;
		};
		
		this.__insertTable = function(doc,textArea,table,firstCell)
		{
			var self = this;
			var item = {table: table};
			var arrEvents = [{name:"closeAllPopups"},{name:"tableAdded",args:item}];
			var config = {insertAfterSelectedNode: true,insertAfterNodeCallback:function(blockElement){
				return (blockElement && !blockElement.nodeName.match(/^TD|TH|TBODY|TABLE|THEADER|TFOOTER$/));
			},dispatchEvents: arrEvents,afterInsertCallback: function(){
				if(firstCell)
	            {
					self.selection.setCursorIn(firstCell);
					self.util.scrollIntoView(firstCell,textArea,doc);
	            }
			}};
			this.__nsEditor.__addElement(table,config);
		};
		
		this.__initializeTablePicker = function()
		{
			if(!this.__nsTablePicker)
			{
				var setting = {isPopUp: true,width: 145, height:130,cellWidth: 12,cellHeight: 11, rowCount: 12,columnCount: 12, cellClickCallback: this.__tablePickerCellClick.bind(this)  };
				this.__nsTablePicker = new NSTablePicker(setting);
			}
		};
	};
	
	NSEditorTable.setIndexInTable = function(table)
	{
		var util = new NSUtil();
		var arrRow = table.rows;
		for(var rowIndex = 0;rowIndex < arrRow.length;rowIndex++)
		{
			var row = arrRow[rowIndex];
			if(!util.hasStyleClass(row,"nsEditorHiddenRow"))
			{
				row.setAttribute("data-ns-row-index",rowIndex);
				var arrCell = row.cells;
				for(var cellIndex = 0;cellIndex < arrCell.length;cellIndex++)
				{
					var cell = arrCell[cellIndex];
					cell.setAttribute("data-ns-row-index",rowIndex);
					cell.setAttribute("data-ns-cell-index",cellIndex);
				}
			}
		}
	};
	
	NSEditor.prototype.registerPlugin("table",NSEditorTable);
	
	return NSEditorTable;
})();
nsModuleExport(this,"NSEditorTable",NSEditorTable);var NSFooterComp = (function()
{
	var NSFooterComp = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.__compElementPathContainerContainer = null;
		this.__compElementPath = null;
		this.__compWords = null;
		this.__compChars = null;
		
		this.__excludeSpace = true;
		
		this.setSettings = function()
		{
			this.__nsEditor.__config["enableElementPath"] = this.util.isUndefinedOrNull(this.__nsEditor.__setting["enableElementPath"]) ? true : Boolean.parse(this.__nsEditor.__setting["enableElementPath"]);
			this.__nsEditor.__config["enableWordsCount"] = this.util.isUndefinedOrNull(this.__nsEditor.__setting["enableWordsCount"]) ? true : Boolean.parse(this.__nsEditor.__setting["enableWordsCount"]);
			this.__nsEditor.__config["enableCharsCount"] = this.util.isUndefinedOrNull(this.__nsEditor.__setting["enableCharsCount"]) ? true : Boolean.parse(this.__nsEditor.__setting["enableCharsCount"]);
		};
		
		this.initialize = function()
		{
		};
		
		this.componentsInitialized = function()
		{
			if(this.__nsEditor.__config["enableElementPath"])
			{
				this.__compElementPathContainer = this.util.createElement("div",null,"nsEditorElementPathContainer");
				this.__nsEditor.__divFooterLeftContainer.appendChild(this.__compElementPathContainer);
				this.__compElementPath = this.util.createElement("ul",null,"nsEditorElementPath");
				this.__compElementPathContainer.appendChild(this.__compElementPath);
			}
			if(this.__nsEditor.__config["enableWordsCount"])
			{
				this.__compWords = this.util.createElement("span",null,"nsEditorWordsContainer");
				this.__nsEditor.__divFooterRightContainer.appendChild(this.__compWords);
			}
			if(this.__nsEditor.__config["enableCharsCount"])
			{
				this.__compChars = this.util.createElement("span",null,"nsEditorCharsContainer");
				this.__nsEditor.__divFooterRightContainer.appendChild(this.__compChars);
			}
			this.__nsEditor.__listenInternalEvent("change keyup",this.__keyEventHandler.bind(this));
			this.__nsEditor.__listenInternalEvent("mousedown change keyup click selectionchange selectionstart",this.__pathChangeHandler.bind(this));
			this.__refreshFooterComp();
			this.__setElementPath();
		};
		
		this.resized = function(event)
		{
			
		};
		
		this.destroy = function()
		{
		};
		
		this.__keyEventHandler = function(event)
		{
			//var eventDetail = event.detail;
			//var orignalEvent = eventDetail.orignalEvent;
			this.__refreshFooterComp();
		};
		
		this.__pathChangeHandler = function(event)
		{
			//var eventDetail = event.detail;
			//var orignalEvent = eventDetail.orignalEvent;
			this.__setElementPath();
		};
		
		this.__refreshFooterComp = function()
		{
			if(this.__compWords)
			{
				this.__compWords.innerHTML = "Words: " + this.__getWordCount();
			}
			if(this.__compChars)
			{
				this.__compChars.innerHTML = "Chars: " + this.__getCharCount();
			}
		};
		
		this.__setElementPath = function()
		{
			if(this.__compElementPath)
			{
				var element = this.selection.getElementUnderCursor();
				this.__compElementPath.innerHTML = "";
				//var html = "";
				if(element)
				{
					var textArea = this.__nsEditor.__getTextArea();
					var self = this;
					var scanParent = function(paramElement)
					{
						 if(paramElement && textArea !== paramElement && !self.util.isTextNode(paramElement)) 
						 {
							 var name = paramElement.nodeName.toLowerCase();
							 var path = self.__getXPathByElement(paramElement,textArea).replace(/^\//, "");
							 var li = self.__getLI(paramElement,path,name,"Select " + name);
							 if(self.__compElementPath.firstChild)
							 {
								 self.__compElementPath.insertBefore(self.__getSeparatorLI(),self.__compElementPath.firstChild);
							 }
							 self.__compElementPath.insertBefore(li,self.__compElementPath.firstChild);
							 //html = name + (html ? " > " : "") + html;
							 //console.log(html);
						 }
					};
					this.util.findParentByCallback(element,scanParent,textArea);
				}
				//this.__compElementPathContainer.innerHTML = html ? ("Path: " + html) : "";
			}
		};
		
		this.__getSeparatorLI = function() 
		{
			var html = "<li> > </li>";
			var li = this.util.getElementFromHtml(html);
            var a = li.firstChild;
            return li;
		};
		
		this.__getLI = function(bindElement, path, name, title) 
		{
			var html = "<li class=\"nsEditorElementPathItem\"><a role=\"button\" data-nseditor-path=\"" + path + "\" href=\"javascript:void(0)\" title=\"" + title + "\" tabindex=\"-1\"'>" + name + "</a></li>";
            var li = this.util.getElementFromHtml(html);
            var a = li.firstChild;
            this.util.addEvent(a,"click",this.__selectPathHandler.bind(this,bindElement,path,name));
            //this.util.addEvent(a,"contextmenu",this.__contextMenuHandler.bind(this,bindElement));
            return li;
        };
        
        this.__getXPathByElement = function(element, textArea)
        {
        	if (!element || element.nodeType !== 1) 
        	{
                return "";
            }
            if (!element.parentNode || textArea === element) 
            {
                return "";
            }
            if (element.id) 
            {
                return "//*[@id='" + element.id + "']";
            }
            var arrSameElement = [].filter.call(element.parentNode.childNodes, function (node) { return node.nodeName === element.nodeName; });
            var parentPath = this.__getXPathByElement(element.parentNode, textArea);
            var indexString = arrSameElement.length > 1 ? "[" + (Array.from(arrSameElement).indexOf(element) + 1) + "]": "";
            var retString = parentPath + "/" +  element.nodeName.toLowerCase() + indexString;
            return retString;
        };
        
        this.__selectPathHandler = function(element,path,name,event)
        {
        	try 
        	{
        		var doc = this.__nsEditor.__getDocument();
        		var textArea = this.__nsEditor.__getTextArea();
                var pathElements = doc.evaluate(path,textArea, null, XPathResult.ANY_TYPE, null);
                var selectedElement = pathElements.iterateNext();
                if (selectedElement) 
                {
                	this.selection.selectElement(selectedElement);
                    return;
                }
            }
            catch (error) 
            { 
            }
            this.selection.selectElement(element);
            return;
        };
		
		this.__getWordCount = function()
		{
			var wordcount = 0;
			var html = this.__nsEditor.__getHtmlFromTextArea() || "";
			if(html.replace(/\s*<[^>]*?>\s*/g, '') !== '') 
			{
	            if (html.trim() !== "") 
	            {
	            	//remove inline tags without adding spaces
	            	html = html.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '');
	            	//replace adjacent tags with possible space between with a space
	            	html = html.replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ');
	            	//remove any singular tags
	                html = html.replace(/(<[^>]*?>)/ig, '');
	                //condense spacing
	                html = html.replace(/\s+/ig, ' ');
	                //count remaining non-space strings
	                wordcount = html.match(/\S+/g).length; 
	            }
	        }
			return wordcount;
		};
		
		this.__getCharCount = function()
		{
			var text = this.__nsEditor.__getTextFromTextArea() || "";
			text = text.replace(/(\r\n|\n|\r)/gm,"").replace(/^\s+/g,' ').replace(/\s+$/g, ' ');
			text = this.__excludeSpace ? text.replace(this.editorUtil.SPACE_REG_EXP, "") : text;
			var charcount = text.length;
			return charcount;
		};
		
		NSEditor.prototype.getWordCount = function()
		{
			var objFooterComp = this.__pluginsInstances["footercomp"].instance;
			return objFooterComp.__getWordCount();
		};
		
		NSEditor.prototype.getCharCount = function()
		{
			var objFooterComp = this.__pluginsInstances["footercomp"].instance;
			return objFooterComp.__getCharCount();
		};
		
	};
	
	NSEditor.prototype.registerPlugin("footercomp",NSFooterComp);
	
	return NSFooterComp;
})();
nsModuleExport(this,"NSFooterComp",NSFooterComp);  var NSElementResizer = (function()
{
	var NSElementResizer = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		this.__config = {};
		
		this.__container = null;
		this.__compTopLeft = null;
		this.__compTopRight = null;
		this.__compBottomLeft = null;
		this.__compBottomRight = null;
		this.__compSize = null;
		this.__doc = null;
		this.__win = null;
		this.__textArea = null;
		
		this.__isElementResized = false;
        this.__isShown = false;
        this.__element = null;
        this.__objResizer = {};
        this.__resizerRef = null;
		
		
		this.setSettings = function()
		{
			var setting = this.__nsEditor.__setting.elementResizer;
			if(!setting)
			{
				setting = {};
			}
			this.__config = {
								resizableElements: setting["resizableElements"] || "img, iframe",//"img, table, iframe"
								enableShowSize: this.util.isUndefinedOrNull(setting["enableShowSize"]) ? true : Boolean.parse(setting["enableShowSize"]),
								hideSizeInterval: setting["hideSizeInterval"] || 1000,
								sizeLabelFunction: setting["sizeLabelFunction"] ? this.util.getFunction(setting["sizeLabelFunction"]) : null,
								minWidth: setting["minWidth"] || 50,
								minHeight: setting["minHeight"] || 50,
						    };
		};
		
		this.initialize = function()
		{
		};
		
		this.componentsInitialized = function()
		{
			this.__doc = this.__nsEditor.__getDocument();
			this.__win = this.__nsEditor.__getWindow();
			this.__textArea = this.__nsEditor.__getTextArea();
			this.__createComponents();
			this.__nsEditor.__listenInternalEvent("change",this.__changeHandler.bind(this));
			this.__nsEditor.__listenInternalEvent("changePlace",this.__addListeners.bind(this));
			this.__nsEditor.__listenInternalEvent("readonly",this.__readonlyHandler.bind(this));
			this.__nsEditor.__listenInternalEvent("hideResizer",this.__hide.bind(this));
			this.__nsEditor.__listenInternalEvent("maximized",this.__fullScreenHandler);
			this.__addListeners();
			this.__changeHandler();
		};
		
		this.resized = function(event)
		{
			
		};
		
		this.destroy = function()
		{
		};
		
		this.__createComponents = function()
		{
			if(!this.__container)
			{
				this.__container = this.util.createElement("div",null,"nsElemEditorResizer",this.__doc);
				this.__compTopLeft = this.__createResizer("nsEditorResizerTopLeft");
				this.__compTopRight = this.__createResizer("nsEditorResizerTopRight");
				this.__compBottomLeft = this.__createResizer("nsEditorResizerBottomLeft");
				this.__compBottomRight = this.__createResizer("nsEditorResizerBottomRight");
				if(this.__config.enableShowSize)
				{
					this.__compSize = this.util.createElement("span",null,"nsEditorResizerSize",this.__doc);
					this.__container.appendChild(this.__compSize);
				}
			}
		};
		
		this.__createResizer = function(cssClass)
		{
			var comp = this.util.createElement("div",null,"nsEditorResizerComp " + cssClass,this.__doc);
			this.util.addEvent(comp,"mousedown touchstart",this.__resizeClickHandler.bind(this,comp));
			this.__container.appendChild(comp);
			return comp;
		};
		
		this.__addListeners = function(event)
		{
			this.__nsEditor.__listenInternalEvent("keydown", this.__keydownHandler.bind(this));
			this.__nsEditor.__listenInternalEvent("resize", this.__updateCompSize.bind(this));
			this.__nsEditor.__listenInternalEvent("mouseup keydown touchend",this.__clickOutsideHandler.bind(this));
			this.util.addEvent([this.__win,this.__textArea],"scroll",this.__scrollHandler.bind(this));
		};
		
		this.__addListenerToElement = function(element,type)
		{
			if(element)
			{
				this.util.addEvent(element,"click",this.__elementClickHandler.bind(this,element,type));
				this.util.addEvent(element,"mousedown",this.__elementMouseDownHandler.bind(this,element,type));
				this.util.addEvent(element,"dragstart",this.__hide.bind(this));
			}
		};
		
		this.__elementClickHandler = function(element,type,event)
		{
			if (this.__element !== element || !this.__isShown) 
			{
				event = this.util.getEvent(event);
				event.stopImmediatePropagation();
                this.__element = element;
                this.__show();
                if (type == "img" && !this.__element.complete)
                {
                	this.util.addEvent(this.__element,"load",this.__updateCompSize);
                }
            }
		};
		
		this.__elementMouseDownHandler = function(element,type,event)
		{
			if(this.__nsEditor.__browserDetail.isMSIE && type == "img")
			{
				event = this.util.getEvent(event);
				event.preventDefault();
			}
		};
		
		this.__resizeClickHandler = function(compResier,event)
		{
			if (this.__element && this.__element.parentNode) 
			{
				event = this.util.getEvent(event);
				event.preventDefault();
				event.stopImmediatePropagation();
				this.__isElementResized = true;
				this.__objResizer.resizer = compResier;
				this.__objResizer.width = this.__element.offsetWidth;
				this.__objResizer.height = this.__element.offsetHeight;
				this.__objResizer.ratio = this.__objResizer.width / this.__objResizer.height;
				this.__objResizer.startX = event.clientX;
				this.__objResizer.startY = event.clientY;
				this.__nsEditor.__dispatchInternalEvent("hidePopup");
				this.__resizerRef = this.__resizeHandler.bind(this); 
				this.__nsEditor.__listenInternalEvent("mousemove touchmove", this.__resizerRef);
	        }
			else
			{
				this.__hide();
			}
		};
		
		this.__resizeHandler = function(event)
		{
			 if (this.__isElementResized && this.__element) 
			 {
				 event = this.util.getEvent(event);
				 event = event.orignalEvent;
				 event = this.util.getEvent(event)
				 event.stopImmediatePropagation();
				 var diffX = event.clientX - this.__objResizer.startX;
				 var diffY = event.clientY - this.__objResizer.startY;
				 var cssClass = this.__objResizer.resizer.className;
	             var newWidth = 0;
	             var newHeight = 0;
	             var isLeft = cssClass.match(/Left/);
	             var isTop = cssClass.match(/Top/);
	             var leftMul = isLeft ?  -1 : 1;
	             var topMul = isTop ?  -1 : 1;
	             var isImage = this.util.isElementOfType(this.__element,"img");
	             if(isImage)
	             {
	            	 if (diffX) 
	            	 {
	            		 newWidth = this.__objResizer.width + leftMul * diffX;
	            		 newHeight = Math.round(newWidth / this.__objResizer.ratio);
	                 }
	            	 else 
	            	 {
	            		 newHeight = this.__objResizer.height + topMul * diffY;
	            		 newWidth = Math.round(newHeight * this.__objResizer.ratio);
	                 }
	            	 var maxWidth = this.util.getInnerWidth(this.__textArea,this.__win);
	            	 if (newWidth > maxWidth) 
	            	 {
	            		 newWidth = maxWidth;
	            		 newHeight = Math.round(newWidth / this.__objResizer.ratio);
	            	 }
	             }
	             else
	             {
	            	 newWidth = this.__objResizer.width + leftMul * diffX;
	            	 newHeight = this.__objResizer.height + topMul * diffY;
	             }
	             if (newWidth > this.__config.minWidth) 
	             {
	            	 if (newWidth < this.__container.offsetWidth) 
	            	 {
	            		 this.__element.style.width = newWidth + "px";
	                 }
	                 else 
	                 {
	                	 this.__element.style.width = "100%";
	                 }
	             }
	             if (newHeight > this.__config.minHeight) 
	             {
	            	 this.__element.style.height = newHeight + "px";
	             }
	             this.__updateCompSize();
                 this.__updateSizeLabel(this.__element.offsetWidth,this.__element.offsetHeight);
			 }
		};
		
		this.__clickOutsideHandler = function(event)
		{
			//var eventDetail = event.detail;
			//console.log("In __clickOutsideHandler " + eventDetail.orignalEvent.type);
			if (this.__isShown) 
			{
                if (this.__isElementResized) 
                {
                	var event = this.util.getEvent(event);
                    //_this.jodit.unlock();
                    this.__isElementResized = false;
                    //this.jodit.setEditorValue();
                    event.stopImmediatePropagation();
                    this.__nsEditor.__removeInternalEvent("mousemove touchmove", this.__resizerRef);
                    this.__resizerRef = null;
                }
                else 
                {
                    this.__hide();
                }
            }
		};
		
		this.__changeHandler = function(event)
		{
			 if(this.__isShown) 
			 {
				 if (!this.__element || !this.__element.parentNode) 
				 {
					 this.__hide();
		         }
		         else 
		         {
		        	 this.__updateCompSize();
		         }
		     }
			 if(!this.__nsEditor.isRemoved() && !this.__nsEditor.__isSourceMode)
			 {
				 var arrElements = this.__textArea.querySelectorAll(this.__config.resizableElements);
				 for(var count = 0;count < arrElements.length;count++)
				 {
					 var element = arrElements[count];
					 var processed = Boolean.parse(element.getAttribute("ns-editor-processed"));
					 var type = element.tagName.toLowerCase();
					 if(!processed && (type == "img" || type == "table"))
				     {
						 element.setAttribute("ns-editor-processed",true);
						 this.__addListenerToElement(element,type);
				     }
				 }
			 }
		};
		
		this.__readonlyHandler = function(event)
		{
			var eventDetail = event.detail;
			if(eventDetail && eventDetail.isReadOnly)
			{
				this.__hide();
			}
		};
		
		this.__scrollHandler = function(event)
		{
			if (this.__isShown && !this.__isElementResized) 
			{
                this.__hide();
            }
		};
		
		this.__keydownHandler = function(event)
		{
			event = this.util.getEvent(event);
			var keyCode = event.which || event.keyCode;
			if(this.__isShown && keyCode === this.util.KEYCODE.DELETE && this.__element && !this.util.isElementOfType(this.__element,"table")) 
			{
				this.__deleteHandler(event);
	        }
		};
		
		this.__fullScreenHandler = function(event)
		{
			if(this.__isShown)
			{
				var zIndex = this.util.getStyleValue(this.__nsEditor.__divOuterContainer,"z-index");
				this.__container.style.zIndex = zIndex;
			}
		};
		
		this.__deleteHandler = function(event)
		{
			if(this.__element)
			{
				if(this.__element.parentNode)
				{
					this.__element.parentNode.removeChild(this.__element);
				}
	            this.__hide();
	            event.preventDefault();
			}
		};
		
		this.__updateCompSize = function()
		{
			if(this.__isShown && !this.__nsEditor.isRemoved())
			{
				if(this.__element && this.__container) 
				{
					var parent = this.__container.parentNode || this.__doc.documentElement;
	                var parentPos = this.editorUtil.getOffset(parent,true);
	                var elementPos = this.editorUtil.getOffset(this.__element,false);
	                var left = parseInt(this.__container.style.left || "0", 10);
	                var top = parseInt(this.__container.style.top || "0", 10);
	                var width = this.__container.offsetWidth;
	                var height = this.__container.offsetHeight;
	                var newTop = elementPos.top - 1 - parentPos.top;
	                var newLeft = elementPos.left - 1 - parentPos.left;
	                if (top !== newTop || left !== newLeft || width !== this.__element.offsetWidth || height !== this.__element.offsetHeight) 
	                {
	                	var style = {top: newTop, left: newLeft, width: this.__element.offsetWidth, height: this.__element.offsetHeight};
	                	/*console.log(parentPos);
	                	console.log(elementPos);
	                	console.log(style);*/
	                	this.util.css(this.__container,style);
	                	this.__nsEditor.__dispatchInternalEvent("changesize");
	                }
				}
			}
		};
		
		this.__updateSizeLabel = function(width,height)
		{
			if(this.__compSize)
			{
				if (width < this.__compSize.offsetWidth || height < this.__compSize.offsetHeight) 
				{
					this.__showHideSizeComp(false);
			    }
				else
				{
					this.__showHideSizeComp(true);
					var label = width + " x " + height;
					if(this.__config.sizeLabelFunction)
					{
						label = this.__config.sizeLabelFunction(width,height);
					}
					else
					{
						this.__compSize.textContent = label
					}
					var self = this;
					setTimeout(function(){ 
						self.__showHideSizeComp.call(self,false); 
					}, this.__config.hideSizeInterval);
				}
			}
		};
		
		this.__show = function()
		{
			if(!this.__isShown && this.editorUtil.isEditable())
			{
				this.__isShown = true;
				this.__nsEditor.__divBodyContainer.appendChild(this.__container);
				this.__updateCompSize();
			}
		};
		
		this.__hide = function()
		{
			this.__isElementResized = false;
	        this.__isShown = false;
	        this.__element = null;
	        if(this.__container.parentNode)
	        {
	        	this.__container.parentNode.removeChild(this.__container);
	        }
		};
		
		this.__showHideSizeComp = function(isShow)
		{
			if(this.__compSize)
			{
				this.__compSize.style.opacity = isShow ? "1" : "0";
			}
		};
		
	};
	
	NSEditor.prototype.registerPlugin("elementResizer",NSElementResizer);
	
	return NSElementResizer;
})();
nsModuleExport(this,"NSElementResizer",NSElementResizer);var NSTablePluggins = (function()
{
	var NSTablePluggins = function(nsEditor)
	{
		/*this.nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;*/
		this.__tblUtil = null;
		
		this.__objTables = {};
		this.__objUIFunc = null;
		
		this.__processedTableIDAttribute = "data-ns-editor-table-id";
		
		this.__rowSubMenu = [{key:"above",label:"Insert row above",toolTip:"Insert row above"},
							 {key:"below",label:"Insert row below",toolTip:"Insert row below"}];

		this.__columnSubMenu = [{key:"before",label:"Insert column before",toolTip:"Insert column before"},
					 			{key:"after",label:"Insert column after",toolTip:"Insert column after"}];
		
		this.__cellSubMenu = [{key:"mergeCells",label:"Merge cells",toolTip:"Merge cells"},
					  {key:"verticalSplit",label:"Vertical split",toolTip:"Vertical split"},
					  {key:"horizontalSplit",label:"Horizontal split",toolTip:"Horizontal split"}];
		
		this.__alignSubMenu = [{key:"top",label:"Top",toolTip:"Align Top"},
						  {key:"middle",label:"Middle",toolTip:"Align Middle"},
						  {key:"bottom",label:"Bottom",toolTip:"Align Bottom"},
						  {key:"normal",label:"Normal",toolTip:"Align Normal"},
						  {key:"left",label:"Left",toolTip:"Align Left"},
						  {key:"right",label:"Right",toolTip:"Align Right"},
						  {key:"center",label:"Center",toolTip:"Align Center"},
						  {key:"justify",label:"Justify",toolTip:"Align Justify"}];
		
		this.__removeSubMenu = [{key:"table",label:"Delete Table",toolTip:"Delete Table"},
							  {key:"row",label:"Delete Row",toolTip:"Delete Row"},
							  {key:"column",label:"Delete Column",toolTip:"Delete Column"},
							  {key:"cell",label:"Empty Cell",toolTip:"Empty Cell"}];
		
		this.__objMenu = null;
		
		this.CLASS_SELECTED_CELL = "nsEditorSelectedCell";
		
		this.initialize = function()
		{
			this.__objMenu = { remove: {html: "<i class=\"ns-icon ns-editor-trash\" aria-hidden=\"true\"></i>",toolTip:"Remove",subMenu:this.__removeSubMenu,subMenuClickHandler:this.__removeClickHandler.bind(this)},
							   row: {html: "<i class=\"ns-icon ns-editor-bars\" aria-hidden=\"true\"></i>",toolTip:"Row",subMenu:this.__rowSubMenu,subMenuClickHandler:this.__rowClickHandler.bind(this)},
							   column: {html: "<i class=\"ns-icon ns-editor-layout\" aria-hidden=\"true\"></i>",toolTip:"Column",subMenu:this.__columnSubMenu,subMenuClickHandler:this.__columnClickHandler.bind(this)},
							   cell: {html: "<i class=\"ns-icon ns-editor-square\" aria-hidden=\"true\"></i>",toolTip:"Cell",subMenu:this.__cellSubMenu,subMenuClickHandler:this.__cellClickHandler.bind(this)},
							   alignment: {html: "<i class=\"ns-icon ns-editor-align-left\" aria-hidden=\"true\"></i>",toolTip:"Alignment",subMenu:this.__alignSubMenu,subMenuClickHandler:this.__alignClickHandler.bind(this)},
							   header: {html: "<i class=\"ns-icon ns-editor-header\" aria-hidden=\"true\"></i>",toolTip:"Table Header",menuClickHandler:this.__headerClickHandler.bind(this)},
							 };
		};
		
		this.setSettings = function()
		{
			var tableSetting = this.nsEditor.__setting["tableSetting"];
			if(!tableSetting)
			{
				tableSetting = {};
			}
			var tableConfig = {};
			tableConfig = {
					enableColumnResize : this.util.isUndefinedOrNull(tableSetting["enableColumnResize"]) ? true : Boolean.parse(tableSetting["enableColumnResize"]),
			};
			this.nsEditor.__config["tableSetting"] = tableConfig;
		};
		
		this.componentsInitialized = function()
		{
			this.nsEditor.__listenInternalEvent("tableAdded", this.__initTable.bind(this));
			this.nsEditor.__listenInternalEvent("mousedown mouseup", this.__handleMouseEvents.bind(this));
			this.nsEditor.__listenInternalEvent("dblclick click", this.__handleClickEvents.bind(this));
			
			this.__tblUtil = new NSTableUtil(this.nsEditor.__getDocument(),this.nsEditor.__getWindow());
			this.__objUIFunc = this.nsEditor.__getUtilInstance("uiFunc","tablePluggins",this.name,this,null);
		};
		
		this.resized = function(event)
		{
			
		};
		
		this.destroy = function()
		{
			
		};
		
		this.getSelectedCells = function(table)
		{
			var arrCells = null;
			if(table)
			{
				arrCells = table.querySelectorAll("." + this.CLASS_SELECTED_CELL);
			}
			else
			{
				var textArea = this.nsEditor.__getTextArea();
				arrCells = textArea.querySelectorAll("." + this.CLASS_SELECTED_CELL);
			}
			return arrCells; 
		};
		
		this.__initTable = function(event)
		{
			if(this.editorUtil.isEditable())
			{
				if(event.detail && event.detail.table)
				{
					var table = event.detail.table;
					if(!table.hasAttribute(this.__processedTableIDAttribute))
					{
						var id = "compNSEditorTable" + this.util.getUniqueId();
						table.setAttribute(this.__processedTableIDAttribute,id);
						var resizableTable = this.__createResizableTable(table);
						var popUp = this.__createPopup(table);
						this.__objTables[id] = {table: table,resizableTable: resizableTable,popUp: popUp};
					}
				}
			}
		};
		
		this.__handleMouseEvents = function(event)
		{
			var item = event.detail;
			var element = item.element;
			var parentElement = item.parentElement;
			var orignalEvent = item.orignalEvent;
			var cell = this.editorUtil.isCell(element) ? element : (this.editorUtil.isCell(parentElement) ? parentElement : null);
			if(cell)
			{
				var table = this.util.findParent(cell,"TABLE");
				var id = table.getAttribute(this.__processedTableIDAttribute);
				if(id)
				{
					var popUp = this.__objTables[id].popUp;
					if(popUp)
					{
						switch(orignalEvent.type)
						{
							case "mousedown":
								popUp.hide();
							break;
							case "mouseup":
								this.__highlightCell(cell,table);
								this.selection.saveSelection();
								/*var offset = {left: -40,top: 17}
								popUp.show(cell,orignalEvent,offset);*/
								
								popUp.show(cell,orignalEvent);
							break;
						}
					}
				}
			}
		};
		
		this.__handleClickEvents = function(event)
		{
			
		};
		
		this.__clearTableSelectedCells = function(table)
		{
			var arrCells = this.getSelectedCells(table);
			for(var count = 0;count < arrCells.length;count++)
			{
				this.util.removeStyleClass(arrCells[count],this.CLASS_SELECTED_CELL);
			}
		};
		
		this.__highlightCell = function(cell,table)
		{
			var textArea = this.nsEditor.__getTextArea();
			this.__clearTableSelectedCells();
			if(cell)
			{
				this.util.addStyleClass(cell,this.CLASS_SELECTED_CELL);
			}
		};
		
		this.__createResizableTable = function(table)
		{
			var setting = {getRowCallback: this.__getRow.bind(this)};
			var nsResizableTable = new NSResizableTable(table,setting,this.nsEditor.__getDocument());
			return nsResizableTable;
		};
		
		this.__createPopup = function(table)
		{
			var setting = {title: "Edit Table",enableArrow: true,contentCallback: this.__getPopUpBody.bind(this,table)};
			var inlinePopUp = this.nsEditor.__getUtilInstance("inlinePopup","tablePopUp",this.name,this,setting);
			this.util.addEvent(table,"click",this.__tblClickHandler.bind(this));
			return inlinePopUp;
		};
		
		this.__tblClickHandler = function(event)
		{
			this.editorUtil.stopEvent(event);
		};
		
		this.__getRow = function(table,objResizableTable)
		{
			if(table && table.tBodies && table.tBodies.length > 0 && table.tBodies[0].rows && table.tBodies[0].rows.length > 0)
			{
				return table.tBodies[0].rows[0];
			}
			return null;
		};
		
		this.__getPopUpBody = function(table,container,objPopup,objTablePluggin)
		{
			var index = 0;
			for(var key in this.__objMenu)
			{
				var item = this.__objMenu[key];
				var arrSubMenu = null;
				if(index % 3 == 0)
				{
					var compSep = objPopup.getHorizontalSeparator();
					container.appendChild(compSep);
				}
				if(item.subMenu && item.subMenu.length)
				{
					arrSubMenu = this.__getSubMenu(table,objPopup,item.subMenu,item,key);
				}
				var menu = this.__createMenuItem(table,objPopup,item.html,item.toolTip,arrSubMenu,item,key);
				container.appendChild(menu);
				index++;
			}
		};
		
		this.__createMenuItem = function(table,objPopup,contentHtml,tooltip,subMenu,item,menuName)
		{
			var handler = (subMenu && subMenu.length) ? null : this.__menuClickHandler.bind(this,table,item,null,menuName);
			var menu = objPopup.getMenuItem(null,null,contentHtml,tooltip,subMenu,handler);
			return menu;
		};
		
		this.__getSubMenu = function(table,objPopup,arrSubMenu,parentItem,parentMenu)
		{
			var arrRet = [];
			for(var count = 0;count < arrSubMenu.length;count++)
			{
				var item = arrSubMenu[count];
				var handler = this.__menuClickHandler.bind(this,table,item,parentItem,parentMenu);
				var anchor = objPopup.getSubMenuItem(null,null,item.label,item.toolTip,handler);
				arrRet.push(anchor);
			}
			return arrRet;
		};
		
		this.__menuClickHandler = function(table,item,parentItem,parentMenuName,event)
		{
			var textArea = this.nsEditor.__getTextArea();
			event = this.util.getEvent(event);
			var self = this;
			/*var cell = this.editorUtil.isCell(event.target) ? event.target : this.util.findParentByCallback(event.target,function(node){
				node && self.editorUtil.isCell(node);
			},textArea);*/
			var arrCells = this.getSelectedCells(table);
			if(arrCells && arrCells.length)
			{
				var cell = arrCells[0];
				var row = this.util.findParent(cell,"TR");
				var rowIndex = row.rowIndex;
				var cellIndex = cell.cellIndex;
				this.selection.restoreSelection();
				if(parentItem && parentItem.subMenuClickHandler)
				{
					parentItem.subMenuClickHandler(arrCells,row,table,cellIndex,rowIndex,item,parentItem,parentMenuName,event);
				}
				else if(item && item.menuClickHandler)
				{
					item.menuClickHandler(arrCells,row,table,cellIndex,rowIndex,item,parentMenuName,event);
				}
			}
			else
			{
				this.util.warning("NSEditor","Selected Cell is not found in Editor");
			}
			
		};
		
		this.__rowClickHandler = function(arrCells,row,table,cellIndex,rowIndex,item,parentItem,parentMenuName,event)
		{
			var self = this;
			var callback = function(newCell,newRow,paramTable,colIndex,rowReference,isInsertBelow)
			{
				self.util.removeStyleClass(newCell,self.CLASS_SELECTED_CELL);
			};
			switch(item.key)
			{
				case "above":
					this.__tblUtil.insertRow(table,row,false,callback); 
				break;
				case "below":
					this.__tblUtil.insertRow(table,row,true,callback);
				break;
			}
			this.__refreshIndexInTable(table);
		};
		
		this.__columnClickHandler = function(arrCells,row,table,cellIndex,rowIndex,item,parentItem,parentMenuName,event)
		{
			var self = this;
			var callback = function(newCell,paramTable,refIndex,isInsertAfter)
			{
				self.util.removeStyleClass(newCell,self.CLASS_SELECTED_CELL);
			};
			switch(item.key)
			{
				case "before":
					this.__tblUtil.insertColumn(table,cellIndex,false,callback); 
				break;
				case "after":
					this.__tblUtil.insertColumn(table,cellIndex,true,callback); 
				break;
			}
			this.__refreshIndexInTable(table);
		};
		
		this.__cellClickHandler = function(arrCells,row,table,cellIndex,rowIndex,item,parentItem,parentMenuName,event)
		{
			switch(item.key)
			{
				case "mergeCells":
					this.__tblUtil.mergeSelectedCells(arrCells,table);
				break;
				case "verticalSplit":
					this.__tblUtil.splitCellsVertical(arrCells,table);
				break;
				case "horizontalSplit":
					this.__tblUtil.splitCellsHorizontal(arrCells,table);
				break;
			}
			this.__clearTableSelectedCells(table);
			this.__refreshIndexInTable(table);
		};
		
		this.__alignClickHandler = function(arrCells,row,table,cellIndex,rowIndex,item,parentItem,parentMenuName,event)
		{			
			switch(item.key)
			{
				case "top":
				case "middle":
				case "bottom":
				case "normal":
					this.__objUIFunc.setVerticalAlignForNodes(item.key,arrCells);
				break;
				case "left":
				case "right":
				case "center":
				case "justify":
					this.__objUIFunc.setHorizontalAlignForNodes(item.key,arrCells);
				break;
			}
		};
		
		this.__removeClickHandler = function(arrCells,row,table,cellIndex,rowIndex,item,parentItem,parentMenuName,event)
		{
			switch(item.key)
			{
				case "table":
					this.editorUtil.removeNode(table);
				break;
				case "row":
					this.__tblUtil.removeRow(table,rowIndex);
					this.__refreshIndexInTable(table);
				break;
				case "column":
					this.__tblUtil.removeColumn(table,cellIndex);
					this.__refreshIndexInTable(table);
				break;
				case "cell":
					for(var cellIndex = 0;cellIndex < arrCells.length;cellIndex++)
					{
						var cell = arrCells[cellIndex];
						this.util.removeAllChildren(cell);
					}
				break;
			}
		};
		
		this.__headerClickHandler = function(arrCells,row,table,cellIndex,rowIndex,item,menuName,event)
		{
			
		};
		
		this.__refreshIndexInTable = function(table)
		{
			NSEditorTable.setIndexInTable(table);
		};
		
	};
	
	NSEditor.prototype.registerPlugin("tablePluggins",NSTablePluggins);
	
	return NSTablePluggins;
})();
nsModuleExport(this,"NSTablePluggins",NSTablePluggins);var NSEditorSearchReplace = (function()
{
	var NSEditorSearchReplace = function(nsEditor)
	{
		this.__nsEditor = nsEditor;
		this.util = nsEditor.util;
		this.editorUtil = nsEditor.editorUtil;
		
		this.__refsSearch = {};
		this.__selSearchElement = null;
		
		this.setSettings = function()
		{
			var self = this;
			this.__nsEditor.__toolBarButton["searchReplace"] ={html:"<i class='ns-icon ns-editor-search' aria-hidden='true'></i>",tooltip:"Search Or Replace",showAsMenu: true,
												   			isDropdown:true,
												   			dataSource:[{value:"Search",html:"<span>Search</span>",tooltip:"Search",shortKey:"ctrl+f",
														   				  click:function(item,key,event)
																		  {
																			  self.__searchClickHandler.call(self,event);
																		  }},
																		  {value:"Replace",html:"<span>Replace</span>",tooltip:"Replace",shortKey:"ctrl+h",
																		  click:function(item,key,event)
																		  {
																			  self.__replaceClickHandler.call(self,event);
																		  }},
																		],
										   					  checkDisability: function(toolBarKey,toolBarItem,item,itemKey,isDefaultDisabled)
															  {
																  if(itemKey === "viewSourceCode")
																  {
																	  return true;
																  }
																  return false;
															   }
															};
		};
		
		this.initialize = function()
		{
		};
		
		this.componentsInitialized = function()
		{
			var self = this;
			this.__nsEditor.__listenInternalEvent("stickyChanged",this.__applySearchSticky.bind(this));
			this.__nsEditor.__listenInternalEvent("keydown mousedown",function(event){
				if(self.__isSearchCompVisible()) 
				{
					self.__selSearchElement = self.selection.getElementUnderCursor();
					self.__updateSearchCount();
				}
			});
		};
		
		this.resized = function(event)
		{
			
		};
		
		this.destroy = function()
		{
			if(this.__nsTablePicker)
			{
				this.__nsTablePicker.remove();
			}
		};
		
		this.__searchClickHandler = function(event)
		{
			this.__createSearchComponents();
			this.__showSearchComp();
			this.__hideReplaceComp();
		};
		
		this.__replaceClickHandler = function(event)
		{
			this.__searchClickHandler();
			this.__showReplaceComp();
		};
		
		this.__createSearchComponents = function()
		{
			if(!this.__refsSearch.wrapper || !this.__refsSearch.wrapper.parentNode)
			{
				var self = this;
				this.__setSearchContainer();
				this.__nsEditor.__divTextAreaContainer.appendChild(this.__refsSearch.wrapper);
				this.util.addEvent(this.__refsSearch.close,"click",this.__hideSearchComp.bind(this));
				var prevNextClick = this.__prevNextClickHandler.bind(this);
				this.util.addEvent([this.__refsSearch.previous,this.__refsSearch.next],"click",prevNextClick);
				this.util.addEvent(this.__refsSearch.moreoption,"click",this.__toggleReplaceComp.bind(this));
				this.util.addEvent(this.__refsSearch.replaceButton,"click",this.__btnReplaceClickHandler.bind(this));
				this.util.addEvent(this.__refsSearch.replaceAllButton,"click",this.__btnReplaceAllClickHandler.bind(this));
				this.util.addEvent(this.__refsSearch.search,"keydown",this.util.debounce(function(event)
				{
					event = self.util.getEvent(event);
					switch (event.key) 
					{
						case self.util.KEYCODE.ENTER:
						{
							self.editorUtil.stopEvent(event);
							/*if (editor.e.fire('searchNext')) {
								this.close();
							}*/
						}
						break;
						default:
						{
							self.__updateSearchCount();
						}
					}
				},10));
			}
		};
		
		this.__setSearchContainer = function()
		{
			var html = "<div data-ns-ref=\"wrapper\" class=\"nsEditorSearchWrapper\">\r\n" + 
					"	 <div class=\"nsEditorSearchContainer\">\r\n" + 
					"		<div class=\"nsEditorSearchContent\">\r\n" + 
					"			<div class=\"nsEditorSearchInputCountWrapper\">\r\n" + 
					"				<table cellpadding=\"0\" cellspacing=\"0\" class=\"nsEditorSearchInputCountOuterContainer\">\r\n" + 
					"					<tbody>\r\n" + 
					"						<tr>\r\n" + 
					"							<td class=\"nsEditorSearchInputContainer\">\r\n" + 
					"								<input data-ns-ref=\"search\" type=\"text\" spellcheck=\"false\" class=\"nsEditorSearchInput\" placeholder=\"Find\">\r\n" + 
					"							</td>\r\n" + 
					"							<td class=\"nsEditorSearchCountContainer\">\r\n" + 
					"								<span data-ns-ref=\"count\" class=\"nsEditorSearchCount\">0 of 0</span>\r\n" + 
					"							</td>\r\n" + 
					"						</tr>\r\n" + 
					"					</tbody>\r\n" + 
					"				</table>\r\n" + 
					"			</div>\r\n" + 
					"			<div class=\"nsEditorSearchButtonContainer\">\r\n" + 
					"				<button data-ns-ref=\"next\" type=\"button\" tabindex=\"-1\" class=\"nsEditorSearchButton nsEditorSearchButtonNext\">\r\n" + 
					"					<span class=\"nsEditorSearchButtonIconWrap\">" +
					"						<i class=\"ns-icon ns-editor-next\" aria-hidden=\"true\"></i>\r\n" + 
					"					</span>\r\n" + 
					"				</button>\r\n" +
					"				<button data-ns-ref=\"previous\" type=\"button\" tabindex=\"-1\" class=\"nsEditorSearchButton nsEditorSearchButtonPrevious\">\r\n" + 
					"					<span class=\"nsEditorSearchButtonIconWrap\">\r\n" + 
					"						<i class=\"ns-icon ns-editor-prev\" aria-hidden=\"true\"></i>\r\n" +
					"					</span>\r\n" + 
					"				</button>\r\n" + 
					"			</div>\r\n" +
					"			<div class=\"nsEditorSearchButtonContainer\">\r\n" + 
					"				<button data-ns-ref=\"moreoption\" type=\"button\" tabindex=\"-1\" class=\"nsEditorSearchButton nsEditorSearchButtonMoreOption\">\r\n" + 
					"					<span class=\"nsEditorSearchButtonIconWrap\">\r\n" + 
					"						<i data-ns-ref=\"moreoptionicon\" class=\"ns-icon ns-editor-expand-bold\" aria-hidden=\"true\"></i>\r\n" +
					"					</span>\r\n" + 
					"				</button>\r\n" + 
					"			</div>\r\n" + 
					"			<div class=\"nsEditorSearchButtonContainer\">\r\n" + 
					"				<button data-ns-ref=\"close\" type=\"button\" tabindex=\"-1\" class=\"nsEditorSearchButton nsEditorSearchButtonClose\">\r\n" + 
					"					<span class=\"nsEditorSearchButtonIconWrap\">\r\n" + 
					"						<i class=\"ns-icon ns-editor-close-bold\" aria-hidden=\"true\"></i>\r\n" +
					"					</span>\r\n" + 
					"				</button>\r\n" + 
					"			</div>\r\n" + 
					"		</div>\r\n" + 
					"   	<div data-ns-ref=\"replaceWrapper\" class=\"nsEditorReplaceContainer\">\r\n" + 
					"			<input data-ns-ref=\"replaceInput\" class=\"nsEditorReplaceInput\" placeholder=\"Replace\" aria-label=\"Replace Field\">\r\n" + 
					"			<div class=\"nsEditorReplaceButtonWrapper\">\r\n" + 
					"				<span class=\"nsEditorReplaceButtonContainer\" tabindex=\"-1\">\r\n" + 
					"					<button data-ns-ref=\"replaceButton\" class=\"nsEditorReplaceButton nsEditorReplaceButtonReplace\">Replace</button>\r\n" + 
					"				</span>\r\n" + 
					"				<span class=\"nsEditorReplaceButtonContainer\" tabindex=\"-1\">\r\n" + 
					"					<button data-ns-ref=\"replaceAllButton\" class=\"nsEditorReplaceButton nsEditorReplaceButtonReplaceAll\">Replace All</button>\r\n" + 
					"				</span>\r\n" + 
					"			</div>\r\n" + 
					"		</div>"
					"	</div>\r\n" +
					"</div>";
			
			this.__refsSearch = this.util.getReferenceFromHtml(html).refs;
			return this.__refsSearch.wrapper;
		};
		
		this.__prevNextClickHandler = function(event)
		{
			if(this.__refsSearch.search.value && this.__refsSearch.search.value.trim().length)
			{
				this.editorUtil.stopEvent(event);
				var textArea = this.__nsEditor.__getTextArea();
				var searchElement = this.selection.getElementUnderCursor();
				var isNext = event.currentTarget == this.__refsSearch.next;
				this.__searchTextSelect({startNode: searchElement || textArea.firstChild,text: this.__refsSearch.search.value,next:isNext});
			}
		};
		
		this.__btnReplaceClickHandler = function(event)
		{
			if(this.__refsSearch.replaceInput.value && this.__refsSearch.replaceInput.value.trim().length && 
					this.__refsSearch.search.value && this.__refsSearch.search.value.trim().length)
			{
				this.editorUtil.stopEvent(event);
				var textArea = this.__nsEditor.__getTextArea();
				var searchElement = this.selection.getElementUnderCursor();
				this.__searchTextReplace({startNode: searchElement || textArea.firstChild,text: this.__refsSearch.search.value,replaceText:this.__refsSearch.replaceInput.value});
			}
		};
		
		this.__btnReplaceAllClickHandler = function(event)
		{
			if(this.__refsSearch.replaceInput.value && this.__refsSearch.replaceInput.value.trim().length && 
					this.__refsSearch.search.value && this.__refsSearch.search.value.trim().length)
			{
				this.editorUtil.stopEvent(event);
				var textArea = this.__nsEditor.__getTextArea();
				var searchElement = this.selection.getElementUnderCursor();
				searchElement = searchElement || textArea.firstChild;
				while(this.__searchTextReplace({startNode: searchElement,text: this.__refsSearch.search.value,replaceText:this.__refsSearch.replaceInput.value}))
				{
					searchElement = this.selection.getElementUnderCursor();
				}
			}
		};
		
		this.__showSearchComp = function()
		{
			if(!this.__isSearchCompVisible())
			{
				this.__nsEditor.__dispatchInternalEvent("hideAllPopup",{container: this.__refsSearch.wrapper},{container: this.__refsSearch.wrapper});
				this.util.addStyleClass(this.__refsSearch.wrapper,"nsEditorSearchVisible");
				this.__applySearchSticky();
				this.__selSearchElement = this.selection.getElementUnderCursor();
				var selectedText = this.selection.getSelection() ? this.selection.getSelection().toString() : "";
				if (selectedText) 
				{
					this.__refsSearch.search.value = selectedText;
				}
				else
				{
					this.__refsSearch.search.value = "";
				}
				this.__updateSearchCount();
				selectedText ? this.__refsSearch.search.select() : this.__refsSearch.search.focus();
			}
		};
		
		this.__hideSearchComp = function(event)
		{
			this.util.removeStyleClass(this.__refsSearch.wrapper,"nsEditorSearchVisible");
		};
		
		this.__isSearchCompVisible = function()
		{
			return (this.__refsSearch.wrapper && this.__refsSearch.wrapper.parentNode && this.util.hasStyleClass(this.__refsSearch.wrapper,"nsEditorSearchVisible"));
		};
		
		this.__showReplaceComp = function(event)
		{
			if(!this.__isReplaceCompVisible())
			{
				this.__refsSearch.replaceInput.value = "";
				this.util.addStyleClass(this.__refsSearch.replaceWrapper,"nsEditorReplaceContainerVisible");
				this.util.addStyleClass(this.__refsSearch.moreoptionicon,"ns-editor-collapse-bold");
				this.util.removeStyleClass(this.__refsSearch.moreoptionicon,"ns-editor-expand-bold"); 
			}
		};
		
		this.__hideReplaceComp = function(event)
		{
			this.util.removeStyleClass(this.__refsSearch.replaceWrapper,"nsEditorReplaceContainerVisible");
			this.util.removeStyleClass(this.__refsSearch.moreoptionicon,"ns-editor-collapse-bold");
			this.util.addStyleClass(this.__refsSearch.moreoptionicon,"ns-editor-expand-bold"); 
		};
		
		this.__toggleReplaceComp = function()
		{
			return this.__isReplaceCompVisible() ? this.__hideReplaceComp() : this.__showReplaceComp();
		};
		
		this.__isReplaceCompVisible = function()
		{
			return (this.__refsSearch.replaceWrapper && this.__refsSearch.replaceWrapper.parentNode && this.util.hasStyleClass(this.__refsSearch.replaceWrapper,"nsEditorReplaceContainerVisible"));
		};
		
		
		this.__updateSearchCount = function()
		{
			if(this.__isSearchCompVisible())
			{
				this.__refsSearch.search.value.length ? this.util.addStyleClass(this.__refsSearch.count,"nsEditorSearchCountVisible") : this.util.removeStyleClass(this.__refsSearch.count,"nsEditorSearchCountVisible");
				var objCount = this.__getTextCounts(this.__refsSearch.search.value);
				this.__refsSearch.count.innerHTML = objCount.index + "/" + objCount.count;
			}
		};
		
		this.__applySearchSticky = function()
		{
			var isSticky = this.__nsEditor.__toolBar.isToolbarSticky();
			if(this.__isSearchCompVisible())
			{
				var css = {};
				if(isSticky)
				{
					this.util.addStyleClass(this.__refsSearch.wrapper,"nsEditorSearchWrapperSticky");
					var rect = this.__nsEditor.__toolBar.__divToolBarContainer.getBoundingClientRect();
					//css = {top: rect.top + rect.height,left: rect.left + rect.width};
					css = {top: rect.top + rect.height,right: rect.left};
				}
				else
				{
					this.util.removeStyleClass(this.__refsSearch.wrapper,"nsEditorSearchWrapperSticky");
					css = {top: "",left: "",right: ""};
				}
				this.util.css(this.__refsSearch.wrapper,css);
			}
		};
		
		//calcCounts
		this.__getTextCounts = function(text)
		{
			var isInArray = function(paramBound,paramArrBound)
			{
				for(var count = 0;count < paramArrBound.length;count++)
				{
					var tempBound = paramArrBound[count];
					if(tempBound.startContainer == paramBound.startContainer && tempBound.endContainer == paramBound.endContainer &&
						tempBound.startOffset == paramBound.startOffset && tempBound.endOffset == paramBound.endOffset)
					{
						return true;
					}
				}
				return false;
			};
			var objRet = {index: 0,count: 0};
			var doc = this.__nsEditor.__getDocument();
			var textArea = this.__nsEditor.__getTextArea();
			var range = this.selection.getRange();
			var startNode = textArea.firstChild;
			var arrBound = [];
			var bound = null;
			while(startNode && text.length) 
			{
				bound = this.__searchText({startNode: startNode,text: text,next: true,deep: 0,range: (bound || doc.createRange())});
				if(bound)
				{
					if (isInArray(bound,arrBound)) 
					{
						break;
					}
					arrBound.push(bound);
					startNode = bound.startContainer;
					objRet.count++;
					if (range && isInArray(range, [bound])) 
					{
						objRet.index = objRet.count;
					}
				}
				else 
				{
					startNode = null;
				}
			}
			return objRet;
		};
		
		//objParam has properties startNode,text,next,deep,range
		//find
		this.__searchText = function(objParam)
		{
			if (objParam.startNode && objParam.text.length) 
			{
				var textArea = this.__nsEditor.__getTextArea();
				objParam.sentence = "";
				objParam.bound = {startContainer: null,startOffset: null,endContainer: null,endOffset: null};
				var siblingProperty = objParam.next ? "nextSibling" : "previousSibling";
				var childProperty = objParam.next ? "firstChild" : "lastChild";
				var self = this;
				this.util.findNodeWithCurrent(objParam.startNode,function(node) 
				{
					if(node && self.__isSearchNode.call(self,objParam,node))
					{
						return true;
					}
					return false;
	            },textArea,siblingProperty,childProperty);
				if (objParam.bound.startContainer && objParam.bound.endContainer) 
				{
					return objParam.bound;
				}
				if (!objParam.deep) 
				{
					this.__selSearchElement = objParam.next ? textArea.firstChild : textArea.lastChild;
					return this.__searchText({startNode: this.__selSearchElement,text: objParam.text,next: objParam.next,deep: objParam.deep + 1,range: objParam.range});
				}
			}
		};
		
		//objParam has properties text,next,deep,range,sentence,bound
		this.__isSearchNode = function(objParam,paramNode)
		{
			if (this.util.isTextNode(paramNode) && paramNode.nodeValue != null && paramNode.nodeValue.length)
			{
				var win = this.__nsEditor.__getWindow();
				var value = paramNode.nodeValue;
				if (!objParam.next && paramNode === objParam.range.startContainer) 
				{
					value = !objParam.deep ? value.substr(0, objParam.range.startOffset) : value.substr(objParam.range.endOffset);
				} 
				else if (objParam.next && paramNode === objParam.range.endContainer) 
				{
					value = !objParam.deep ? value.substr(objParam.range.endOffset) : value.substr(0, objParam.range.startOffset);
				}
				var tmpSentence = objParam.next ? objParam.sentence + value : value + objParam.sentence;
				var part = this.__searchSomePart(objParam.text,tmpSentence,objParam.next);
				if(part != false) 
				{
					var currentPart = this.__searchSomePart(objParam.text,value,objParam.next);
					if (currentPart === true) 
					{
						currentPart = this.editorUtil.trim(objParam.text);
					} 
					else if(currentPart === false) 
					{
						currentPart = this.__searchSomePart(value,objParam.text,objParam.next);
						if (currentPart === true) 
						{
							currentPart = this.editorUtil.trim(value);
						}
					}
					var currentPartIndex = this.__searchSomePartIndex(objParam.text,value,objParam.next) || 0;
					if(((objParam.next && !objParam.deep) || (!objParam.next && objParam.deep)) && paramNode.nodeValue.length - value.length > 0)
					{
						currentPartIndex += paramNode.nodeValue.length - value.length;
					}
					if (objParam.bound.startContainer == null) 
					{
						objParam.bound.startContainer = paramNode;
						objParam.bound.startOffset = currentPartIndex;
					}
					if (part !== true) 
					{
						objParam.sentence = tmpSentence;
					} 
					else 
					{
						objParam.bound.endContainer = paramNode;
						objParam.bound.endOffset = currentPartIndex;
						objParam.bound.endOffset += currentPart.length;
						return true;
					}
				}
				else
				{
					objParam.sentence = "";
					objParam.bound = {startContainer: null,startOffset: null,endContainer: null,endOffset: null};
				}
			}
			else if (this.editorUtil.isBlock(paramNode,win) && objParam.sentence != "") 
			{
				objParam.sentence = objParam.next ? objParam.sentence + " " : " " + objParam.sentence;
			}

			return false;
		};
		
		//objParam has properties startNode,text,next
		//findAndSelect
		this.__searchTextSelect = function(objParam)
		{
			var doc = this.__nsEditor.__getDocument();
			objParam.range = this.selection.getRange();
			objParam.deep = 0;
			var bound = this.__searchText(objParam);
			if (bound && bound.startContainer && bound.endContainer) 
			{
				var range = doc.createRange();
				try 
				{
					range.setStart(bound.startContainer,bound.startOffset);
					range.setEnd(bound.endContainer,bound.endOffset);
					this.selection.selectRange(range);
				} 
				catch (error) 
				{
					console.debug(error);
				}
				this.__scrollToNode(bound.startContainer);
				this.__selSearchElement = bound.startContainer;
				this.__updateSearchCount();
				return true;
			}
			return false;
		};
		
		//objParam has properties startNode,text,replaceText
		//findAndReplace
		this.__searchTextReplace = function(objParam)
		{
			var doc = this.__nsEditor.__getDocument();
			objParam.next = true;
			objParam.range = this.selection.getRange();
			objParam.deep = 0;
			var bound = this.__searchText(objParam);
			if (bound && bound.startContainer && bound.endContainer) 
			{
				var range = doc.createRange();
				try 
				{
					range.setStart(bound.startContainer,bound.startOffset);
					range.setEnd(bound.endContainer,bound.endOffset);
					range.deleteContents();
					var textNode = doc.createTextNode(objParam.replaceText);
					range.insertNode(textNode);
					this.selection.selectElement(textNode);
					this.__scrollToNode(textNode);
				} 
				catch (error) 
				{
					console.debug(error);
				}
				this.__updateSearchCount();
				return true;
			}
			return false;
		};
		
		this.__searchSomePart = function(text,sentence,start,getIndex)
		{
			start = this.util.isUndefinedOrNull(start) ? true : Boolean.parse(start);
			getIndex = Boolean.parse(getIndex);
			text = this.editorUtil.trim(text.toLowerCase());
			sentence = sentence.toLowerCase();

			var textIndex = start ? 0 : text.length - 1;
			var length = 0;
			var startAtIndex = null;
			var inc = start ? 1 : -1;
			var tmp = [];

			for (var count = (start ? 0 : sentence.length - 1); !this.util.isUndefined(sentence[count]);count += inc) 
			{
				var some = (text[textIndex] === sentence[count]);
				if (some || (startAtIndex != null && this.editorUtil.SPACE_REG_EXP.test(sentence[count]))) 
				{
					if (startAtIndex == null || !start) 
					{
						startAtIndex = count;
					}
					tmp.push(sentence[count]);
					if(some) 
					{
						length += 1;
						textIndex += inc;
					}
				} 
				else 
				{
					startAtIndex = null;
					tmp.length = 0;
					length = 0;
					textIndex = start ? 0 : text.length - 1;
				}

				if (length === text.length) 
				{
					return getIndex ? startAtIndex : true;
				}
			}
			if (getIndex) 
			{
	            return this.util.isUndefinedOrNull(startAtIndex) ? startAtIndex : false;
	        }
			if(tmp.length) 
			{
				return start ? tmp.join('') : tmp.reverse().join('');
			}
			return false;
		};
		
		this.__searchSomePartIndex = function(text,sentence,start)
		{
			start = this.util.isUndefinedOrNull(start) ? true : Boolean.parse(start);
	        return this.__searchSomePart(text,sentence,start,true);
		};
		
		this.__scrollToNode = function(node)
		{
			var textArea = this.__nsEditor.__getTextArea();
			var parent = this.editorUtil.getClosestElement(node,this.util.isElement,textArea);
			if (!parent) 
			{
				parent = this.util.findPrevNode(node,this.util.isElement,textArea);
			}
			if(parent && parent != textArea)
			{
				parent.scrollIntoView();
			}
		};
	};
	
	NSEditor.prototype.registerPlugin("searchReplace",NSEditorSearchReplace);
	
	return NSEditorSearchReplace;
})();
nsModuleExport(this,"NSEditorSearchReplace",NSEditorSearchReplace);